var map = {
	"./Greece.mp3": 590604,
	"./I’m.mp3": 399856,
	"./I’ve.mp3": 622868,
	"./Mavis.mp3": 517611,
	"./Paul.mp3": 891527,
	"./Steve.mp3": 639106,
	"./Sue.mp3": 513066,
	"./Sydney.mp3": 227233,
	"./a-2.mp3": 165759,
	"./a-3.mp3": 973146,
	"./a.mp3": 227170,
	"./a3.mp3": 280785,
	"./ab.mp3": 549180,
	"./abbreviate.mp3": 389014,
	"./abbreviation.mp3": 151817,
	"./ablaze.mp3": 752742,
	"./able.mp3": 35873,
	"./about.mp3": 874536,
	"./above.mp3": 548944,
	"./absolute.mp3": 508890,
	"./acceleration.mp3": 167505,
	"./accent.mp3": 918999,
	"./accept.mp3": 990777,
	"./acceptance.mp3": 874424,
	"./access.mp3": 493751,
	"./accessed.mp3": 994400,
	"./accident.mp3": 188002,
	"./accidental.mp3": 158773,
	"./accidentally.mp3": 303004,
	"./accidents.mp3": 976145,
	"./accommodate.mp3": 434544,
	"./accomodated.mp3": 896213,
	"./accomodating.mp3": 440386,
	"./accompanied.mp3": 241929,
	"./accompany.mp3": 576282,
	"./according.mp3": 345999,
	"./accordingly.mp3": 177366,
	"./accords.mp3": 969972,
	"./account.mp3": 555538,
	"./accumulate.mp3": 426191,
	"./accurate.mp3": 82359,
	"./accuse.mp3": 474945,
	"./ach.mp3": 346827,
	"./ache.mp3": 30848,
	"./achieve.mp3": 46482,
	"./acorn.mp3": 644760,
	"./acoustic.mp3": 892392,
	"./acrobat.mp3": 63245,
	"./acronym.mp3": 521268,
	"./acropolis.mp3": 689441,
	"./across.mp3": 887778,
	"./acted.mp3": 788192,
	"./acting.mp3": 348665,
	"./action.mp3": 313807,
	"./activate.mp3": 470818,
	"./active.mp3": 66307,
	"./actively.mp3": 799026,
	"./actors.mp3": 378023,
	"./actual.mp3": 963903,
	"./actually.mp3": 985894,
	"./acuity.mp3": 484226,
	"./acupuncture.mp3": 281836,
	"./acute.mp3": 187719,
	"./add.mp3": 558306,
	"./addition.mp3": 314041,
	"./address.mp3": 527255,
	"./addressed.mp3": 617792,
	"./addresses.mp3": 80387,
	"./addressing.mp3": 477145,
	"./adhere.mp3": 752728,
	"./adjective.mp3": 251926,
	"./adjust.mp3": 998788,
	"./admiration.mp3": 676073,
	"./admission.mp3": 987416,
	"./adorable.mp3": 540441,
	"./adorably.mp3": 184517,
	"./adoration.mp3": 321336,
	"./advance.mp3": 393901,
	"./advantageous.mp3": 681999,
	"./adventure.mp3": 308399,
	"./adventurous.mp3": 272381,
	"./adverb.mp3": 6681,
	"./adversary.mp3": 226654,
	"./advert.mp3": 912831,
	"./advertise.mp3": 892948,
	"./advertisement.mp3": 742480,
	"./advertises.mp3": 851083,
	"./advice.mp3": 847281,
	"./advisable.mp3": 302352,
	"./advise.mp3": 647233,
	"./advocate.mp3": 703482,
	"./aerobics.mp3": 779711,
	"./aerofoil.mp3": 421492,
	"./aeronaut.mp3": 86034,
	"./aerospace.mp3": 984964,
	"./affect.mp3": 106238,
	"./affection.mp3": 477316,
	"./afford.mp3": 159511,
	"./afloat.mp3": 778140,
	"./afraid.mp3": 120920,
	"./after.mp3": 764421,
	"./afterwards.mp3": 978778,
	"./again.mp3": 820439,
	"./age.mp3": 808166,
	"./aggressive.mp3": 706633,
	"./ago.mp3": 504428,
	"./aground.mp3": 596159,
	"./ahead.mp3": 816608,
	"./ahoy.mp3": 453670,
	"./aib.mp3": 151971,
	"./aik.mp3": 250918,
	"./ail.mp3": 880125,
	"./aim.mp3": 157400,
	"./air -2.mp3": 589228,
	"./air -3.mp3": 951537,
	"./air.mp3": 272659,
	"./airch.mp3": 274610,
	"./airport.mp3": 169434,
	"./aisle.mp3": 643627,
	"./aithor.mp3": 398808,
	"./ak.mp3": 541353,
	"./alhabet.mp3": 481712,
	"./alhalet.mp3": 284810,
	"./align.mp3": 637104,
	"./all.mp3": 141650,
	"./alley.mp3": 447048,
	"./allowed.mp3": 907931,
	"./almost.mp3": 660851,
	"./aloe.mp3": 736998,
	"./alone.mp3": 866898,
	"./along.mp3": 607168,
	"./aloud.mp3": 252006,
	"./alpabet.mp3": 14600,
	"./alpalet.mp3": 62546,
	"./alphabet.mp3": 821124,
	"./alphalet.mp3": 727334,
	"./alphanumeric.mp3": 258728,
	"./alrabet.mp3": 812202,
	"./alralet.mp3": 128656,
	"./already.mp3": 488635,
	"./alright.mp3": 219332,
	"./altar.mp3": 211011,
	"./alter.mp3": 421359,
	"./although.mp3": 991439,
	"./always.mp3": 470734,
	"./am.mp3": 383263,
	"./amateur.mp3": 227048,
	"./amaze.mp3": 487167,
	"./ambitious.mp3": 482076,
	"./amuse.mp3": 984368,
	"./amusement.mp3": 683804,
	"./an.mp3": 999592,
	"./analogue.mp3": 213883,
	"./analogy.mp3": 443074,
	"./anchor.mp3": 631110,
	"./ancient.mp3": 595683,
	"./and.mp3": 790492,
	"./angel.mp3": 161716,
	"./angrily.mp3": 513877,
	"./angry.mp3": 59460,
	"./animal.mp3": 707665,
	"./animals.mp3": 539436,
	"./animation.mp3": 260997,
	"./anm.mp3": 759689,
	"./anniversary.mp3": 499669,
	"./annoy.mp3": 354182,
	"./annoying.mp3": 425666,
	"./annual.mp3": 293336,
	"./annually.mp3": 3281,
	"./another.mp3": 647118,
	"./anp.mp3": 187056,
	"./ans.mp3": 305223,
	"./ansade.mp3": 664973,
	"./anslame.mp3": 500728,
	"./anss.mp3": 566802,
	"./answer.mp3": 667835,
	"./anticipate.mp3": 793841,
	"./anticlimax.mp3": 376365,
	"./anticlockwise.mp3": 100693,
	"./antidote.mp3": 990595,
	"./antique.mp3": 325936,
	"./antiseptic.mp3": 69037,
	"./antisocial.mp3": 977144,
	"./anxious.mp3": 954816,
	"./any.mp3": 427709,
	"./anyone.mp3": 76055,
	"./anywhere.mp3": 814982,
	"./aon.mp3": 123705,
	"./aot.mp3": 723379,
	"./ap.mp3": 619326,
	"./apparent.mp3": 967678,
	"./appear.mp3": 315258,
	"./apple.mp3": 15823,
	"./applicable.mp3": 256402,
	"./applicably.mp3": 456774,
	"./application.mp3": 547701,
	"./applicator.mp3": 208858,
	"./appreciate.mp3": 323399,
	"./appreciated.mp3": 659665,
	"./appreciation.mp3": 996416,
	"./appreciative.mp3": 257196,
	"./apprehensive.mp3": 311125,
	"./approximately.mp3": 318924,
	"./april.mp3": 886883,
	"./aquarium.mp3": 360124,
	"./aquatics.mp3": 831806,
	"./aqueduct.mp3": 277277,
	"./ar -2.mp3": 956725,
	"./ar -3.mp3": 270096,
	"./ar .mp3": 506092,
	"./ar.mp3": 733900,
	"./arc.mp3": 738211,
	"./are.mp3": 506453,
	"./aren't.mp3": 709572,
	"./arfar.mp3": 484283,
	"./arfay.mp3": 193756,
	"./arfear.mp3": 326570,
	"./arfow.mp3": 168668,
	"./arfue.mp3": 160268,
	"./argar.mp3": 786010,
	"./argay.mp3": 259077,
	"./argear.mp3": 590417,
	"./argew.mp3": 320887,
	"./argow.mp3": 808249,
	"./argue.mp3": 697637,
	"./arguing.mp3": 204308,
	"./argument.mp3": 710232,
	"./ark.mp3": 593483,
	"./arl.mp3": 743640,
	"./arm.mp3": 466365,
	"./around.mp3": 462146,
	"./arrange.mp3": 919991,
	"./arrival.mp3": 542424,
	"./arrivals.mp3": 495671,
	"./arrive.mp3": 425680,
	"./arrives.mp3": 90175,
	"./arriving.mp3": 966101,
	"./arrow.mp3": 436376,
	"./artificial.mp3": 72517,
	"./artist.mp3": 687468,
	"./artwork.mp3": 893651,
	"./as.mp3": 791761,
	"./ascent.mp3": 485319,
	"./ascertain.mp3": 604317,
	"./ask.mp3": 610980,
	"./asked.mp3": 38067,
	"./asleep.mp3": 145015,
	"./assess.mp3": 126647,
	"./assign.mp3": 329478,
	"./assigning.mp3": 681666,
	"./assistance.mp3": 230757,
	"./assistant.mp3": 937575,
	"./assoa.mp3": 375688,
	"./assor.mp3": 742223,
	"./assow.mp3": 888870,
	"./assuhe.mp3": 141260,
	"./assure.mp3": 913758,
	"./asterisk.mp3": 804769,
	"./astrologer.mp3": 977265,
	"./astronaut.mp3": 757026,
	"./astronomer.mp3": 95917,
	"./astrophysics.mp3": 862893,
	"./at.mp3": 481954,
	"./ate.mp3": 902487,
	"./athlete.mp3": 712366,
	"./athor.mp3": 850225,
	"./atmosphere.mp3": 179361,
	"./atrocious.mp3": 961458,
	"./attached.mp3": 740017,
	"./attack.mp3": 482597,
	"./attempts.mp3": 117063,
	"./attention.mp3": 538745,
	"./audacious.mp3": 346325,
	"./audible.mp3": 148013,
	"./audience.mp3": 712207,
	"./audio.mp3": 76945,
	"./aught.mp3": 390714,
	"./august.mp3": 672214,
	"./author.mp3": 23668,
	"./authored.mp3": 780611,
	"./autobiography.mp3": 276347,
	"./autograph.mp3": 747796,
	"./automate.mp3": 628123,
	"./automatic.mp3": 241938,
	"./automatically.mp3": 415788,
	"./automobile.mp3": 240742,
	"./autonomy.mp3": 173939,
	"./autopilot.mp3": 151410,
	"./autumn.mp3": 785235,
	"./availability.mp3": 248292,
	"./available.mp3": 231918,
	"./avenar.mp3": 267028,
	"./avenay.mp3": 665475,
	"./avene.mp3": 287158,
	"./avenear.mp3": 727631,
	"./avenow.mp3": 525095,
	"./avenue.mp3": 916763,
	"./average.mp3": 726090,
	"./avine.mp3": 887426,
	"./avone.mp3": 2652,
	"./avune.mp3": 43494,
	"./award.mp3": 691048,
	"./away.mp3": 758243,
	"./awful.mp3": 399682,
	"./awkward.mp3": 545278,
	"./awkwardly.mp3": 858791,
	"./ay -2.mp3": 471844,
	"./ay -3.mp3": 690441,
	"./ay .mp3": 302369,
	"./ay.mp3": 5611,
	"./aych.mp3": 251386,
	"./ayntray.mp3": 841159,
	"./b -2.mp3": 759694,
	"./b -3.mp3": 257939,
	"./b.mp3": 663797,
	"./ba.mp3": 445146,
	"./babies'.mp3": 352528,
	"./babies.mp3": 967137,
	"./baby's.mp3": 260127,
	"./baby.mp3": 290689,
	"./bach.mp3": 422835,
	"./back.mp3": 341500,
	"./background.mp3": 238489,
	"./backward.mp3": 866298,
	"./backwards.mp3": 509561,
	"./bad.mp3": 219418,
	"./badge.mp3": 675230,
	"./badger.mp3": 256224,
	"./badly.mp3": 58299,
	"./baf.mp3": 35656,
	"./bag.mp3": 680941,
	"./baggage.mp3": 89353,
	"./baguette.mp3": 576056,
	"./bah.mp3": 860430,
	"./bai.mp3": 358675,
	"./baik.mp3": 337374,
	"./bail.mp3": 97557,
	"./baip.mp3": 389449,
	"./bait.mp3": 772269,
	"./bak.mp3": 464225,
	"./bake.mp3": 736354,
	"./balance.mp3": 425543,
	"./balar.mp3": 652491,
	"./balay.mp3": 592428,
	"./balb.mp3": 413548,
	"./bald.mp3": 642050,
	"./balear.mp3": 740250,
	"./ball.mp3": 304042,
	"./balm.mp3": 782543,
	"./balow.mp3": 871788,
	"./balt.mp3": 305266,
	"./balue.mp3": 311580,
	"./bame.mp3": 952412,
	"./bane.mp3": 937033,
	"./bang.mp3": 258363,
	"./bank.mp3": 457847,
	"./bankrupt.mp3": 205344,
	"./bannair.mp3": 744514,
	"./bannar.mp3": 313959,
	"./bannare.mp3": 545004,
	"./banner.mp3": 795419,
	"./bannerer.mp3": 232442,
	"./bannor.mp3": 443033,
	"./banquet.mp3": 458493,
	"./baon.mp3": 882769,
	"./baop.mp3": 627295,
	"./bap.mp3": 336934,
	"./bar.mp3": 88564,
	"./bard.mp3": 353064,
	"./bare.mp3": 500493,
	"./bargain.mp3": 760265,
	"./bargained.mp3": 649722,
	"./bargaining.mp3": 420591,
	"./barge.mp3": 641844,
	"./bark.mp3": 983987,
	"./barth.mp3": 123384,
	"./bas.mp3": 48409,
	"./bash.mp3": 338275,
	"./basically.mp3": 531027,
	"./bast.mp3": 901823,
	"./bat.mp3": 228138,
	"./bath.mp3": 719998,
	"./batoa.mp3": 178970,
	"./bator.mp3": 925693,
	"./batow.mp3": 48116,
	"./batuhe.mp3": 34102,
	"./bature.mp3": 789524,
	"./baw.mp3": 966141,
	"./bawl.mp3": 268027,
	"./bax.mp3": 246046,
	"./bay.mp3": 237987,
	"./baz.mp3": 33196,
	"./be.mp3": 761110,
	"./beach.mp3": 206254,
	"./bead.mp3": 698537,
	"./beak.mp3": 353938,
	"./beam.mp3": 706364,
	"./bear.mp3": 65839,
	"./beard.mp3": 967945,
	"./beards.mp3": 219924,
	"./beast.mp3": 858010,
	"./beat.mp3": 214201,
	"./beath.mp3": 531203,
	"./beautician.mp3": 526576,
	"./beautiful.mp3": 985738,
	"./beauty.mp3": 586605,
	"./because.mp3": 206071,
	"./becc.mp3": 9568,
	"./bech.mp3": 763711,
	"./beckon.mp3": 585359,
	"./bed.mp3": 331174,
	"./bedroom.mp3": 431575,
	"./bee.mp3": 875595,
	"./beek.mp3": 720822,
	"./been.mp3": 992159,
	"./beep.mp3": 247633,
	"./bees.mp3": 75198,
	"./beet.mp3": 916981,
	"./before.mp3": 111916,
	"./beg.mp3": 347097,
	"./began.mp3": 380380,
	"./begg.mp3": 215960,
	"./begin.mp3": 59572,
	"./beginner.mp3": 253239,
	"./beginning.mp3": 518662,
	"./behind.mp3": 645833,
	"./beige.mp3": 537091,
	"./bek.mp3": 304917,
	"./beke.mp3": 278070,
	"./believable.mp3": 48422,
	"./believe.mp3": 42367,
	"./believer.mp3": 866207,
	"./believing.mp3": 625854,
	"./bell.mp3": 802790,
	"./below.mp3": 189512,
	"./belt.mp3": 842638,
	"./beme.mp3": 49096,
	"./ben.mp3": 331884,
	"./benc.mp3": 332995,
	"./bench.mp3": 619073,
	"./bend.mp3": 860880,
	"./beneficial.mp3": 347253,
	"./benefit.mp3": 761438,
	"./benh.mp3": 630100,
	"./benk.mp3": 634539,
	"./bent.mp3": 565952,
	"./berr.mp3": 72226,
	"./berry.mp3": 775083,
	"./best.mp3": 238291,
	"./bet.mp3": 376598,
	"./bettair.mp3": 437834,
	"./bettar.mp3": 60719,
	"./bettare.mp3": 164580,
	"./better.mp3": 850371,
	"./betterer.mp3": 224322,
	"./bettor.mp3": 479505,
	"./bew.mp3": 292361,
	"./beware.mp3": 751073,
	"./biannual.mp3": 935403,
	"./bias.mp3": 533222,
	"./bicc.mp3": 908540,
	"./bicentennial.mp3": 590285,
	"./bich.mp3": 221787,
	"./bicycle.mp3": 224672,
	"./bid.mp3": 723778,
	"./biennial.mp3": 603259,
	"./bif.mp3": 187568,
	"./bifocals.mp3": 458876,
	"./big.mp3": 468309,
	"./bigg.mp3": 892484,
	"./bigh.mp3": 66391,
	"./bike.mp3": 867178,
	"./bilingual.mp3": 559376,
	"./bill.mp3": 731874,
	"./bim.mp3": 864271,
	"./bime.mp3": 198020,
	"./bin.mp3": 221848,
	"./binary.mp3": 39498,
	"./bind.mp3": 130412,
	"./binoculars.mp3": 814875,
	"./biodiversity.mp3": 580082,
	"./biography.mp3": 133352,
	"./biologist.mp3": 903551,
	"./biology.mp3": 89898,
	"./biosphere.mp3": 654498,
	"./bip.mp3": 322510,
	"./biped.mp3": 643037,
	"./bird.mp3": 650592,
	"./birds.mp3": 273423,
	"./birr.mp3": 332894,
	"./birth.mp3": 438608,
	"./birthday.mp3": 948062,
	"./bis.mp3": 926305,
	"./bisect.mp3": 232055,
	"./bish.mp3": 256235,
	"./bit.mp3": 386994,
	"./bith.mp3": 409062,
	"./biweekly.mp3": 211567,
	"./bizarre.mp3": 105386,
	"./black.mp3": 702566,
	"./blackberry.mp3": 463318,
	"./blae.mp3": 718285,
	"./blaird.mp3": 762983,
	"./blame.mp3": 259814,
	"./bland.mp3": 9954,
	"./blank.mp3": 68665,
	"./blape.mp3": 654381,
	"./blar.mp3": 425862,
	"./blard.mp3": 238070,
	"./blast.mp3": 268693,
	"./blaw.mp3": 937391,
	"./blay.mp3": 336849,
	"./blaze.mp3": 834819,
	"./bleak.mp3": 865024,
	"./blear.mp3": 55773,
	"./bled.mp3": 640300,
	"./bleme.mp3": 115562,
	"./blend.mp3": 486742,
	"./blepe.mp3": 191689,
	"./blew.mp3": 508307,
	"./blied.mp3": 435387,
	"./blime .mp3": 229362,
	"./blind.mp3": 640554,
	"./blink.mp3": 807921,
	"./blipe.mp3": 399397,
	"./bload.mp3": 556029,
	"./blob.mp3": 705180,
	"./block.mp3": 542228,
	"./blome.mp3": 522900,
	"./blond.mp3": 781884,
	"./blonde.mp3": 146277,
	"./bloo.mp3": 998317,
	"./blope.mp3": 346275,
	"./blow.mp3": 170581,
	"./blue.mp3": 498113,
	"./bluebell.mp3": 68866,
	"./bluff.mp3": 342300,
	"./blush.mp3": 457021,
	"./bluw.mp3": 156227,
	"./bo.mp3": 707676,
	"./boa.mp3": 483553,
	"./boach.mp3": 637108,
	"./boad.mp3": 65063,
	"./boak.mp3": 462996,
	"./boal.mp3": 886831,
	"./boan.mp3": 105949,
	"./boap.mp3": 92339,
	"./boast.mp3": 913872,
	"./boat.mp3": 679447,
	"./bockair.mp3": 223698,
	"./bockar.mp3": 707927,
	"./bockay.mp3": 6248,
	"./bockey.mp3": 434028,
	"./bockoy.mp3": 704014,
	"./boe.mp3": 711813,
	"./boi.mp3": 317449,
	"./boil.mp3": 217367,
	"./bok.mp3": 638779,
	"./boke.mp3": 642512,
	"./bold.mp3": 49852,
	"./bomb.mp3": 323074,
	"./bome.mp3": 493534,
	"./bomp.mp3": 66423,
	"./bone.mp3": 596607,
	"./bonfire.mp3": 160422,
	"./boo.mp3": 947711,
	"./book.mp3": 440802,
	"./boon.mp3": 662915,
	"./boop.mp3": 132045,
	"./boot.mp3": 500201,
	"./bop.mp3": 52524,
	"./bor.mp3": 265374,
	"./bord.mp3": 79774,
	"./born.mp3": 922292,
	"./borough.mp3": 965263,
	"./borp.mp3": 605618,
	"./borth.mp3": 230778,
	"./bos.mp3": 257315,
	"./boss.mp3": 260774,
	"./bot.mp3": 744816,
	"./both.mp3": 777040,
	"./bottle.mp3": 699705,
	"./bou.mp3": 25557,
	"./bough.mp3": 296876,
	"./bought.mp3": 191040,
	"./boulder.mp3": 51056,
	"./bounce.mp3": 550837,
	"./bow.mp3": 862983,
	"./bowl.mp3": 44153,
	"./bowled.mp3": 909226,
	"./box.mp3": 107892,
	"./boxair.mp3": 818448,
	"./boxar.mp3": 23065,
	"./boxare.mp3": 655466,
	"./boxer.mp3": 567781,
	"./boxerer.mp3": 490200,
	"./boxor.mp3": 708263,
	"./boy's.mp3": 940279,
	"./boy.mp3": 67737,
	"./boys'.mp3": 791599,
	"./boys.mp3": 929764,
	"./brack.mp3": 957828,
	"./brake.mp3": 607658,
	"./brand.mp3": 870892,
	"./brash.mp3": 996715,
	"./brat.mp3": 403634,
	"./brave.mp3": 157385,
	"./bravely.mp3": 885944,
	"./bread.mp3": 786689,
	"./break.mp3": 180410,
	"./breakable.mp3": 365958,
	"./breakfast.mp3": 635884,
	"./bream.mp3": 268100,
	"./breath.mp3": 263099,
	"./breathe.mp3": 923344,
	"./breathes.mp3": 63935,
	"./breathing.mp3": 611029,
	"./breathless.mp3": 822584,
	"./breathlessly.mp3": 12145,
	"./breaths.mp3": 642030,
	"./breathtaking.mp3": 310759,
	"./breete.mp3": 154110,
	"./breeze.mp3": 932152,
	"./brew.mp3": 827409,
	"./brick.mp3": 565628,
	"./bridal.mp3": 746077,
	"./bridge.mp3": 184926,
	"./bridle.mp3": 792199,
	"./brief.mp3": 981163,
	"./bright.mp3": 407801,
	"./bring.mp3": 998843,
	"./brish.mp3": 78755,
	"./bristle.mp3": 750706,
	"./brite.mp3": 902831,
	"./broadcast.mp3": 299102,
	"./brochure.mp3": 742877,
	"./brock.mp3": 921174,
	"./broke.mp3": 589352,
	"./broom.mp3": 409716,
	"./brote.mp3": 756385,
	"./broth.mp3": 174792,
	"./brother.mp3": 265633,
	"./brought.mp3": 8568,
	"./brow.mp3": 14687,
	"./brown.mp3": 530851,
	"./bruch.mp3": 741847,
	"./bruf.mp3": 88492,
	"./brug.mp3": 450801,
	"./bruise.mp3": 680783,
	"./brung.mp3": 382239,
	"./brus.mp3": 747781,
	"./brush.mp3": 2599,
	"./bruss.mp3": 974184,
	"./brute.mp3": 104179,
	"./bucket.mp3": 601767,
	"./bud.mp3": 628310,
	"./bug.mp3": 874697,
	"./buil.mp3": 372937,
	"./build.mp3": 281439,
	"./builder.mp3": 235782,
	"./building.mp3": 613329,
	"./bulb.mp3": 190336,
	"./bulge.mp3": 978626,
	"./bull.mp3": 848886,
	"./bullies.mp3": 396851,
	"./bult.mp3": 872638,
	"./bume.mp3": 302424,
	"./bump.mp3": 840777,
	"./bun.mp3": 905500,
	"./burger.mp3": 54050,
	"./burn.mp3": 889254,
	"./burp.mp3": 116064,
	"./bursar.mp3": 737322,
	"./burst.mp3": 669361,
	"./bury.mp3": 233261,
	"./bus.mp3": 542717,
	"./bush.mp3": 28287,
	"./busier.mp3": 201503,
	"./busiest.mp3": 135050,
	"./busily.mp3": 294651,
	"./business.mp3": 437195,
	"./buss.mp3": 825392,
	"./busses.mp3": 53764,
	"./bustle.mp3": 579846,
	"./busy.mp3": 328042,
	"./but.mp3": 913510,
	"./buww.mp3": 917896,
	"./buxx.mp3": 446502,
	"./buy.mp3": 420231,
	"./buyy.mp3": 256808,
	"./buzz.mp3": 469394,
	"./buzzed.mp3": 839537,
	"./buzzer.mp3": 720439,
	"./buzzing.mp3": 783238,
	"./buzzword.mp3": 443726,
	"./by.mp3": 944898,
	"./c.mp3": 977168,
	"./ca.mp3": 797309,
	"./cable.mp3": 318312,
	"./cach.mp3": 988384,
	"./cack.mp3": 243575,
	"./cad.mp3": 384787,
	"./caddot.mp3": 762792,
	"./caf.mp3": 617185,
	"./caffeine.mp3": 958368,
	"./cag.mp3": 24412,
	"./cage.mp3": 127493,
	"./cai.mp3": 761882,
	"./caid.mp3": 635098,
	"./caik.mp3": 879905,
	"./cail.mp3": 340594,
	"./cain.mp3": 979424,
	"./cair.mp3": 504244,
	"./cais.mp3": 464089,
	"./cait.mp3": 643818,
	"./cake.mp3": 108353,
	"./cakkok.mp3": 104317,
	"./calendar.mp3": 989847,
	"./calf.mp3": 118055,
	"./call.mp3": 158941,
	"./called.mp3": 19662,
	"./calm.mp3": 546424,
	"./cam.mp3": 77846,
	"./came.mp3": 291275,
	"./camel.mp3": 719373,
	"./camp.mp3": 476314,
	"./can't.mp3": 611564,
	"./can.mp3": 993609,
	"./cancel.mp3": 129019,
	"./cant.mp3": 486703,
	"./caods.mp3": 245783,
	"./caol.mp3": 262416,
	"./cap.mp3": 539143,
	"./capable.mp3": 706455,
	"./capacity.mp3": 611889,
	"./capital.mp3": 349135,
	"./capitalise.mp3": 525604,
	"./captive.mp3": 274061,
	"./captop.mp3": 154272,
	"./capture.mp3": 948549,
	"./car rote.mp3": 916371,
	"./car's.mp3": 947835,
	"./car.mp3": 6165,
	"./car_s.mp3": 266035,
	"./card.mp3": 559579,
	"./care.mp3": 266550,
	"./careful.mp3": 231419,
	"./carefully.mp3": 381578,
	"./careless.mp3": 289437,
	"./carelessness.mp3": 929636,
	"./cargais.mp3": 610501,
	"./cargays.mp3": 843125,
	"./cargees.mp3": 656373,
	"./cargoes.mp3": 274323,
	"./cargows.mp3": 577685,
	"./cargoys.mp3": 390023,
	"./carnivorous.mp3": 194046,
	"./carriage.mp3": 678519,
	"./carriages.mp3": 304450,
	"./carries.mp3": 654682,
	"./carrot.mp3": 465416,
	"./carry.mp3": 702602,
	"./cars'.mp3": 534019,
	"./cars_.mp3": 680187,
	"./cart.mp3": 33387,
	"./cas.mp3": 209072,
	"./case.mp3": 664057,
	"./casework.mp3": 603326,
	"./cash.mp3": 838992,
	"./cast.mp3": 7556,
	"./castle.mp3": 35513,
	"./castles.mp3": 331140,
	"./casual.mp3": 350558,
	"./casually.mp3": 470279,
	"./casualty.mp3": 130735,
	"./cat's.mp3": 672409,
	"./cat.mp3": 390947,
	"./cat_s.mp3": 751313,
	"./catalogue.mp3": 947140,
	"./catch.mp3": 77506,
	"./catches.mp3": 982274,
	"./category.mp3": 383177,
	"./cats.mp3": 338854,
	"./cattot.mp3": 74216,
	"./caught.mp3": 500037,
	"./cause.mp3": 535814,
	"./cautious.mp3": 215190,
	"./cave.mp3": 361746,
	"./cays.mp3": 623081,
	"./ceb.mp3": 211737,
	"./ceck.mp3": 452339,
	"./ceebe.mp3": 59181,
	"./ceed.mp3": 921418,
	"./ceeds.mp3": 145289,
	"./ceek.mp3": 877137,
	"./ceel.mp3": 720354,
	"./cees.mp3": 805929,
	"./ceese.mp3": 579034,
	"./ceet.mp3": 8698,
	"./ceff.mp3": 581153,
	"./ceg.mp3": 923096,
	"./ceiling.mp3": 593378,
	"./celebrate.mp3": 440344,
	"./celebration.mp3": 138003,
	"./celery.mp3": 626351,
	"./cell.mp3": 305081,
	"./cellar.mp3": 128696,
	"./ceme.mp3": 945527,
	"./cement.mp3": 646053,
	"./cemetery.mp3": 54713,
	"./cemetry.mp3": 911718,
	"./cent.mp3": 842859,
	"./centigrade.mp3": 31237,
	"./centimetre.mp3": 221633,
	"./centipede.mp3": 712088,
	"./central.mp3": 494096,
	"./centrally.mp3": 597993,
	"./centre.mp3": 612872,
	"./centred.mp3": 343484,
	"./centuries.mp3": 330775,
	"./century.mp3": 122627,
	"./cep.mp3": 782779,
	"./cereal.mp3": 110077,
	"./cert.mp3": 169327,
	"./certain.mp3": 983481,
	"./certainly.mp3": 882312,
	"./certificate.mp3": 458686,
	"./certificates.mp3": 375717,
	"./certified.mp3": 198896,
	"./certify.mp3": 319031,
	"./certifying.mp3": 650105,
	"./certitude.mp3": 83896,
	"./ces.mp3": 726500,
	"./cest.mp3": 229032,
	"./cet.mp3": 91711,
	"./cewk.mp3": 602335,
	"./ch -2.mp3": 997865,
	"./ch -3.mp3": 830852,
	"./ch .mp3": 198904,
	"./ch.mp3": 344752,
	"./chack.mp3": 911831,
	"./chad.mp3": 788723,
	"./chai.mp3": 902330,
	"./chaik.mp3": 858049,
	"./chaim.mp3": 29719,
	"./chain.mp3": 265472,
	"./chair.mp3": 813268,
	"./chak.mp3": 674152,
	"./chalet.mp3": 491780,
	"./chalk.mp3": 948966,
	"./chall.mp3": 578173,
	"./challenge.mp3": 40196,
	"./cham.mp3": 243958,
	"./chame.mp3": 658923,
	"./champ.mp3": 550458,
	"./champagne.mp3": 171969,
	"./championship.mp3": 873606,
	"./chan.mp3": 215913,
	"./chance.mp3": 572765,
	"./change.mp3": 837377,
	"./changeable.mp3": 261909,
	"./chaos.mp3": 246907,
	"./chapel.mp3": 68216,
	"./character.mp3": 767670,
	"./charge.mp3": 507741,
	"./chark.mp3": 799008,
	"./charl.mp3": 110291,
	"./chart.mp3": 328523,
	"./chase.mp3": 252441,
	"./chass.mp3": 132415,
	"./chat.mp3": 378627,
	"./chauffeur.mp3": 295086,
	"./chaw.mp3": 255436,
	"./chawn.mp3": 426410,
	"./chay.mp3": 815050,
	"./che.mp3": 382713,
	"./chead.mp3": 140918,
	"./cheal.mp3": 979630,
	"./cheat.mp3": 968646,
	"./check.mp3": 234963,
	"./ched.mp3": 51055,
	"./chee.mp3": 825418,
	"./cheek.mp3": 714545,
	"./cheem.mp3": 162695,
	"./cheen.mp3": 44528,
	"./cheer.mp3": 882212,
	"./cheerful.mp3": 766033,
	"./cheese.mp3": 879290,
	"./chef.mp3": 270173,
	"./cheff.mp3": 75649,
	"./cheg.mp3": 657656,
	"./chelf.mp3": 566691,
	"./chell.mp3": 893465,
	"./chem.mp3": 624354,
	"./cheme.mp3": 740631,
	"./chemist.mp3": 543550,
	"./chen.mp3": 60981,
	"./cheque.mp3": 855856,
	"./cherry.mp3": 105806,
	"./chese.mp3": 260093,
	"./chess.mp3": 217851,
	"./chest.mp3": 634056,
	"./chew.mp3": 141992,
	"./chick.mp3": 890463,
	"./chicken.mp3": 158994,
	"./chid.mp3": 156027,
	"./chief's.mp3": 446362,
	"./chief.mp3": 443060,
	"./chiff.mp3": 754701,
	"./chift.mp3": 973807,
	"./chigh.mp3": 251468,
	"./chil.mp3": 895251,
	"./child's.mp3": 817187,
	"./child.mp3": 330301,
	"./childhood.mp3": 824623,
	"./childishness.mp3": 165222,
	"./children's.mp3": 199954,
	"./children.mp3": 320588,
	"./chill.mp3": 370389,
	"./chilly.mp3": 46306,
	"./chim.mp3": 397006,
	"./chime.mp3": 705331,
	"./chimnair.mp3": 311584,
	"./chimnar.mp3": 58825,
	"./chimnay.mp3": 137486,
	"./chimney.mp3": 521002,
	"./chimnoy.mp3": 923368,
	"./chimp.mp3": 556770,
	"./chin.mp3": 801,
	"./chink.mp3": 528404,
	"./chip.mp3": 938767,
	"./chips.mp3": 757130,
	"./chirl.mp3": 540859,
	"./chirp.mp3": 765063,
	"./chirt.mp3": 159395,
	"./chis.mp3": 296344,
	"./chise.mp3": 769329,
	"./chit.mp3": 629835,
	"./choad.mp3": 111896,
	"./choak.mp3": 716963,
	"./choal.mp3": 51440,
	"./choan.mp3": 587650,
	"./chob.mp3": 773979,
	"./chock.mp3": 108917,
	"./chocolate.mp3": 279205,
	"./chod.mp3": 872845,
	"./choe.mp3": 699240,
	"./choice.mp3": 313272,
	"./choin.mp3": 485946,
	"./chol.mp3": 686949,
	"./chom.mp3": 636672,
	"./chome.mp3": 288937,
	"./chomp.mp3": 262840,
	"./choo.mp3": 896402,
	"./choon.mp3": 546808,
	"./choose.mp3": 306306,
	"./chop.mp3": 756665,
	"./chore.mp3": 609632,
	"./chorl.mp3": 726829,
	"./chorn.mp3": 363775,
	"./chort.mp3": 899093,
	"./chorus.mp3": 547807,
	"./chose.mp3": 677851,
	"./chow.mp3": 382666,
	"./chowl.mp3": 308290,
	"./chown.mp3": 772080,
	"./choy.mp3": 433548,
	"./chrill.mp3": 567699,
	"./christmas.mp3": 46075,
	"./chronic.mp3": 942173,
	"./chronicle.mp3": 772208,
	"./chronography.mp3": 533313,
	"./chronological.mp3": 775869,
	"./chud.mp3": 888383,
	"./chug.mp3": 995656,
	"./chume.mp3": 741063,
	"./chump.mp3": 604814,
	"./chunk.mp3": 297488,
	"./chup.mp3": 53259,
	"./church.mp3": 741884,
	"./chuse.mp3": 321997,
	"./chute.mp3": 23300,
	"./chuzz.mp3": 699129,
	"./cib.mp3": 562829,
	"./cibe.mp3": 50814,
	"./cick.mp3": 69247,
	"./cicken.mp3": 608114,
	"./ciff.mp3": 506605,
	"./cig.mp3": 273796,
	"./cim.mp3": 823918,
	"./cime.mp3": 194003,
	"./cimney.mp3": 355466,
	"./cin.mp3": 792385,
	"./cip.mp3": 781935,
	"./circa.mp3": 627917,
	"./circadian.mp3": 486013,
	"./circle.mp3": 655141,
	"./circuit.mp3": 21358,
	"./circular.mp3": 17338,
	"./circulation.mp3": 374294,
	"./circumference.mp3": 337924,
	"./circumnavigate.mp3": 258995,
	"./circumstance.mp3": 310454,
	"./circus.mp3": 688516,
	"./cirp.mp3": 84583,
	"./ciss.mp3": 24535,
	"./cit.mp3": 752043,
	"./cities.mp3": 336464,
	"./city.mp3": 933556,
	"./civil.mp3": 31686,
	"./cix.mp3": 960167,
	"./ciz.mp3": 665013,
	"./claird.mp3": 601660,
	"./clais.mp3": 620589,
	"./clamp.mp3": 325094,
	"./clang.mp3": 261868,
	"./clank.mp3": 530968,
	"./clap.mp3": 908899,
	"./clapping.mp3": 996831,
	"./clar.mp3": 66417,
	"./clard.mp3": 769367,
	"./clas.mp3": 220460,
	"./clash.mp3": 462804,
	"./clasp.mp3": 222716,
	"./class.mp3": 304051,
	"./classes.mp3": 778455,
	"./classroom.mp3": 73166,
	"./claw.mp3": 396400,
	"./claws.mp3": 62559,
	"./clay.mp3": 524198,
	"./clean.mp3": 369056,
	"./clear.mp3": 893876,
	"./cled.mp3": 126971,
	"./clee.mp3": 101782,
	"./clep.mp3": 909711,
	"./clew.mp3": 265460,
	"./cley.mp3": 769218,
	"./click.mp3": 10643,
	"./clied.mp3": 992234,
	"./cliff.mp3": 851329,
	"./climb.mp3": 33596,
	"./climbing.mp3": 267860,
	"./cling.mp3": 899940,
	"./clip.mp3": 187675,
	"./cload.mp3": 460284,
	"./clock.mp3": 186081,
	"./clod.mp3": 949705,
	"./cloid.mp3": 852644,
	"./clois.mp3": 175311,
	"./closure.mp3": 643860,
	"./cloth.mp3": 988835,
	"./clothe.mp3": 566344,
	"./clothes.mp3": 716839,
	"./cloud.mp3": 3624,
	"./clow.mp3": 504870,
	"./clows.mp3": 290749,
	"./cloy.mp3": 377072,
	"./clu.mp3": 323365,
	"./cluck.mp3": 909839,
	"./clud.mp3": 187595,
	"./clue.mp3": 947622,
	"./clueless.mp3": 793805,
	"./cluid.mp3": 506162,
	"./clump.mp3": 288498,
	"./clumsy.mp3": 626450,
	"./clung.mp3": 11264,
	"./clutch.mp3": 17610,
	"./co-author.mp3": 912605,
	"./co-exist.mp3": 218525,
	"./co-operate.mp3": 560548,
	"./co-operation.mp3": 528583,
	"./co-ordinate.mp3": 536288,
	"./co-ordinated.mp3": 320164,
	"./co-ordinating.mp3": 36773,
	"./co-own.mp3": 275552,
	"./co-won.mp3": 212224,
	"./co.mp3": 526627,
	"./coa.mp3": 283748,
	"./coach.mp3": 652809,
	"./coad.mp3": 472248,
	"./coak.mp3": 144707,
	"./coal.mp3": 672592,
	"./coan.mp3": 922594,
	"./coarse.mp3": 598782,
	"./coat.mp3": 956584,
	"./cob.mp3": 340027,
	"./cobe.mp3": 630992,
	"./coconut.mp3": 762718,
	"./cod.mp3": 401517,
	"./coes.mp3": 517159,
	"./coffee.mp3": 207113,
	"./cognition.mp3": 452315,
	"./cohesive.mp3": 291165,
	"./coil.mp3": 169160,
	"./coin.mp3": 895450,
	"./coincide.mp3": 47603,
	"./coincided.mp3": 602653,
	"./coincidence.mp3": 169399,
	"./coincidental.mp3": 981254,
	"./coinciding.mp3": 858970,
	"./coint.mp3": 938346,
	"./cok.mp3": 581006,
	"./col.mp3": 413061,
	"./cold.mp3": 835051,
	"./collaborate.mp3": 231667,
	"./colleague.mp3": 72270,
	"./collection.mp3": 442093,
	"./collision.mp3": 86371,
	"./colocate.mp3": 717409,
	"./colourful.mp3": 208474,
	"./column.mp3": 170391,
	"./com.mp3": 284320,
	"./comb.mp3": 570586,
	"./combine.mp3": 694860,
	"./come.mp3": 132937,
	"./comfort.mp3": 906055,
	"./comfortable.mp3": 849623,
	"./comforted.mp3": 585008,
	"./comforting.mp3": 147945,
	"./comically.mp3": 445026,
	"./coming.mp3": 266656,
	"./commence.mp3": 942556,
	"./commentary.mp3": 341318,
	"./committed.mp3": 68181,
	"./committee.mp3": 787440,
	"./common.mp3": 378822,
	"./communicate.mp3": 110648,
	"./communicated.mp3": 919628,
	"./communicating.mp3": 263133,
	"./communicative.mp3": 470599,
	"./communities.mp3": 755656,
	"./community.mp3": 31564,
	"./comp.mp3": 594584,
	"./companion.mp3": 819933,
	"./company.mp3": 386774,
	"./compere.mp3": 639538,
	"./compete.mp3": 190572,
	"./competency.mp3": 294286,
	"./competent.mp3": 523226,
	"./competing.mp3": 108169,
	"./competition.mp3": 562798,
	"./complate.mp3": 813508,
	"./complement.mp3": 951865,
	"./complete.mp3": 842936,
	"./completed.mp3": 117836,
	"./completely.mp3": 173681,
	"./completing.mp3": 399389,
	"./completion.mp3": 145267,
	"./compliment.mp3": 83949,
	"./complite.mp3": 76700,
	"./complote.mp3": 393650,
	"./composing.mp3": 26474,
	"./composition.mp3": 160213,
	"./composure.mp3": 216240,
	"./compound.mp3": 582494,
	"./comprehension.mp3": 634203,
	"./computer.mp3": 153598,
	"./conceive.mp3": 716179,
	"./concentrate.mp3": 464743,
	"./concentrated.mp3": 518577,
	"./concentrating.mp3": 367430,
	"./concentration.mp3": 386400,
	"./concerned.mp3": 412180,
	"./conclusion.mp3": 202312,
	"./confession.mp3": 631792,
	"./confide.mp3": 90713,
	"./confidence.mp3": 435617,
	"./confident.mp3": 30315,
	"./confidential.mp3": 300007,
	"./confused.mp3": 445520,
	"./confusion.mp3": 200607,
	"./congested.mp3": 19269,
	"./congratulation.mp3": 946407,
	"./connected.mp3": 469482,
	"./connecting.mp3": 89343,
	"./conquer.mp3": 74868,
	"./conquest.mp3": 458495,
	"./conquests.mp3": 291002,
	"./conscience.mp3": 293535,
	"./conscientious.mp3": 118201,
	"./conscious.mp3": 709345,
	"./consequential.mp3": 228710,
	"./consider.mp3": 106312,
	"./considerable.mp3": 593104,
	"./considerably.mp3": 761668,
	"./considerate.mp3": 361232,
	"./consideration.mp3": 113787,
	"./consonant.mp3": 638320,
	"./conspire.mp3": 67876,
	"./construction.mp3": 228014,
	"./constructive.mp3": 237678,
	"./constructure.mp3": 172654,
	"./consumer.mp3": 439429,
	"./cont.mp3": 214897,
	"./content.mp3": 581372,
	"./contentious.mp3": 983012,
	"./contest.mp3": 146231,
	"./contestant.mp3": 622398,
	"./continar.mp3": 913169,
	"./continay.mp3": 697734,
	"./continear.mp3": 376468,
	"./continow.mp3": 678406,
	"./continue.mp3": 121158,
	"./continuous.mp3": 309928,
	"./contract.mp3": 823611,
	"./contradict.mp3": 285274,
	"./contradicted.mp3": 785977,
	"./contradicting.mp3": 503102,
	"./contrarian.mp3": 348416,
	"./contrary.mp3": 762245,
	"./contrast.mp3": 710603,
	"./contribute.mp3": 10108,
	"./control.mp3": 187332,
	"./controversial.mp3": 311652,
	"./controversy.mp3": 814527,
	"./convenience.mp3": 277482,
	"./convenient.mp3": 477274,
	"./conveniently.mp3": 167739,
	"./conversation.mp3": 73028,
	"./convey.mp3": 2845,
	"./cood.mp3": 837954,
	"./coods.mp3": 948977,
	"./cook.mp3": 624665,
	"./cool.mp3": 499946,
	"./coose.mp3": 89058,
	"./cop.mp3": 768985,
	"./copied.mp3": 130669,
	"./copier.mp3": 389963,
	"./copies.mp3": 329190,
	"./copilot.mp3": 83479,
	"./copying.mp3": 60442,
	"./cor.mp3": 813835,
	"./cord.mp3": 994853,
	"./cordial.mp3": 139029,
	"./cords.mp3": 944648,
	"./core.mp3": 944576,
	"./cork.mp3": 119478,
	"./corl.mp3": 697101,
	"./coronation.mp3": 397491,
	"./corporal.mp3": 433909,
	"./corporation.mp3": 936257,
	"./corpse.mp3": 615989,
	"./correspond.mp3": 862250,
	"./correspondence.mp3": 378939,
	"./corrupt.mp3": 852692,
	"./cot.mp3": 686717,
	"./cough.mp3": 884641,
	"./could.mp3": 115944,
	"./couldn't.mp3": 176447,
	"./couldnt.mp3": 461334,
	"./count.mp3": 290214,
	"./country.mp3": 267821,
	"./couple.mp3": 371717,
	"./coupon.mp3": 676615,
	"./courage.mp3": 154559,
	"./courageous.mp3": 654902,
	"./course.mp3": 547682,
	"./courteous.mp3": 889886,
	"./cousin.mp3": 581942,
	"./cover.mp3": 762454,
	"./cow.mp3": 948714,
	"./cowl.mp3": 931554,
	"./cown.mp3": 681552,
	"./coworker.mp3": 79329,
	"./coys.mp3": 641971,
	"./crab.mp3": 816067,
	"./crack.mp3": 310173,
	"./craft.mp3": 409249,
	"./craftsmanship.mp3": 918086,
	"./crail.mp3": 56352,
	"./crairon.mp3": 185501,
	"./crairs.mp3": 747197,
	"./cral.mp3": 60573,
	"./cramp.mp3": 882432,
	"./craon.mp3": 507824,
	"./crars.mp3": 200694,
	"./crash.mp3": 997037,
	"./crashes.mp3": 912122,
	"./craw.mp3": 613202,
	"./crawl.mp3": 772490,
	"./crayon.mp3": 464299,
	"./crazy.mp3": 474148,
	"./crazy2.mp3": 972150,
	"./cream.mp3": 358201,
	"./creation.mp3": 553166,
	"./creative.mp3": 562830,
	"./creature.mp3": 14158,
	"./creatures.mp3": 359733,
	"./cree.mp3": 118932,
	"./creede.mp3": 684801,
	"./creeon.mp3": 78715,
	"./creep.mp3": 783924,
	"./crepe.mp3": 190206,
	"./crept.mp3": 896947,
	"./cres.mp3": 73786,
	"./crescent.mp3": 870580,
	"./cresh.mp3": 222126,
	"./cress.mp3": 328505,
	"./crest.mp3": 954506,
	"./crew.mp3": 229686,
	"./crib.mp3": 583627,
	"./cride.mp3": 597134,
	"./cried.mp3": 222316,
	"./cries.mp3": 491703,
	"./crisp.mp3": 389210,
	"./criss.mp3": 850733,
	"./critically.mp3": 234615,
	"./criticise.mp3": 299494,
	"./critique.mp3": 161545,
	"./croas.mp3": 503561,
	"./crob.mp3": 101469,
	"./crock.mp3": 734639,
	"./crode.mp3": 784608,
	"./croil.mp3": 669882,
	"./croo.mp3": 250124,
	"./cross.mp3": 29767,
	"./crow.mp3": 43588,
	"./crowl.mp3": 379440,
	"./crucial.mp3": 698272,
	"./crude.mp3": 664858,
	"./cruel.mp3": 106992,
	"./cruelly.mp3": 692297,
	"./cruise.mp3": 343844,
	"./crumb.mp3": 205486,
	"./crush.mp3": 152862,
	"./crust.mp3": 999386,
	"./cry.mp3": 372323,
	"./crying.mp3": 109165,
	"./cryptically.mp3": 666053,
	"./crystal.mp3": 696657,
	"./cub.mp3": 380585,
	"./cube.mp3": 110106,
	"./cuck.mp3": 64739,
	"./cud.mp3": 679967,
	"./cuff.mp3": 288273,
	"./cug.mp3": 838824,
	"./cuhe.mp3": 893880,
	"./cuhh.mp3": 627857,
	"./cuil.mp3": 435734,
	"./cuin.mp3": 947172,
	"./cuint.mp3": 147880,
	"./cum.mp3": 824082,
	"./cume.mp3": 76711,
	"./cump.mp3": 93486,
	"./cun.mp3": 130981,
	"./cup.mp3": 175467,
	"./cupboard.mp3": 95029,
	"./cupid.mp3": 525432,
	"./cupp.mp3": 789169,
	"./curable.mp3": 467357,
	"./curds.mp3": 314922,
	"./cure.mp3": 239754,
	"./curiosity.mp3": 925000,
	"./curious.mp3": 315193,
	"./curl.mp3": 643623,
	"./currency.mp3": 288576,
	"./curve.mp3": 591294,
	"./cuss.mp3": 333195,
	"./cute.mp3": 488996,
	"./cutting.mp3": 755295,
	"./cuzz.mp3": 298009,
	"./cycle.mp3": 500653,
	"./cycled.mp3": 682339,
	"./cycling.mp3": 40956,
	"./cyclist.mp3": 165776,
	"./cyclists.mp3": 640127,
	"./cyclone.mp3": 285776,
	"./cyclones.mp3": 356031,
	"./cygnet.mp3": 60929,
	"./d -2.mp3": 80092,
	"./d -3.mp3": 215393,
	"./d.mp3": 932931,
	"./da.mp3": 399812,
	"./dab.mp3": 471782,
	"./dack.mp3": 26422,
	"./dact.mp3": 349429,
	"./dad.mp3": 894616,
	"./daft.mp3": 643194,
	"./dag.mp3": 537039,
	"./daib.mp3": 842561,
	"./dail.mp3": 823071,
	"./dain.mp3": 613005,
	"./daip.mp3": 170051,
	"./dair.mp3": 78545,
	"./daish.mp3": 972404,
	"./dait.mp3": 526695,
	"./dal .mp3": 470968,
	"./dalha.mp3": 719229,
	"./dall.mp3": 174412,
	"./dalpa.mp3": 874757,
	"./dalpha.mp3": 269541,
	"./dalra.mp3": 739931,
	"./dam.mp3": 141077,
	"./damage.mp3": 656766,
	"./damp.mp3": 380399,
	"./dan.mp3": 396546,
	"./dance.mp3": 164194,
	"./dangerous.mp3": 148511,
	"./danoa.mp3": 60226,
	"./danor.mp3": 491013,
	"./danow.mp3": 823004,
	"./danuhe.mp3": 916014,
	"./danure.mp3": 505596,
	"./dap.mp3": 698020,
	"./dar.mp3": 186582,
	"./dare.mp3": 277771,
	"./darel.mp3": 961357,
	"./dark.mp3": 707093,
	"./darn.mp3": 734060,
	"./das.mp3": 754299,
	"./dash.mp3": 363001,
	"./dask.mp3": 729286,
	"./daslake.mp3": 721674,
	"./dass.mp3": 740270,
	"./dat.mp3": 170504,
	"./date.mp3": 772673,
	"./daub.mp3": 479765,
	"./daughter.mp3": 223633,
	"./daul.mp3": 566795,
	"./daunt.mp3": 499199,
	"./daw.mp3": 63231,
	"./dawn.mp3": 41987,
	"./day.mp3": 599073,
	"./de.mp3": 541416,
	"./dead.mp3": 228523,
	"./deadly.mp3": 998618,
	"./dear.mp3": 396109,
	"./debris.mp3": 735124,
	"./decade.mp3": 787229,
	"./decagon.mp3": 16176,
	"./decathlon.mp3": 43439,
	"./deceased.mp3": 648843,
	"./deceit.mp3": 912943,
	"./deceitful.mp3": 19644,
	"./deceive.mp3": 78510,
	"./december.mp3": 916200,
	"./decency.mp3": 392190,
	"./decent.mp3": 70058,
	"./decide.mp3": 960613,
	"./decided.mp3": 804171,
	"./decision.mp3": 186463,
	"./decisive.mp3": 450227,
	"./deckon.mp3": 82641,
	"./decode.mp3": 285115,
	"./decompose.mp3": 425716,
	"./decoration.mp3": 464891,
	"./decrease.mp3": 462933,
	"./ded.mp3": 995932,
	"./dee.mp3": 588705,
	"./deen.mp3": 649373,
	"./deep.mp3": 847667,
	"./deer.mp3": 593729,
	"./deesh.mp3": 62980,
	"./deet.mp3": 249047,
	"./defeated.mp3": 905175,
	"./defend.mp3": 21297,
	"./deff.mp3": 313916,
	"./definite.mp3": 862073,
	"./deflate.mp3": 479018,
	"./deflay.mp3": 331760,
	"./deflo.mp3": 472401,
	"./defloi.mp3": 219862,
	"./deflou.mp3": 887298,
	"./defloy.mp3": 658086,
	"./deform.mp3": 711554,
	"./defraud.mp3": 526366,
	"./defrost.mp3": 238630,
	"./deft.mp3": 688510,
	"./defuse.mp3": 842587,
	"./deg.mp3": 356307,
	"./degenerate.mp3": 790705,
	"./dek.mp3": 926015,
	"./delate.mp3": 478388,
	"./delete.mp3": 45992,
	"./delicate.mp3": 117500,
	"./delicious.mp3": 291076,
	"./delight.mp3": 383412,
	"./delite.mp3": 274060,
	"./delote.mp3": 726946,
	"./delusion.mp3": 676874,
	"./dem.mp3": 965129,
	"./demagogue.mp3": 503001,
	"./democracy.mp3": 895496,
	"./demography.mp3": 840729,
	"./demonstrate.mp3": 176225,
	"./den.mp3": 49366,
	"./dense.mp3": 517022,
	"./dentist.mp3": 168210,
	"./dentures.mp3": 654295,
	"./dep.mp3": 696944,
	"./depart.mp3": 873739,
	"./department.mp3": 701059,
	"./dependable.mp3": 137019,
	"./dephaw.mp3": 117804,
	"./dephew.mp3": 418952,
	"./dephoo.mp3": 865458,
	"./dephow.mp3": 864234,
	"./deport.mp3": 927957,
	"./deporting.mp3": 531715,
	"./depreciate.mp3": 998785,
	"./depreciating.mp3": 153976,
	"./depreciation.mp3": 569010,
	"./depress.mp3": 76377,
	"./depressed.mp3": 261194,
	"./depressing.mp3": 248223,
	"./depth.mp3": 437932,
	"./der.mp3": 233154,
	"./derail.mp3": 887928,
	"./des.mp3": 510663,
	"./descent.mp3": 217541,
	"./descray.mp3": 499782,
	"./describe.mp3": 748010,
	"./described.mp3": 9866,
	"./description.mp3": 846745,
	"./descro.mp3": 304527,
	"./descroi.mp3": 324800,
	"./descrou.mp3": 872596,
	"./descroy.mp3": 772752,
	"./desert.mp3": 526782,
	"./desh.mp3": 370013,
	"./design.mp3": 449495,
	"./designed.mp3": 872320,
	"./designer.mp3": 70974,
	"./desirable.mp3": 833294,
	"./desk.mp3": 925258,
	"./desleke.mp3": 686546,
	"./desperate.mp3": 527776,
	"./desperately.mp3": 394841,
	"./desperation.mp3": 74315,
	"./dessert.mp3": 58801,
	"./destination.mp3": 882095,
	"./destroy.mp3": 735373,
	"./destruct.mp3": 553287,
	"./destruction.mp3": 334207,
	"./destructive.mp3": 754835,
	"./det.mp3": 4652,
	"./determination.mp3": 166682,
	"./determine.mp3": 15776,
	"./determined.mp3": 551972,
	"./develop.mp3": 877340,
	"./developed.mp3": 17067,
	"./developing.mp3": 15348,
	"./development.mp3": 131448,
	"./developmental.mp3": 565523,
	"./device.mp3": 706527,
	"./devil.mp3": 42945,
	"./devise.mp3": 880399,
	"./dew.mp3": 362467,
	"./dex.mp3": 757400,
	"./diagonal.mp3": 263932,
	"./diagram.mp3": 278424,
	"./dialogue.mp3": 826151,
	"./diameter.mp3": 745220,
	"./dice.mp3": 789176,
	"./dich.mp3": 65681,
	"./dictation.mp3": 732240,
	"./dictionary.mp3": 379157,
	"./did.mp3": 792192,
	"./didn't.mp3": 486359,
	"./didnt.mp3": 369502,
	"./die.mp3": 842469,
	"./dieb.mp3": 76989,
	"./died.mp3": 687755,
	"./diel.mp3": 348835,
	"./dif.mp3": 51922,
	"./difference.mp3": 494836,
	"./different.mp3": 562324,
	"./difficult.mp3": 997449,
	"./diffuse.mp3": 806765,
	"./dig.mp3": 556439,
	"./digestible.mp3": 174713,
	"./digestion.mp3": 11550,
	"./digestive.mp3": 874513,
	"./digging.mp3": 302714,
	"./dight.mp3": 844147,
	"./dim.mp3": 28365,
	"./din.mp3": 294842,
	"./dine.mp3": 637151,
	"./dink.mp3": 172993,
	"./dinosaur.mp3": 277704,
	"./dip.mp3": 589068,
	"./direction.mp3": 84380,
	"./dirt.mp3": 726830,
	"./dis.mp3": 559235,
	"./disable.mp3": 829939,
	"./disadvantage.mp3": 964622,
	"./disagree.mp3": 130525,
	"./disappear.mp3": 607196,
	"./disappeared.mp3": 25899,
	"./disappoint.mp3": 598918,
	"./disapprove.mp3": 863318,
	"./disaster.mp3": 567384,
	"./disastrous.mp3": 56144,
	"./disbelieve.mp3": 691553,
	"./disbelieving.mp3": 762008,
	"./disc.mp3": 435702,
	"./discipline.mp3": 209183,
	"./disclosure.mp3": 166790,
	"./discomfort.mp3": 938157,
	"./disconnect.mp3": 114783,
	"./discontinue.mp3": 556884,
	"./discord.mp3": 831383,
	"./discount.mp3": 546060,
	"./discounted.mp3": 193179,
	"./discover.mp3": 344424,
	"./discretionary.mp3": 205739,
	"./discuss.mp3": 682037,
	"./discussion.mp3": 415113,
	"./disease.mp3": 97953,
	"./disguise.mp3": 874244,
	"./dish.mp3": 759233,
	"./dishonest.mp3": 681438,
	"./dislike.mp3": 777018,
	"./dislocate.mp3": 102849,
	"./disobey.mp3": 523938,
	"./disorder.mp3": 924953,
	"./displeasure.mp3": 663262,
	"./disposed.mp3": 703368,
	"./dispossess.mp3": 96601,
	"./dispossessed.mp3": 240970,
	"./dispossessing.mp3": 705503,
	"./disqualify.mp3": 195040,
	"./disrepair.mp3": 639036,
	"./disrespect.mp3": 66715,
	"./disrespectful.mp3": 20392,
	"./disrespecting.mp3": 578421,
	"./disrupt.mp3": 822956,
	"./diss.mp3": 263430,
	"./dissect.mp3": 302158,
	"./dissolve.mp3": 335072,
	"./distance.mp3": 980076,
	"./distract.mp3": 333167,
	"./distraught.mp3": 478562,
	"./distrust.mp3": 453731,
	"./disturbed.mp3": 814489,
	"./dit.mp3": 87120,
	"./dive.mp3": 542103,
	"./diverse.mp3": 524807,
	"./divide.mp3": 228726,
	"./divided.mp3": 766982,
	"./dividend.mp3": 76400,
	"./dividing.mp3": 538499,
	"./division.mp3": 785268,
	"./dizzy.mp3": 918725,
	"./do.mp3": 526674,
	"./doa.mp3": 1987,
	"./doael.mp3": 573860,
	"./doan.mp3": 686999,
	"./docc.mp3": 288796,
	"./dock.mp3": 523044,
	"./docket.mp3": 314435,
	"./document.mp3": 31410,
	"./dod.mp3": 779874,
	"./dodge.mp3": 151846,
	"./dodgem.mp3": 58451,
	"./dodgey.mp3": 212807,
	"./doe.mp3": 384807,
	"./doel.mp3": 451033,
	"./does.mp3": 327538,
	"./dog.mp3": 216501,
	"./dogg.mp3": 55204,
	"./dogs'.mp3": 410659,
	"./dogs.mp3": 582424,
	"./dolhin.mp3": 899891,
	"./doll.mp3": 654658,
	"./dollar.mp3": 822971,
	"./dolphin.mp3": 425135,
	"./dolpin.mp3": 319339,
	"./dolrin.mp3": 682477,
	"./dominais.mp3": 954375,
	"./dominays.mp3": 841367,
	"./dominees.mp3": 650839,
	"./dominoes.mp3": 492121,
	"./dominoys.mp3": 174853,
	"./don't.mp3": 762973,
	"./don.mp3": 813176,
	"./donation.mp3": 318571,
	"./donkair.mp3": 182309,
	"./donkar.mp3": 589602,
	"./donkay.mp3": 82397,
	"./donkey.mp3": 647617,
	"./donkoy.mp3": 67567,
	"./doo.mp3": 425693,
	"./door.mp3": 22197,
	"./dop.mp3": 401582,
	"./dor.mp3": 847100,
	"./dorel.mp3": 126371,
	"./dormant.mp3": 296940,
	"./dorn.mp3": 315962,
	"./dorr.mp3": 11966,
	"./dose.mp3": 943682,
	"./dosloke.mp3": 58078,
	"./dot.mp3": 494674,
	"./double.mp3": 491162,
	"./doubt.mp3": 529617,
	"./dough.mp3": 803866,
	"./dow.mp3": 285221,
	"./dowel.mp3": 842830,
	"./down.mp3": 778801,
	"./downstairs.mp3": 387451,
	"./draft.mp3": 983346,
	"./dragging.mp3": 8858,
	"./dragon.mp3": 726700,
	"./drain.mp3": 592997,
	"./draird.mp3": 816303,
	"./drake.mp3": 443792,
	"./dram.mp3": 980205,
	"./dramatically.mp3": 735080,
	"./dran.mp3": 391834,
	"./drank.mp3": 60577,
	"./drard.mp3": 881054,
	"./draught.mp3": 613120,
	"./draw.mp3": 169095,
	"./drawn.mp3": 794027,
	"./dray.mp3": 678297,
	"./dread.mp3": 930851,
	"./dream.mp3": 572326,
	"./dreary.mp3": 955154,
	"./dred.mp3": 894372,
	"./dree.mp3": 629321,
	"./drem.mp3": 795425,
	"./dress.mp3": 653450,
	"./dresses.mp3": 544138,
	"./drew.mp3": 424459,
	"./drey.mp3": 853781,
	"./dri.mp3": 264932,
	"./dried.mp3": 556531,
	"./dries.mp3": 157968,
	"./drift.mp3": 951130,
	"./drill.mp3": 104492,
	"./drink.mp3": 477033,
	"./drip.mp3": 464388,
	"./driss.mp3": 25230,
	"./drive.mp3": 731999,
	"./droad.mp3": 922997,
	"./droin.mp3": 720135,
	"./dropped.mp3": 338825,
	"./dropping.mp3": 187246,
	"./dross.mp3": 464740,
	"./drought.mp3": 818978,
	"./drove.mp3": 281649,
	"./drown.mp3": 731849,
	"./droy.mp3": 517923,
	"./drum.mp3": 821713,
	"./drunk.mp3": 813469,
	"./dry.mp3": 790324,
	"./dual.mp3": 391635,
	"./dub.mp3": 788834,
	"./ducc.mp3": 36098,
	"./duch.mp3": 436093,
	"./duck.mp3": 698090,
	"./ducket.mp3": 961049,
	"./duct.mp3": 391649,
	"./dud.mp3": 430284,
	"./dude.mp3": 790293,
	"./due.mp3": 945617,
	"./duel.mp3": 286207,
	"./duet.mp3": 870855,
	"./duf.mp3": 773182,
	"./duft.mp3": 752110,
	"./dug.mp3": 553475,
	"./dugg.mp3": 635706,
	"./duhe.mp3": 719569,
	"./dul.mp3": 638676,
	"./dull.mp3": 38752,
	"./duly.mp3": 413041,
	"./dum.mp3": 363897,
	"./dumb.mp3": 695801,
	"./dummy.mp3": 447467,
	"./dump.mp3": 713115,
	"./dun-2.mp3": 432795,
	"./dun.mp3": 246534,
	"./duo.mp3": 185643,
	"./dup.mp3": 90880,
	"./duplex.mp3": 17783,
	"./duplicate.mp3": 634164,
	"./durable.mp3": 286990,
	"./duration.mp3": 719409,
	"./dure.mp3": 158759,
	"./during.mp3": 340870,
	"./durr.mp3": 621052,
	"./dus.mp3": 881303,
	"./dush.mp3": 792653,
	"./dustbin.mp3": 692284,
	"./dut.mp3": 398588,
	"./e -2.mp3": 765823,
	"./e -3.mp3": 56858,
	"./e.mp3": 364542,
	"./eac.mp3": 396482,
	"./each.mp3": 988054,
	"./eager.mp3": 380619,
	"./eah.mp3": 796477,
	"./eak.mp3": 58474,
	"./ear.mp3": 106743,
	"./earl.mp3": 826313,
	"./earlier.mp3": 48891,
	"./early.mp3": 641534,
	"./earn.mp3": 147643,
	"./earnings.mp3": 356152,
	"./earth.mp3": 455451,
	"./earthquake.mp3": 79042,
	"./ease.mp3": 824263,
	"./easily.mp3": 625402,
	"./eat.mp3": 752033,
	"./eb.mp3": 683664,
	"./echo.mp3": 824726,
	"./ecosystem.mp3": 498731,
	"./edge.mp3": 218802,
	"./edited.mp3": 283338,
	"./education.mp3": 478885,
	"./ee -2.mp3": 671516,
	"./ee -3.mp3": 264289,
	"./ee .mp3": 282345,
	"./ee.mp3": 698307,
	"./eech.mp3": 218338,
	"./eek.mp3": 660078,
	"./een.mp3": 257687,
	"./eerie.mp3": 384221,
	"./eese.mp3": 707547,
	"./eet.mp3": 684189,
	"./effect.mp3": 846066,
	"./effortless.mp3": 947928,
	"./egg.mp3": 408800,
	"./eggs.mp3": 504207,
	"./egypt.mp3": 876346,
	"./eight.mp3": 101058,
	"./eighteen.mp3": 866970,
	"./eighth.mp3": 462358,
	"./eighty.mp3": 477707,
	"./either.mp3": 70114,
	"./ekit.mp3": 41162,
	"./election.mp3": 683060,
	"./electrician.mp3": 635208,
	"./elehant.mp3": 392880,
	"./elepant.mp3": 867672,
	"./elephant.mp3": 818858,
	"./elerant.mp3": 409170,
	"./eleven.mp3": 209242,
	"./em.mp3": 330475,
	"./embarassed.mp3": 586890,
	"./embarassing.mp3": 240223,
	"./embarassingly.mp3": 687046,
	"./embarassment.mp3": 388709,
	"./embarrass.mp3": 382391,
	"./embarrassment.mp3": 926607,
	"./empay.mp3": 960527,
	"./employ.mp3": 739583,
	"./empo.mp3": 454056,
	"./empoi.mp3": 188013,
	"./empou.mp3": 928753,
	"./empoy.mp3": 15741,
	"./emray.mp3": 400129,
	"./emro.mp3": 520754,
	"./emroi.mp3": 421579,
	"./emrou.mp3": 147255,
	"./emroy.mp3": 947771,
	"./enclosure.mp3": 226191,
	"./encounter.mp3": 874736,
	"./encourage.mp3": 176584,
	"./encouraged.mp3": 125116,
	"./end.mp3": 718024,
	"./endurance.mp3": 260704,
	"./enduring.mp3": 150087,
	"./energetically.mp3": 393417,
	"./energy.mp3": 209201,
	"./engage.mp3": 887720,
	"./engineer.mp3": 805538,
	"./engines.mp3": 777510,
	"./enjay.mp3": 484472,
	"./enjo.mp3": 640105,
	"./enjoi.mp3": 666574,
	"./enjou.mp3": 34282,
	"./enjoy.mp3": 52190,
	"./enjoyable.mp3": 145258,
	"./enjoyment.mp3": 196382,
	"./enlighten.mp3": 989301,
	"./enlightening.mp3": 830947,
	"./enormous.mp3": 946035,
	"./enough.mp3": 367293,
	"./enpay.mp3": 420062,
	"./enpo.mp3": 825111,
	"./enpoi.mp3": 879208,
	"./enpou .mp3": 761836,
	"./enpoy.mp3": 725496,
	"./enray.mp3": 592384,
	"./enro.mp3": 424993,
	"./enroi.mp3": 555462,
	"./enrou.mp3": 355090,
	"./enroy.mp3": 270262,
	"./ensede.mp3": 951613,
	"./ensleme.mp3": 180960,
	"./ensure.mp3": 16255,
	"./entertainment.mp3": 279533,
	"./entrance.mp3": 353351,
	"./enumerate.mp3": 19649,
	"./envelepe.mp3": 153027,
	"./envelipe.mp3": 300943,
	"./envelope.mp3": 249193,
	"./envelupe.mp3": 503635,
	"./envious.mp3": 225442,
	"./environment.mp3": 434092,
	"./ep.mp3": 979090,
	"./epidemic.mp3": 19235,
	"./equal.mp3": 532319,
	"./equalise.mp3": 293300,
	"./equidistant.mp3": 367024,
	"./equilateral.mp3": 158962,
	"./equip.mp3": 378811,
	"./equiped.mp3": 798644,
	"./equiping.mp3": 572437,
	"./equipment.mp3": 94355,
	"./equipped.mp3": 340146,
	"./erit.mp3": 260987,
	"./esit.mp3": 931714,
	"./especially.mp3": 390430,
	"./essential.mp3": 913263,
	"./evacuate.mp3": 469791,
	"./eve.mp3": 976805,
	"./even.mp3": 389041,
	"./evening.mp3": 778759,
	"./eventually.mp3": 147894,
	"./ever.mp3": 674477,
	"./every.mp3": 307482,
	"./everybody.mp3": 408902,
	"./everyone.mp3": 173554,
	"./everywhere.mp3": 555835,
	"./evidence.mp3": 775186,
	"./evil.mp3": 802103,
	"./exaggerate.mp3": 325120,
	"./exaggerated.mp3": 216708,
	"./exaggeration.mp3": 166891,
	"./exceed.mp3": 133881,
	"./excel.mp3": 182962,
	"./exceling.mp3": 929830,
	"./excellence.mp3": 6651,
	"./excellent.mp3": 114413,
	"./except.mp3": 369126,
	"./excess.mp3": 47780,
	"./excessive.mp3": 999670,
	"./excitable.mp3": 866378,
	"./excite.mp3": 575107,
	"./excited.mp3": 390861,
	"./excitement.mp3": 310299,
	"./exciting.mp3": 593514,
	"./exclaim.mp3": 244734,
	"./exclude.mp3": 445209,
	"./exercise.mp3": 619131,
	"./exglede.mp3": 590301,
	"./exglide.mp3": 218833,
	"./exglode.mp3": 849599,
	"./exglude.mp3": 437165,
	"./exhale.mp3": 851386,
	"./exhilarate.mp3": 838216,
	"./exist.mp3": 340150,
	"./existed.mp3": 851909,
	"./existence.mp3": 274511,
	"./existing.mp3": 721426,
	"./exit.mp3": 122381,
	"./expansion.mp3": 865132,
	"./expectant.mp3": 494213,
	"./expectation.mp3": 684813,
	"./expense.mp3": 658639,
	"./expensive.mp3": 743172,
	"./experience.mp3": 655061,
	"./experienced.mp3": 412443,
	"./experiences.mp3": 395896,
	"./experiment.mp3": 5288,
	"./experimenting.mp3": 633944,
	"./expert.mp3": 633709,
	"./expertise.mp3": 668762,
	"./expertly.mp3": 478804,
	"./explained.mp3": 257669,
	"./explaining.mp3": 857170,
	"./explanation.mp3": 657066,
	"./explosion.mp3": 815558,
	"./export.mp3": 227287,
	"./exporting.mp3": 480089,
	"./express.mp3": 553971,
	"./expression.mp3": 764787,
	"./expressive.mp3": 710023,
	"./extension.mp3": 47772,
	"./exterminate.mp3": 430303,
	"./extermination.mp3": 700456,
	"./extortionate.mp3": 797857,
	"./extra-ordinary.mp3": 527172,
	"./extra.mp3": 474361,
	"./extraneous.mp3": 21329,
	"./extraordinary.mp3": 741603,
	"./extraterrestrial.mp3": 729616,
	"./extreme.mp3": 429483,
	"./extremely.mp3": 600218,
	"./extremities.mp3": 50958,
	"./extremity.mp3": 347382,
	"./eye.mp3": 348084,
	"./eyes.mp3": 846059,
	"./f-2.mp3": 189492,
	"./f.mp3": 536977,
	"./fable.mp3": 115749,
	"./face.mp3": 930086,
	"./facial.mp3": 136789,
	"./fack.mp3": 802288,
	"./facket.mp3": 358623,
	"./fact.mp3": 696251,
	"./fad.mp3": 474670,
	"./faf.mp3": 403836,
	"./fag.mp3": 900609,
	"./fai.mp3": 237919,
	"./faid.mp3": 404569,
	"./fail.mp3": 447217,
	"./faim.mp3": 389356,
	"./faip.mp3": 706477,
	"./fair.mp3": 827071,
	"./fait.mp3": 349833,
	"./fal.mp3": 966582,
	"./fall.mp3": 365886,
	"./falsehood.mp3": 406528,
	"./falt.mp3": 342134,
	"./fam.mp3": 928987,
	"./familiar.mp3": 260100,
	"./familiarise.mp3": 334741,
	"./familiarise_2.mp3": 764590,
	"./families.mp3": 93053,
	"./family.mp3": 590069,
	"./famous.mp3": 348205,
	"./fan.mp3": 382020,
	"./fancy.mp3": 568148,
	"./fang.mp3": 768015,
	"./fantastic.mp3": 798004,
	"./fao.mp3": 396009,
	"./faop.mp3": 6667,
	"./fap.mp3": 336610,
	"./far.mp3": 86608,
	"./fare.mp3": 990809,
	"./farmer.mp3": 556732,
	"./farmland.mp3": 575574,
	"./farmland_2.mp3": 951393,
	"./farmyard.mp3": 827449,
	"./farst.mp3": 194985,
	"./fart.mp3": 717476,
	"./farther.mp3": 127965,
	"./fascinate.mp3": 323931,
	"./fashionable.mp3": 602735,
	"./fass.mp3": 275928,
	"./fast.mp3": 583243,
	"./fasten.mp3": 711982,
	"./fat.mp3": 990334,
	"./father.mp3": 195183,
	"./fatherhood.mp3": 973033,
	"./fatigue.mp3": 288592,
	"./fatigue_2.mp3": 111131,
	"./fatter.mp3": 840123,
	"./fattest.mp3": 162326,
	"./fault.mp3": 972219,
	"./fave.mp3": 628373,
	"./favourable.mp3": 440546,
	"./favourable_2.mp3": 726933,
	"./favoured.mp3": 352501,
	"./favoured_2.mp3": 573966,
	"./favouring.mp3": 129058,
	"./favouring_2.mp3": 979285,
	"./favourite.mp3": 977682,
	"./favouritism.mp3": 344838,
	"./favouritism_2.mp3": 941585,
	"./faw.mp3": 162769,
	"./fax.mp3": 537674,
	"./fay.mp3": 763311,
	"./fe.mp3": 771506,
	"./fear.mp3": 691851,
	"./fearless.mp3": 245320,
	"./feast.mp3": 541606,
	"./feat.mp3": 81085,
	"./feather.mp3": 764198,
	"./feature.mp3": 169929,
	"./feb.mp3": 466220,
	"./february.mp3": 9879,
	"./feck.mp3": 289028,
	"./fed.mp3": 694722,
	"./fee.mp3": 972231,
	"./feebe.mp3": 619692,
	"./feed.mp3": 512529,
	"./feek.mp3": 887434,
	"./feel.mp3": 261433,
	"./feem.mp3": 205588,
	"./feep.mp3": 708069,
	"./feet.mp3": 250369,
	"./fef.mp3": 158512,
	"./feg.mp3": 439253,
	"./fel.mp3": 873066,
	"./felf.mp3": 226360,
	"./felfet.mp3": 853959,
	"./fell.mp3": 193058,
	"./felt.mp3": 150778,
	"./fem.mp3": 835215,
	"./fen.mp3": 735320,
	"./fence.mp3": 294348,
	"./fep.mp3": 835982,
	"./ferocious.mp3": 443778,
	"./fertilise.mp3": 827448,
	"./fess.mp3": 244860,
	"./fet.mp3": 357938,
	"./fetch.mp3": 439195,
	"./fete.mp3": 834439,
	"./feve.mp3": 378313,
	"./few.mp3": 125509,
	"./ff.mp3": 539077,
	"./fib.mp3": 894104,
	"./fibe.mp3": 81649,
	"./fic.mp3": 616829,
	"./ficc.mp3": 797472,
	"./fich.mp3": 162111,
	"./fict.mp3": 471715,
	"./fiction.mp3": 933379,
	"./fictitious.mp3": 805880,
	"./fid.mp3": 987622,
	"./field.mp3": 167043,
	"./fiend.mp3": 652761,
	"./fierce.mp3": 741739,
	"./fiery.mp3": 177676,
	"./fif.mp3": 222900,
	"./fiff.mp3": 682746,
	"./fift.mp3": 300856,
	"./fifteen.mp3": 372824,
	"./fig.mp3": 699097,
	"./figg.mp3": 318360,
	"./fight.mp3": 540477,
	"./fights.mp3": 625136,
	"./fik.mp3": 656917,
	"./fill.mp3": 90918,
	"./filthy.mp3": 64579,
	"./fim.mp3": 594704,
	"./fin.mp3": 683884,
	"./final.mp3": 878591,
	"./finalise.mp3": 929876,
	"./finally.mp3": 98470,
	"./find.mp3": 90128,
	"./fine.mp3": 166261,
	"./finich.mp3": 238492,
	"./finif.mp3": 358941,
	"./finig.mp3": 746424,
	"./finis.mp3": 242180,
	"./finish.mp3": 664876,
	"./finish_2.mp3": 135455,
	"./finishes.mp3": 569624,
	"./finishes_2.mp3": 667347,
	"./finishing.mp3": 828964,
	"./finishing_2.mp3": 950791,
	"./finite.mp3": 863604,
	"./finite_2.mp3": 991748,
	"./finiz.mp3": 760769,
	"./fip.mp3": 870106,
	"./fir.mp3": 686344,
	"./fire.mp3": 738625,
	"./firm.mp3": 903401,
	"./firr.mp3": 301474,
	"./first.mp3": 536481,
	"./firt.mp3": 942924,
	"./fis.mp3": 815277,
	"./fish.mp3": 358031,
	"./fisit.mp3": 675194,
	"./fiss.mp3": 188960,
	"./fist.mp3": 857043,
	"./fit.mp3": 702422,
	"./fite.mp3": 760075,
	"./five.mp3": 474013,
	"./fix.mp3": 575602,
	"./fiz.mp3": 698080,
	"./fizz.mp3": 2114,
	"./flag.mp3": 364163,
	"./flame.mp3": 505290,
	"./flapping.mp3": 656392,
	"./flare.mp3": 342247,
	"./flash.mp3": 492493,
	"./flask.mp3": 89594,
	"./flaw.mp3": 290611,
	"./flea.mp3": 352393,
	"./fleme.mp3": 797382,
	"./flew.mp3": 456463,
	"./flexible.mp3": 87340,
	"./flies.mp3": 633060,
	"./flies_2.mp3": 771719,
	"./flime.mp3": 986962,
	"./fling.mp3": 475057,
	"./flo.mp3": 423422,
	"./flock.mp3": 863648,
	"./flog.mp3": 824145,
	"./flome.mp3": 306400,
	"./floo.mp3": 242425,
	"./floor.mp3": 447081,
	"./floppy.mp3": 624143,
	"./floss.mp3": 57672,
	"./flout.mp3": 27661,
	"./flow.mp3": 104513,
	"./flu.mp3": 815108,
	"./flug.mp3": 178575,
	"./flume.mp3": 440438,
	"./flung.mp3": 157317,
	"./flush.mp3": 262073,
	"./flute.mp3": 798593,
	"./fly.mp3": 741120,
	"./fo.mp3": 882248,
	"./foa.mp3": 121317,
	"./foad.mp3": 90507,
	"./foak.mp3": 722736,
	"./foal.mp3": 904611,
	"./foam.mp3": 912670,
	"./foap.mp3": 468159,
	"./foat.mp3": 616699,
	"./fobe.mp3": 917287,
	"./foch.mp3": 551181,
	"./fock.mp3": 817658,
	"./foct.mp3": 169745,
	"./fod.mp3": 378748,
	"./foe.mp3": 206145,
	"./fog.mp3": 460083,
	"./foi.mp3": 976589,
	"./foil.mp3": 826347,
	"./foind.mp3": 988399,
	"./foit.mp3": 934899,
	"./fol.mp3": 687556,
	"./follow.mp3": 375946,
	"./fom .mp3": 807035,
	"./fon.mp3": 398966,
	"./fond.mp3": 759686,
	"./fong.mp3": 877049,
	"./foo.mp3": 208347,
	"./food.mp3": 962581,
	"./fook.mp3": 988838,
	"./foolishness.mp3": 944166,
	"./foom.mp3": 742296,
	"./foop.mp3": 573601,
	"./foot.mp3": 648837,
	"./football.mp3": 504450,
	"./fop.mp3": 35344,
	"./for.mp3": 285346,
	"./forcible.mp3": 19261,
	"./foreign.mp3": 121479,
	"./foreseeable.mp3": 453684,
	"./forgetful.mp3": 241963,
	"./forgetting.mp3": 729890,
	"./forgive.mp3": 936377,
	"./forgotten.mp3": 508889,
	"./forgotten_2.mp3": 658954,
	"./fork.mp3": 480489,
	"./form.mp3": 779871,
	"./forp.mp3": 862910,
	"./forst.mp3": 984711,
	"./fort.mp3": 878562,
	"./forty.mp3": 630699,
	"./forward.mp3": 147240,
	"./forwards.mp3": 50119,
	"./forwards_2.mp3": 862536,
	"./fossil.mp3": 923981,
	"./fot.mp3": 410444,
	"./fote.mp3": 548821,
	"./fou.mp3": 442129,
	"./fought.mp3": 744564,
	"./fought_2.mp3": 19095,
	"./found.mp3": 923747,
	"./foundation.mp3": 356882,
	"./foundations.mp3": 884993,
	"./four.mp3": 181233,
	"./fourteen.mp3": 443681,
	"./fout.mp3": 629383,
	"./fove.mp3": 594691,
	"./fow.mp3": 533635,
	"./fowl.mp3": 941861,
	"./fox.mp3": 191800,
	"./foy.mp3": 261789,
	"./fra.mp3": 601537,
	"./fraction.mp3": 863771,
	"./fracture.mp3": 820143,
	"./fraird.mp3": 272089,
	"./frantically.mp3": 487658,
	"./frard.mp3": 368404,
	"./fraught.mp3": 65982,
	"./frech.mp3": 778491,
	"./fred.mp3": 109218,
	"./free.mp3": 714151,
	"./freeze.mp3": 421268,
	"./fref.mp3": 859216,
	"./freg.mp3": 62197,
	"./freight.mp3": 438118,
	"./frequency.mp3": 872117,
	"./frequent.mp3": 966275,
	"./frequently.mp3": 767090,
	"./frequently_2.mp3": 863013,
	"./fres.mp3": 673217,
	"./fresh.mp3": 974411,
	"./fresher.mp3": 425994,
	"./freshest.mp3": 591065,
	"./fri.mp3": 985206,
	"./frick.mp3": 162280,
	"./friday.mp3": 742112,
	"./fridge.mp3": 828186,
	"./fried.mp3": 159941,
	"./friend.mp3": 891961,
	"./friends.mp3": 548804,
	"./fries.mp3": 713502,
	"./fright.mp3": 67997,
	"./frightened.mp3": 17715,
	"./fringe.mp3": 331276,
	"./frisky.mp3": 774925,
	"./frith.mp3": 535202,
	"./froad.mp3": 944043,
	"./frock.mp3": 994778,
	"./frog.mp3": 202003,
	"./from.mp3": 294473,
	"./frond.mp3": 96870,
	"./frost.mp3": 487361,
	"./froth.mp3": 452244,
	"./frug.mp3": 27749,
	"./fruit.mp3": 817029,
	"./fruitful.mp3": 709650,
	"./fruitful_2.mp3": 633733,
	"./fruition.mp3": 528313,
	"./fruition_2.mp3": 252650,
	"./fruitless.mp3": 131218,
	"./fruitless_2.mp3": 288773,
	"./fruitlessly.mp3": 278163,
	"./fruitlessly_2.mp3": 873276,
	"./fruity.mp3": 358738,
	"./fruity_2.mp3": 990213,
	"./fry.mp3": 812934,
	"./fube.mp3": 666565,
	"./fuch.mp3": 296491,
	"./fudge.mp3": 146678,
	"./fuel.mp3": 958089,
	"./fuf .mp3": 200072,
	"./fug.mp3": 919749,
	"./fuil.mp3": 698013,
	"./fuind.mp3": 482313,
	"./fuit.mp3": 557541,
	"./fulfil.mp3": 680043,
	"./full.mp3": 879666,
	"./fume.mp3": 272724,
	"./fun.mp3": 746568,
	"./function.mp3": 524109,
	"./fund.mp3": 362556,
	"./funnily.mp3": 777742,
	"./funny.mp3": 677911,
	"./fup.mp3": 473310,
	"./fur.mp3": 260460,
	"./furious.mp3": 239700,
	"./furniture.mp3": 46345,
	"./furp.mp3": 401212,
	"./further.mp3": 735385,
	"./fury.mp3": 393385,
	"./fus.mp3": 106417,
	"./fush.mp3": 778395,
	"./fuss.mp3": 980492,
	"./fust.mp3": 943975,
	"./fut.mp3": 488962,
	"./future.mp3": 819004,
	"./fuzz.mp3": 313726,
	"./g -2.mp3": 618741,
	"./g -3.mp3": 932112,
	"./g.mp3": 479116,
	"./gack.mp3": 657883,
	"./gacket.mp3": 487492,
	"./gad.mp3": 98391,
	"./gaft.mp3": 328955,
	"./gag.mp3": 791616,
	"./gaid.mp3": 955590,
	"./gail.mp3": 482238,
	"./gais.mp3": 705485,
	"./gait.mp3": 127862,
	"./gal.mp3": 907231,
	"./gam.mp3": 294266,
	"./game.mp3": 947487,
	"./gan.mp3": 697165,
	"./gap.mp3": 254211,
	"./gaptop.mp3": 887204,
	"./garden.mp3": 653978,
	"./gardener.mp3": 534495,
	"./gardening.mp3": 384382,
	"./gare.mp3": 210994,
	"./garl.mp3": 756991,
	"./gas.mp3": 131020,
	"./gasp.mp3": 762972,
	"./gat.mp3": 94503,
	"./gaunt.mp3": 902124,
	"./gave.mp3": 39126,
	"./geal.mp3": 735698,
	"./gear.mp3": 540116,
	"./gecko.mp3": 143742,
	"./ged.mp3": 630235,
	"./geed.mp3": 615814,
	"./gees.mp3": 391885,
	"./geese.mp3": 115198,
	"./geet.mp3": 814262,
	"./geg.mp3": 83268,
	"./gel.mp3": 186419,
	"./gelf.mp3": 137007,
	"./gell.mp3": 146933,
	"./gelp.mp3": 769705,
	"./gem.mp3": 175918,
	"./geme.mp3": 296403,
	"./gen.mp3": 601857,
	"./generally.mp3": 86758,
	"./generate.mp3": 139852,
	"./generation.mp3": 227199,
	"./genetic.mp3": 520894,
	"./gentle.mp3": 57338,
	"./gently.mp3": 753342,
	"./gently_2.mp3": 47673,
	"./genuinely.mp3": 62709,
	"./geography.mp3": 683037,
	"./geology.mp3": 579947,
	"./geometry.mp3": 318309,
	"./gestate.mp3": 838108,
	"./gestate_2.mp3": 765967,
	"./gesture.mp3": 849806,
	"./gesture_2.mp3": 95177,
	"./get.mp3": 561515,
	"./getting.mp3": 565315,
	"./ghost.mp3": 424802,
	"./giant.mp3": 961008,
	"./gid.mp3": 536463,
	"./gift.mp3": 257443,
	"./gig.mp3": 436568,
	"./giggle.mp3": 195334,
	"./gil-2.mp3": 234406,
	"./gil.mp3": 673479,
	"./gild.mp3": 501009,
	"./gill.mp3": 249913,
	"./gilt.mp3": 238849,
	"./gime.mp3": 848055,
	"./gin.mp3": 140501,
	"./ginger.mp3": 122773,
	"./gingerly.mp3": 146492,
	"./gip.mp3": 753723,
	"./giraffe.mp3": 410495,
	"./girl's.mp3": 541013,
	"./girl.mp3": 737623,
	"./girls'.mp3": 406885,
	"./girls.mp3": 983266,
	"./give.mp3": 699294,
	"./glamorous.mp3": 577364,
	"./glar.mp3": 204637,
	"./glare.mp3": 421102,
	"./glass.mp3": 471127,
	"./glasses.mp3": 518083,
	"./glay.mp3": 558818,
	"./gleaming.mp3": 99221,
	"./glear.mp3": 677808,
	"./glee.mp3": 55954,
	"./gley.mp3": 951878,
	"./glide.mp3": 956568,
	"./glimpse.mp3": 970666,
	"./globe.mp3": 547896,
	"./glorious.mp3": 943259,
	"./gloss.mp3": 885541,
	"./glow.mp3": 1570,
	"./glue.mp3": 444322,
	"./gluw.mp3": 899392,
	"./gnat.mp3": 846933,
	"./gnaw.mp3": 618754,
	"./gnome.mp3": 783219,
	"./gnomes.mp3": 339382,
	"./go.mp3": 701199,
	"./goa.mp3": 46760,
	"./goad.mp3": 516892,
	"./goal.mp3": 234788,
	"./goat.mp3": 9260,
	"./gock.mp3": 886401,
	"./god.mp3": 72169,
	"./goes.mp3": 758907,
	"./gog.mp3": 100214,
	"./going.mp3": 465889,
	"./gol.mp3": 907393,
	"./gold.mp3": 992775,
	"./golt.mp3": 968055,
	"./gome.mp3": 847077,
	"./gone.mp3": 206584,
	"./good.mp3": 73486,
	"./gor.mp3": 896943,
	"./gorgeous.mp3": 912362,
	"./gorl.mp3": 160225,
	"./got.mp3": 561657,
	"./goulash.mp3": 499168,
	"./government.mp3": 304252,
	"./gown.mp3": 966204,
	"./gows.mp3": 544797,
	"./goys.mp3": 644415,
	"./grabbing.mp3": 136409,
	"./grace.mp3": 501927,
	"./gracious.mp3": 768010,
	"./gradually.mp3": 241804,
	"./grahics.mp3": 895588,
	"./grammar.mp3": 330836,
	"./grammatical.mp3": 851649,
	"./grammatical_2.mp3": 662210,
	"./gran.mp3": 33499,
	"./grandad.mp3": 608506,
	"./grander.mp3": 162664,
	"./grandest.mp3": 908147,
	"./graph.mp3": 678711,
	"./graphical.mp3": 526204,
	"./graphics.mp3": 789282,
	"./grapics.mp3": 699788,
	"./grarics.mp3": 509394,
	"./grasp.mp3": 447550,
	"./grass.mp3": 619985,
	"./grassland.mp3": 346742,
	"./grassland_2.mp3": 994113,
	"./grate.mp3": 599730,
	"./graw.mp3": 94846,
	"./great.mp3": 260568,
	"./greedily.mp3": 515752,
	"./green.mp3": 503750,
	"./greenhouse.mp3": 471078,
	"./grew.mp3": 78586,
	"./grey.mp3": 188092,
	"./grey_2.mp3": 770735,
	"./grief.mp3": 568890,
	"./grill.mp3": 522143,
	"./grit.mp3": 748873,
	"./griy.mp3": 471968,
	"./groan.mp3": 932652,
	"./groind.mp3": 907864,
	"./grond.mp3": 295467,
	"./groo.mp3": 29216,
	"./gross.mp3": 346027,
	"./ground.mp3": 453556,
	"./group.mp3": 895094,
	"./grow.mp3": 98392,
	"./grown.mp3": 467622,
	"./growth.mp3": 591972,
	"./growth_2.mp3": 927239,
	"./grue.mp3": 747240,
	"./gruff.mp3": 270539,
	"./gruind.mp3": 779834,
	"./grumpily.mp3": 939684,
	"./grumpy.mp3": 529805,
	"./grund.mp3": 943553,
	"./gruw.mp3": 888138,
	"./guarantee.mp3": 617,
	"./guard.mp3": 275960,
	"./guard_2.mp3": 844019,
	"./guardian.mp3": 796152,
	"./guardian_2.mp3": 631475,
	"./guess.mp3": 773136,
	"./guess_2.mp3": 249371,
	"./guessed.mp3": 219727,
	"./guest.mp3": 245251,
	"./guest_2.mp3": 858668,
	"./guidance.mp3": 795431,
	"./guidance_2.mp3": 642408,
	"./guide.mp3": 385127,
	"./guilt.mp3": 519178,
	"./guilt_2.mp3": 219053,
	"./guilty.mp3": 648531,
	"./guitar.mp3": 96795,
	"./guitar_2.mp3": 855636,
	"./gulp.mp3": 756153,
	"./gume.mp3": 855619,
	"./gurd.mp3": 269379,
	"./gym.mp3": 176082,
	"./gym_2.mp3": 721989,
	"./h -2.mp3": 279256,
	"./h -3.mp3": 638653,
	"./h.mp3": 653871,
	"./hach.mp3": 203405,
	"./hack.mp3": 953530,
	"./had.mp3": 654972,
	"./haft.mp3": 606494,
	"./hag.mp3": 736307,
	"./hai.mp3": 252813,
	"./haid.mp3": 660675,
	"./haif.mp3": 264721,
	"./haik.mp3": 471864,
	"./hail.mp3": 962219,
	"./hain.mp3": 13625,
	"./haint.mp3": 992351,
	"./hainted.mp3": 405672,
	"./hair.mp3": 943909,
	"./half.mp3": 31338,
	"./halp.mp3": 366372,
	"./halt.mp3": 838856,
	"./ham.mp3": 647145,
	"./hammair.mp3": 177182,
	"./hammare.mp3": 72832,
	"./hammer.mp3": 551319,
	"./hammerer.mp3": 770366,
	"./han.mp3": 675190,
	"./hand.mp3": 895558,
	"./hang.mp3": 12921,
	"./hant.mp3": 67830,
	"./hanted.mp3": 972741,
	"./haot.mp3": 784709,
	"./hapless.mp3": 212023,
	"./hapless_2.mp3": 777656,
	"./happened.mp3": 736238,
	"./happening.mp3": 955003,
	"./happier.mp3": 631104,
	"./happier_2.mp3": 554187,
	"./happiest.mp3": 962747,
	"./happily.mp3": 279284,
	"./happiness.mp3": 691668,
	"./happy.mp3": 678941,
	"./har.mp3": 561570,
	"./harass.mp3": 798285,
	"./harass_2.mp3": 163382,
	"./harassed.mp3": 308094,
	"./harassed_2.mp3": 633977,
	"./harassment.mp3": 460153,
	"./harassment_2.mp3": 411434,
	"./hard.mp3": 576210,
	"./harder.mp3": 130679,
	"./hardest.mp3": 248114,
	"./hardness.mp3": 587635,
	"./hare.mp3": 623255,
	"./has.mp3": 166503,
	"./hase.mp3": 701996,
	"./hasn't.mp3": 847890,
	"./hat.mp3": 686668,
	"./hatch.mp3": 947489,
	"./haunt.mp3": 90131,
	"./haunted.mp3": 675756,
	"./have.mp3": 246915,
	"./hax.mp3": 468024,
	"./hay.mp3": 538013,
	"./hazardous.mp3": 364784,
	"./he'll.mp3": 839663,
	"./he.mp3": 390436,
	"./he_s.mp3": 695682,
	"./head.mp3": 82159,
	"./headphones.mp3": 528672,
	"./heal.mp3": 260391,
	"./healed.mp3": 488592,
	"./healed_2.mp3": 123739,
	"./healing.mp3": 687241,
	"./healing_2.mp3": 63674,
	"./heals.mp3": 65778,
	"./heals_2.mp3": 610277,
	"./health.mp3": 74475,
	"./health_2.mp3": 56292,
	"./healthiest.mp3": 838500,
	"./healthiest_2.mp3": 264071,
	"./healthy.mp3": 257332,
	"./healthy_2.mp3": 276695,
	"./hear.mp3": 257385,
	"./hear_2.mp3": 511706,
	"./heard.mp3": 751231,
	"./heard_2.mp3": 666960,
	"./hears.mp3": 911412,
	"./hears_2.mp3": 143703,
	"./heart.mp3": 225039,
	"./heat.mp3": 556767,
	"./heb.mp3": 970758,
	"./hedge.mp3": 883048,
	"./hedges.mp3": 966343,
	"./hee.mp3": 217757,
	"./heed.mp3": 835955,
	"./heef.mp3": 251393,
	"./heege.mp3": 473957,
	"./heek.mp3": 721384,
	"./heel.mp3": 796123,
	"./heese.mp3": 391321,
	"./heet.mp3": 909507,
	"./heft.mp3": 230554,
	"./height.mp3": 8628,
	"./heir.mp3": 973553,
	"./hel.mp3": 805584,
	"./held.mp3": 108660,
	"./helhet.mp3": 494111,
	"./hell.mp3": 900268,
	"./help.mp3": 386376,
	"./helpful.mp3": 69765,
	"./heme.mp3": 492566,
	"./hemisphere.mp3": 474501,
	"./hemp.mp3": 300495,
	"./hen.mp3": 55586,
	"./her.mp3": 685558,
	"./herd.mp3": 552006,
	"./herd_2.mp3": 28433,
	"./here's.mp3": 971745,
	"./here.mp3": 160491,
	"./here_2.mp3": 176612,
	"./here_s_2.mp3": 432570,
	"./heroically.mp3": 811499,
	"./hesitancy.mp3": 637193,
	"./hesitant.mp3": 320279,
	"./hesitation.mp3": 317931,
	"./hest.mp3": 136709,
	"./het.mp3": 89576,
	"./hexagon.mp3": 440919,
	"./hexagram.mp3": 264408,
	"./hey.mp3": 619585,
	"./hic.mp3": 412543,
	"./hich.mp3": 118581,
	"./hicked.mp3": 883265,
	"./hicken.mp3": 885467,
	"./hide.mp3": 337437,
	"./hideous.mp3": 133216,
	"./hient.mp3": 299387,
	"./hiented.mp3": 718708,
	"./hig.mp3": 103611,
	"./hige.mp3": 883664,
	"./high.mp3": 708729,
	"./highland.mp3": 668734,
	"./highland_2.mp3": 755385,
	"./highly.mp3": 246728,
	"./hike.mp3": 917340,
	"./hiked.mp3": 926112,
	"./hiker.mp3": 608414,
	"./hiking.mp3": 226553,
	"./hild.mp3": 619296,
	"./hill.mp3": 421832,
	"./hilt.mp3": 111664,
	"./him.mp3": 432033,
	"./hime.mp3": 184930,
	"./himney.mp3": 62159,
	"./hin.mp3": 344590,
	"./hinder.mp3": 143675,
	"./hinder_2.mp3": 872180,
	"./hinderance.mp3": 156682,
	"./hinderance_2.mp3": 858093,
	"./hindered.mp3": 956980,
	"./hindered_2.mp3": 395159,
	"./hindering.mp3": 11989,
	"./hindering_2.mp3": 742638,
	"./hindmost.mp3": 720111,
	"./hindmost_2.mp3": 250432,
	"./hindrance.mp3": 110301,
	"./hindsight.mp3": 464881,
	"./hindsight_2.mp3": 287026,
	"./hinge.mp3": 102210,
	"./hip.mp3": 727576,
	"./hire.mp3": 127279,
	"./hirp.mp3": 814198,
	"./his.mp3": 369999,
	"./hisit.mp3": 247188,
	"./hiskers.mp3": 163010,
	"./hisper.mp3": 342256,
	"./historian.mp3": 28754,
	"./historian_2.mp3": 353861,
	"./historians.mp3": 675201,
	"./historians_2.mp3": 949186,
	"./historic.mp3": 487398,
	"./historic_2.mp3": 526833,
	"./historical.mp3": 575185,
	"./historical_2.mp3": 384786,
	"./historically.mp3": 664640,
	"./historically_2.mp3": 431563,
	"./history.mp3": 969315,
	"./hit.mp3": 572724,
	"./hive.mp3": 562875,
	"./ho.mp3": 687694,
	"./hoad.mp3": 800833,
	"./hoaf.mp3": 538419,
	"./hoak.mp3": 652026,
	"./hoat.mp3": 520465,
	"./hockey.mp3": 291246,
	"./hod.mp3": 750894,
	"./hoe.mp3": 761395,
	"./hof.mp3": 680060,
	"./hog.mp3": 176833,
	"./hoge.mp3": 289410,
	"./hok.mp3": 820429,
	"./hol.mp3": 242806,
	"./hold.mp3": 763206,
	"./hole.mp3": 888043,
	"./hologram.mp3": 980808,
	"./hologram_2.mp3": 630147,
	"./home.mp3": 897264,
	"./honey.mp3": 373290,
	"./honk.mp3": 409059,
	"./hood.mp3": 520191,
	"./hoof.mp3": 399597,
	"./hook.mp3": 590108,
	"./hoose.mp3": 878861,
	"./hoot.mp3": 451471,
	"./hop.mp3": 612834,
	"./hope.mp3": 160279,
	"./hopeful.mp3": 831780,
	"./hopeless.mp3": 497444,
	"./hopping.mp3": 341034,
	"./hor.mp3": 362832,
	"./horrible.mp3": 695614,
	"./horribly.mp3": 515962,
	"./horse.mp3": 972244,
	"./horses.mp3": 870795,
	"./horses_2.mp3": 356036,
	"./hort.mp3": 853348,
	"./hospital.mp3": 983255,
	"./hot.mp3": 266558,
	"./hotel.mp3": 961061,
	"./hound.mp3": 792449,
	"./hour.mp3": 337067,
	"./house.mp3": 387739,
	"./house_2.mp3": 46164,
	"./how.mp3": 438993,
	"./howl.mp3": 233983,
	"./hoy.mp3": 39535,
	"./huch.mp3": 591961,
	"./hue.mp3": 829389,
	"./huf.mp3": 426490,
	"./huff.mp3": 955112,
	"./huft.mp3": 638538,
	"./hug.mp3": 39455,
	"./huge.mp3": 333428,
	"./hugging.mp3": 907298,
	"./huhh.mp3": 502212,
	"./hum.mp3": 974117,
	"./human.mp3": 139216,
	"./humanity.mp3": 575092,
	"./humanly.mp3": 202025,
	"./humbly.mp3": 887236,
	"./hume.mp3": 133286,
	"./hummed.mp3": 513773,
	"./humming.mp3": 822218,
	"./humorous.mp3": 924425,
	"./humorous_2.mp3": 333306,
	"./hump.mp3": 55359,
	"./hun.mp3": 183570,
	"./hund.mp3": 899554,
	"./hungry.mp3": 37290,
	"./hunt.mp3": 614354,
	"./hunted.mp3": 22513,
	"./hunter.mp3": 903415,
	"./hunting.mp3": 228230,
	"./hupp.mp3": 909300,
	"./hurl.mp3": 635758,
	"./hurt.mp3": 929222,
	"./hus.mp3": 534955,
	"./hush.mp3": 119561,
	"./huss.mp3": 67486,
	"./hustle.mp3": 105336,
	"./hut.mp3": 44600,
	"./hutch.mp3": 248893,
	"./hymn.mp3": 710317,
	"./i -2.mp3": 66171,
	"./i -3.mp3": 498454,
	"./i -4.mp3": 127661,
	"./i -5.mp3": 482376,
	"./i -6.mp3": 375103,
	"./i .mp3": 801190,
	"./i'll.mp3": 46109,
	"./i'm.mp3": 812950,
	"./i've.mp3": 248914,
	"./i.mp3": 428234,
	"./i1.mp3": 871803,
	"./i2.mp3": 27428,
	"./ice.mp3": 850538,
	"./icicle.mp3": 473976,
	"./icing.mp3": 534047,
	"./icy.mp3": 813454,
	"./identical.mp3": 451182,
	"./identifiable.mp3": 775665,
	"./identified.mp3": 33870,
	"./identify.mp3": 403981,
	"./identity.mp3": 947459,
	"./iethor.mp3": 438780,
	"./if.mp3": 39448,
	"./igh.mp3": 556543,
	"./ignorance.mp3": 224687,
	"./ih.mp3": 525726,
	"./ill.mp3": 857242,
	"./illegal.mp3": 773617,
	"./illegible.mp3": 773274,
	"./illegibly.mp3": 926750,
	"./illiterate.mp3": 887704,
	"./illogical.mp3": 840799,
	"./illusion.mp3": 703960,
	"./im.mp3": 123335,
	"./image.mp3": 195136,
	"./imagery.mp3": 234387,
	"./imagination.mp3": 919457,
	"./imaginative.mp3": 784929,
	"./imagine.mp3": 648823,
	"./imagining.mp3": 440790,
	"./immaterial.mp3": 648204,
	"./immature.mp3": 536539,
	"./immeasurable.mp3": 190596,
	"./immediate.mp3": 228220,
	"./immediately.mp3": 618813,
	"./immense.mp3": 349533,
	"./immigrate.mp3": 681126,
	"./immortal.mp3": 976742,
	"./impartial.mp3": 375034,
	"./impatient.mp3": 723142,
	"./imperfect.mp3": 819862,
	"./implant.mp3": 859362,
	"./impolite.mp3": 208360,
	"./import.mp3": 237278,
	"./important.mp3": 420309,
	"./importantly.mp3": 798268,
	"./impossible.mp3": 614922,
	"./impossibly.mp3": 551918,
	"./impress.mp3": 4008,
	"./impresses.mp3": 409468,
	"./impression.mp3": 671314,
	"./impressive.mp3": 841314,
	"./improve.mp3": 228431,
	"./in.mp3": 5168,
	"./inactive.mp3": 197990,
	"./incident.mp3": 931087,
	"./incidental.mp3": 145956,
	"./incidentally.mp3": 261829,
	"./incidents.mp3": 612682,
	"./include.mp3": 910103,
	"./income.mp3": 488816,
	"./incomplete.mp3": 640289,
	"./inconvenience.mp3": 381541,
	"./inconvenient.mp3": 990759,
	"./incorrect.mp3": 339546,
	"./increase.mp3": 820509,
	"./incredible.mp3": 700328,
	"./incredibly.mp3": 434636,
	"./indefinite.mp3": 910676,
	"./independence.mp3": 445291,
	"./independent.mp3": 892381,
	"./indicate.mp3": 852012,
	"./individual.mp3": 619100,
	"./individualise.mp3": 756781,
	"./individually.mp3": 155037,
	"./individuals.mp3": 439971,
	"./inexpensive.mp3": 849819,
	"./inexperience.mp3": 8060,
	"./infant.mp3": 83005,
	"./infectious.mp3": 420182,
	"./infinite.mp3": 852881,
	"./infinitely.mp3": 765120,
	"./influence.mp3": 270382,
	"./influential.mp3": 852492,
	"./information.mp3": 836681,
	"./infrequent.mp3": 231289,
	"./initial.mp3": 301959,
	"./initiate.mp3": 266772,
	"./inject.mp3": 671506,
	"./injection.mp3": 553056,
	"./injured.mp3": 254560,
	"./ink.mp3": 371431,
	"./innate.mp3": 732834,
	"./innocence.mp3": 659789,
	"./innocent.mp3": 205887,
	"./innovate.mp3": 23639,
	"./insane.mp3": 8379,
	"./inscribe.mp3": 772610,
	"./insecure.mp3": 990959,
	"./inside.mp3": 438253,
	"./insincere.mp3": 190529,
	"./insincerely.mp3": 304336,
	"./insoluble.mp3": 748502,
	"./inspect.mp3": 832811,
	"./inspected.mp3": 729636,
	"./inspecting.mp3": 702949,
	"./inspection.mp3": 98251,
	"./inspiration.mp3": 764535,
	"./inspire.mp3": 592317,
	"./instant.mp3": 561504,
	"./instead.mp3": 620501,
	"./instruct.mp3": 404559,
	"./instruction.mp3": 301415,
	"./intelligence.mp3": 961168,
	"./intend.mp3": 655711,
	"./interact.mp3": 495439,
	"./interacted.mp3": 387224,
	"./interacting.mp3": 803489,
	"./interaction.mp3": 589927,
	"./interactivity.mp3": 31526,
	"./intercept.mp3": 774733,
	"./intercepted.mp3": 854718,
	"./intercepting.mp3": 776811,
	"./interception.mp3": 364737,
	"./intercity.mp3": 53468,
	"./interest.mp3": 354867,
	"./interesting.mp3": 199517,
	"./interestingly.mp3": 66340,
	"./interests.mp3": 778934,
	"./interface.mp3": 710350,
	"./interfere.mp3": 545165,
	"./interfered.mp3": 445315,
	"./interference.mp3": 214573,
	"./intergalactic.mp3": 906101,
	"./intermediary.mp3": 995708,
	"./intermediate.mp3": 136742,
	"./international.mp3": 564023,
	"./interrelated.mp3": 936042,
	"./interrupt.mp3": 931090,
	"./interruption.mp3": 336160,
	"./interrupts.mp3": 739905,
	"./intersect.mp3": 954864,
	"./intersected.mp3": 959855,
	"./intersection.mp3": 666650,
	"./interval.mp3": 512558,
	"./interview.mp3": 155722,
	"./interviewer.mp3": 145711,
	"./interviewing.mp3": 118670,
	"./interviews.mp3": 194441,
	"./into.mp3": 163719,
	"./intrigue.mp3": 851320,
	"./invalid.mp3": 237686,
	"./invasion.mp3": 909240,
	"./invention.mp3": 162693,
	"./invest.mp3": 902542,
	"./invincible.mp3": 91234,
	"./invisible.mp3": 214742,
	"./invite.mp3": 792482,
	"./involve.mp3": 714736,
	"./involved.mp3": 38484,
	"./ip.mp3": 331414,
	"./ir -2.mp3": 734221,
	"./ir -3.mp3": 560616,
	"./ir .mp3": 198164,
	"./ir.mp3": 842852,
	"./ire.mp3": 352093,
	"./ireland.mp3": 200938,
	"./irrational.mp3": 211922,
	"./irreconciled.mp3": 985300,
	"./irregular.mp3": 486056,
	"./irregularity.mp3": 507420,
	"./irrelevant.mp3": 300675,
	"./irreplaceable.mp3": 989252,
	"./irresistible.mp3": 982462,
	"./irrespective.mp3": 795292,
	"./irresponsible.mp3": 796692,
	"./is.mp3": 577801,
	"./ise.mp3": 211578,
	"./island.mp3": 576846,
	"./isle.mp3": 994236,
	"./it's.mp3": 264992,
	"./it.mp3": 499098,
	"./itch.mp3": 886451,
	"./itinerary.mp3": 840392,
	"./its.mp3": 946265,
	"./j -2.mp3": 480022,
	"./j -3.mp3": 505211,
	"./j.mp3": 872989,
	"./jack.mp3": 103972,
	"./jacket.mp3": 33219,
	"./jai.mp3": 93227,
	"./jail.mp3": 670253,
	"./jain.mp3": 917695,
	"./jainty.mp3": 880222,
	"./jaip.mp3": 384817,
	"./jam.mp3": 123119,
	"./jamp.mp3": 487613,
	"./janty.mp3": 32505,
	"./january.mp3": 778709,
	"./jap.mp3": 165102,
	"./jar.mp3": 306172,
	"./jass.mp3": 760988,
	"./jaunt.mp3": 730565,
	"./jaunty.mp3": 406930,
	"./jaw.mp3": 48741,
	"./jaww.mp3": 527396,
	"./jaxx.mp3": 102482,
	"./jay.mp3": 619419,
	"./jayy.mp3": 970148,
	"./jazz.mp3": 282830,
	"./jealous.mp3": 209732,
	"./jeene.mp3": 110796,
	"./jeep.mp3": 800777,
	"./jellies.mp3": 163003,
	"./jen.mp3": 714340,
	"./jep.mp3": 717314,
	"./jet.mp3": 854686,
	"./jewel.mp3": 38813,
	"./jienty.mp3": 204714,
	"./jill.mp3": 272266,
	"./jilt.mp3": 786002,
	"./jine.mp3": 703657,
	"./jo.mp3": 1348,
	"./joa.mp3": 946777,
	"./joan.mp3": 322773,
	"./jog.mp3": 784207,
	"./joi.mp3": 989425,
	"./join.mp3": 210061,
	"./joke.mp3": 909448,
	"./jolt.mp3": 879428,
	"./jone.mp3": 618423,
	"./jou.mp3": 732333,
	"./journalist.mp3": 889906,
	"./journey.mp3": 938747,
	"./jow.mp3": 852927,
	"./jown.mp3": 622915,
	"./joy.mp3": 515617,
	"./joyful.mp3": 809486,
	"./joyless.mp3": 772942,
	"./judge.mp3": 579634,
	"./judged.mp3": 3650,
	"./judgement.mp3": 208706,
	"./judicial.mp3": 960000,
	"./juice.mp3": 811519,
	"./juin.mp3": 662099,
	"./july.mp3": 721831,
	"./jump.mp3": 319793,
	"./jumped.mp3": 33762,
	"./jumper.mp3": 100988,
	"./jumping.mp3": 844039,
	"./jumps.mp3": 879820,
	"./june.mp3": 120877,
	"./junty.mp3": 897005,
	"./just.mp3": 823099,
	"./k -2.mp3": 760337,
	"./k -3.mp3": 245004,
	"./k.mp3": 260472,
	"./kack.mp3": 33567,
	"./kag.mp3": 415588,
	"./kain.mp3": 709080,
	"./kaip.mp3": 809742,
	"./kair.mp3": 278236,
	"./kak.mp3": 873632,
	"./kalt.mp3": 629549,
	"./kam.mp3": 43470,
	"./kap.mp3": 42703,
	"./kase.mp3": 896305,
	"./keck.mp3": 96955,
	"./keek.mp3": 968665,
	"./keep.mp3": 323214,
	"./keese.mp3": 676386,
	"./kehin.mp3": 181042,
	"./kem.mp3": 539674,
	"./ken.mp3": 1197,
	"./kenin.mp3": 122448,
	"./kent.mp3": 811795,
	"./kep.mp3": 558243,
	"./kept.mp3": 222461,
	"./kerin.mp3": 781580,
	"./kest.mp3": 596928,
	"./kettle.mp3": 92420,
	"./kevin.mp3": 217400,
	"./kew.mp3": 45744,
	"./key.mp3": 657190,
	"./kich.mp3": 744256,
	"./kick.mp3": 508503,
	"./kicken.mp3": 103866,
	"./kid.mp3": 578163,
	"./kidney.mp3": 341417,
	"./kig.mp3": 13180,
	"./kilt.mp3": 231813,
	"./kim.mp3": 59574,
	"./kimney.mp3": 265186,
	"./kin.mp3": 489001,
	"./kind.mp3": 887743,
	"./kindly.mp3": 862566,
	"./king.mp3": 452488,
	"./kip.mp3": 550887,
	"./kirp.mp3": 395599,
	"./kit.mp3": 651715,
	"./kitchen.mp3": 946459,
	"./kite.mp3": 367976,
	"./kitten.mp3": 982756,
	"./kiz.mp3": 591773,
	"./knaw.mp3": 802262,
	"./knee.mp3": 774704,
	"./kneel.mp3": 108492,
	"./knew.mp3": 974130,
	"./knife.mp3": 536504,
	"./knight.mp3": 333226,
	"./knighthood.mp3": 62452,
	"./knit.mp3": 778961,
	"./knitting.mp3": 198761,
	"./knock.mp3": 242091,
	"./knoo.mp3": 529624,
	"./knot.mp3": 588791,
	"./know.mp3": 333600,
	"./knowing.mp3": 236064,
	"./knowingly.mp3": 734553,
	"./knowledge.mp3": 175495,
	"./knowledgeable.mp3": 115863,
	"./known.mp3": 589646,
	"./knows.mp3": 615055,
	"./knuckle.mp3": 419232,
	"./koose.mp3": 879210,
	"./kop.mp3": 690673,
	"./kount.mp3": 864942,
	"./kug.mp3": 251504,
	"./l  .mp3": 9283,
	"./l -2.mp3": 133860,
	"./l.mp3": 750827,
	"./la.mp3": 150428,
	"./laboratory.mp3": 140822,
	"./laborious.mp3": 332825,
	"./labour.mp3": 700996,
	"./lace.mp3": 25496,
	"./lacey.mp3": 240685,
	"./lacy.mp3": 111004,
	"./lad.mp3": 855520,
	"./laddair.mp3": 881088,
	"./laddare.mp3": 971418,
	"./ladder.mp3": 994741,
	"./ladderer.mp3": 124808,
	"./ladies.mp3": 941149,
	"./ladle.mp3": 954501,
	"./lady.mp3": 335893,
	"./laf.mp3": 216690,
	"./laflet.mp3": 381849,
	"./lai.mp3": 589897,
	"./laid.mp3": 866335,
	"./laif.mp3": 656269,
	"./laik.mp3": 515900,
	"./lain.mp3": 470373,
	"./lainch.mp3": 988952,
	"./lair.mp3": 23737,
	"./lake.mp3": 609488,
	"./lamb.mp3": 67669,
	"./lamp.mp3": 33399,
	"./lan.mp3": 511194,
	"./lanch.mp3": 363251,
	"./lane.mp3": 563583,
	"./language.mp3": 383571,
	"./lap.mp3": 324972,
	"./laptop.mp3": 827945,
	"./lar.mp3": 537822,
	"./large.mp3": 421458,
	"./large2.mp3": 775036,
	"./lass.mp3": 227750,
	"./last.mp3": 856957,
	"./lat.mp3": 17264,
	"./latch.mp3": 62021,
	"./late.mp3": 52729,
	"./lately.mp3": 615240,
	"./later.mp3": 68201,
	"./lattair.mp3": 5536,
	"./laugh.mp3": 172,
	"./laughed.mp3": 793659,
	"./laughing.mp3": 516708,
	"./launch.mp3": 655444,
	"./law.mp3": 135431,
	"./lawn.mp3": 832875,
	"./lawyer.mp3": 347137,
	"./layal.mp3": 50510,
	"./lazily.mp3": 144254,
	"./le.mp3": 842720,
	"./lead.mp3": 812131,
	"./leaf.mp3": 969649,
	"./leaflet.mp3": 804600,
	"./league.mp3": 907878,
	"./lear.mp3": 266629,
	"./learn.mp3": 28817,
	"./least.mp3": 873524,
	"./leather.mp3": 127228,
	"./lecture.mp3": 481981,
	"./led.mp3": 387108,
	"./ledge.mp3": 236004,
	"./leed.mp3": 667359,
	"./leef.mp3": 973645,
	"./leek.mp3": 375804,
	"./leet.mp3": 192751,
	"./leflet.mp3": 960061,
	"./left.mp3": 14678,
	"./leg.mp3": 231483,
	"./legible.mp3": 464931,
	"./leisure.mp3": 743346,
	"./leke.mp3": 460316,
	"./lene.mp3": 466803,
	"./length.mp3": 622317,
	"./lentil.mp3": 235425,
	"./let's.mp3": 697498,
	"./let.mp3": 369972,
	"./lete.mp3": 34573,
	"./lettare.mp3": 290254,
	"./letter.mp3": 80433,
	"./letterer .mp3": 968124,
	"./letting.mp3": 503304,
	"./liaise.mp3": 730918,
	"./liberal.mp3": 174464,
	"./liberate.mp3": 648529,
	"./liberty.mp3": 228506,
	"./librarian.mp3": 467887,
	"./library.mp3": 339178,
	"./licence.mp3": 777382,
	"./license.mp3": 931542,
	"./licid.mp3": 430968,
	"./lie.mp3": 861981,
	"./lied.mp3": 421683,
	"./liench.mp3": 94156,
	"./lifid.mp3": 503469,
	"./lift.mp3": 146906,
	"./light.mp3": 349019,
	"./lightened.mp3": 338893,
	"./lightning.mp3": 158945,
	"./like.mp3": 815848,
	"./likeable.mp3": 628656,
	"./liked.mp3": 481884,
	"./likid.mp3": 592640,
	"./lilt.mp3": 668772,
	"./limb.mp3": 334125,
	"./limitation.mp3": 529809,
	"./limited.mp3": 840401,
	"./limiting.mp3": 247718,
	"./limp.mp3": 55375,
	"./line.mp3": 349079,
	"./lineage.mp3": 265456,
	"./lip.mp3": 287748,
	"./liquid.mp3": 618061,
	"./listen.mp3": 485564,
	"./listen2.mp3": 764862,
	"./lit.mp3": 429352,
	"./lite.mp3": 982881,
	"./literate.mp3": 897011,
	"./little.mp3": 341713,
	"./live.mp3": 613279,
	"./liveable.mp3": 750783,
	"./lived.mp3": 177177,
	"./liwid.mp3": 525780,
	"./ll.mp3": 959917,
	"./loa.mp3": 891899,
	"./load.mp3": 961845,
	"./loaf.mp3": 740647,
	"./loaflet.mp3": 504698,
	"./loak.mp3": 593414,
	"./loal.mp3": 628509,
	"./local.mp3": 651582,
	"./locality.mp3": 74446,
	"./location.mp3": 130268,
	"./loch.mp3": 873459,
	"./locomotive.mp3": 746926,
	"./lod.mp3": 491866,
	"./lof.mp3": 308104,
	"./loft.mp3": 808396,
	"./log.mp3": 953389,
	"./logged.mp3": 629883,
	"./loi.mp3": 631123,
	"./loial.mp3": 189568,
	"./loin.mp3": 901959,
	"./lok.mp3": 736673,
	"./loke.mp3": 703330,
	"./lollipop.mp3": 820232,
	"./lon.mp3": 836192,
	"./lone.mp3": 904009,
	"./lonely.mp3": 808312,
	"./long.mp3": 225339,
	"./lonk.mp3": 908471,
	"./look.mp3": 442960,
	"./looked.mp3": 322255,
	"./looking.mp3": 483120,
	"./looks.mp3": 181759,
	"./lor.mp3": 361012,
	"./lore.mp3": 467469,
	"./lorries.mp3": 812035,
	"./lot.mp3": 500586,
	"./lote.mp3": 129327,
	"./lots.mp3": 304553,
	"./loual.mp3": 499684,
	"./loud.mp3": 852137,
	"./loudly.mp3": 650392,
	"./love.mp3": 463473,
	"./loveable.mp3": 443589,
	"./lovely.mp3": 385312,
	"./low.mp3": 238589,
	"./lown.mp3": 913673,
	"./loyal.mp3": 323664,
	"./luch.mp3": 76357,
	"./luckily.mp3": 104186,
	"./lug.mp3": 342571,
	"./luggage.mp3": 411455,
	"./luhe.mp3": 605337,
	"./luke.mp3": 879148,
	"./lum.mp3": 102545,
	"./lump.mp3": 794211,
	"./lun.mp3": 930110,
	"./lunc.mp3": 638581,
	"./lunch.mp3": 579255,
	"./lung.mp3": 511761,
	"./lungs.mp3": 803884,
	"./lunh.mp3": 403018,
	"./lunk.mp3": 847773,
	"./lunt.mp3": 823662,
	"./lure.mp3": 64607,
	"./luscious.mp3": 824738,
	"./lute.mp3": 946493,
	"./lyric.mp3": 177426,
	"./m -2.mp3": 927527,
	"./m .mp3": 787258,
	"./m.mp3": 625990,
	"./ma.mp3": 372895,
	"./machine.mp3": 664536,
	"./mack.mp3": 217681,
	"./mad.mp3": 311705,
	"./made.mp3": 196202,
	"./madness.mp3": 269824,
	"./mag.mp3": 600230,
	"./magic.mp3": 384178,
	"./magician.mp3": 610298,
	"./magnum.mp3": 894574,
	"./maiket.mp3": 32704,
	"./mail.mp3": 880460,
	"./main.mp3": 765886,
	"./mair.mp3": 586234,
	"./mait.mp3": 157572,
	"./make.mp3": 286071,
	"./maket.mp3": 521265,
	"./mal.mp3": 658801,
	"./maladroit.mp3": 459568,
	"./malady.mp3": 671343,
	"./malcontent.mp3": 720072,
	"./male.mp3": 673234,
	"./malfunction.mp3": 634865,
	"./malicious.mp3": 647789,
	"./maliciously.mp3": 320532,
	"./malk.mp3": 546372,
	"./malnourished.mp3": 589956,
	"./malt.mp3": 232743,
	"./mam.mp3": 296492,
	"./man's.mp3": 871961,
	"./man.mp3": 501283,
	"./mane.mp3": 349064,
	"./manoa.mp3": 11555,
	"./manow.mp3": 466053,
	"./manuhe.mp3": 690353,
	"./manure.mp3": 587015,
	"./manuscript.mp3": 361237,
	"./many.mp3": 862956,
	"./map.mp3": 944237,
	"./march.mp3": 725214,
	"./market.mp3": 584017,
	"./marriage.mp3": 725221,
	"./marries.mp3": 451588,
	"./marvellous.mp3": 100287,
	"./marvellously.mp3": 37990,
	"./mas.mp3": 999066,
	"./mask.mp3": 860769,
	"./massive.mp3": 689029,
	"./mat.mp3": 561417,
	"./match.mp3": 519276,
	"./matches.mp3": 320408,
	"./mate.mp3": 557242,
	"./material.mp3": 184646,
	"./materialist.mp3": 907106,
	"./materials.mp3": 309085,
	"./maternal.mp3": 817157,
	"./mathematician.mp3": 725658,
	"./matoa.mp3": 80909,
	"./mator.mp3": 590730,
	"./matow.mp3": 913323,
	"./matuhe.mp3": 681891,
	"./mature.mp3": 706461,
	"./maximal.mp3": 469236,
	"./maximise.mp3": 537204,
	"./maximum.mp3": 959349,
	"./may.mp3": 827040,
	"./me.mp3": 394587,
	"./meach.mp3": 156929,
	"./meadow.mp3": 145962,
	"./meal.mp3": 469432,
	"./meant.mp3": 737626,
	"./measure.mp3": 280951,
	"./meat.mp3": 891200,
	"./mechanic.mp3": 27407,
	"./med.mp3": 568213,
	"./medal.mp3": 73682,
	"./meddle.mp3": 298958,
	"./mede.mp3": 603318,
	"./media.mp3": 43075,
	"./mediate.mp3": 129646,
	"./mediation.mp3": 10417,
	"./medical.mp3": 291126,
	"./medically.mp3": 844255,
	"./medicate.mp3": 363587,
	"./medicated.mp3": 989005,
	"./medicates.mp3": 696582,
	"./medicating.mp3": 635242,
	"./medication.mp3": 975748,
	"./medicinal.mp3": 766335,
	"./medicine.mp3": 24757,
	"./medieval.mp3": 351104,
	"./medium.mp3": 782404,
	"./mee.mp3": 287472,
	"./meen.mp3": 410110,
	"./meet.mp3": 344324,
	"./meg.mp3": 823682,
	"./megan's.mp3": 222437,
	"./meke.mp3": 948475,
	"./mel.mp3": 223677,
	"./meld.mp3": 519251,
	"./melt.mp3": 9059,
	"./mem.mp3": 347928,
	"./membership.mp3": 708917,
	"./men's.mp3": 753293,
	"./men.mp3": 964175,
	"./mention.mp3": 107061,
	"./mercy.mp3": 6215,
	"./mere.mp3": 846744,
	"./merge.mp3": 677039,
	"./merriment.mp3": 114384,
	"./merry.mp3": 728836,
	"./mess.mp3": 232565,
	"./messy.mp3": 972354,
	"./met.mp3": 254469,
	"./metal.mp3": 194242,
	"./mew.mp3": 486898,
	"./mice's.mp3": 923909,
	"./mice.mp3": 508903,
	"./micro-organism.mp3": 934736,
	"./micrometre.mp3": 557672,
	"./microphone.mp3": 597661,
	"./microscope.mp3": 514449,
	"./mid.mp3": 29569,
	"./midday.mp3": 868421,
	"./middle.mp3": 165386,
	"./mide.mp3": 377282,
	"./midrange.mp3": 563604,
	"./midriff.mp3": 101482,
	"./mig.mp3": 87278,
	"./might.mp3": 606186,
	"./mik.mp3": 423290,
	"./mike.mp3": 343199,
	"./mild.mp3": 608063,
	"./mildew.mp3": 161359,
	"./mileage.mp3": 751319,
	"./milk.mp3": 677980,
	"./millimetre.mp3": 736893,
	"./million.mp3": 920207,
	"./millionaire.mp3": 497670,
	"./millipede.mp3": 122180,
	"./mim.mp3": 510980,
	"./min.mp3": 57947,
	"./mind.mp3": 265877,
	"./mine.mp3": 985136,
	"./mined.mp3": 663764,
	"./mini.mp3": 348212,
	"./miniature.mp3": 295419,
	"./minimal.mp3": 248482,
	"./minimise.mp3": 235090,
	"./minimum.mp3": 273827,
	"./miniscule.mp3": 602406,
	"./miniskirt.mp3": 358865,
	"./minor.mp3": 495492,
	"./minority.mp3": 47176,
	"./minute 2.mp3": 377399,
	"./minute.mp3": 425997,
	"./minute2.mp3": 556325,
	"./minutes.mp3": 17024,
	"./mip.mp3": 902197,
	"./mir.mp3": 70503,
	"./mis.mp3": 465570,
	"./misbehave.mp3": 547467,
	"./mischief.mp3": 641057,
	"./mischievous.mp3": 557388,
	"./mischievously.mp3": 940013,
	"./miscommunicate.mp3": 117881,
	"./misconduct.mp3": 606830,
	"./misfortune.mp3": 982293,
	"./misguide.mp3": 498034,
	"./mishap.mp3": 606525,
	"./mishaps.mp3": 149424,
	"./misinform.mp3": 482005,
	"./misjudge.mp3": 808831,
	"./mislead.mp3": 869292,
	"./mispell.mp3": 127971,
	"./misplace.mp3": 797039,
	"./misprint.mp3": 131431,
	"./mispronounce.mp3": 826735,
	"./mispronounced.mp3": 760585,
	"./miss.mp3": 338641,
	"./missed.mp3": 274306,
	"./mission.mp3": 402317,
	"./misspell.mp3": 772464,
	"./mist.mp3": 28834,
	"./mistake.mp3": 137347,
	"./mistletoe.mp3": 774953,
	"./mistreat.mp3": 24010,
	"./misuse.mp3": 46644,
	"./mix.mp3": 111389,
	"./mixture.mp3": 972263,
	"./moaket.mp3": 138622,
	"./moal.mp3": 38438,
	"./moan.mp3": 247540,
	"./moch.mp3": 653844,
	"./mod.mp3": 126279,
	"./mode.mp3": 919436,
	"./model.mp3": 244120,
	"./modern.mp3": 121860,
	"./mointain.mp3": 59072,
	"./moisten.mp3": 58806,
	"./moith-2.mp3": 706991,
	"./moith.mp3": 815218,
	"./moke-2.mp3": 258936,
	"./moke.mp3": 33165,
	"./mole.mp3": 250820,
	"./molt.mp3": 907321,
	"./mom-2.mp3": 424375,
	"./mom.mp3": 510762,
	"./mon-2.mp3": 756040,
	"./mon.mp3": 248765,
	"./monarch.mp3": 593329,
	"./monday.mp3": 633553,
	"./monday2.mp3": 948017,
	"./money.mp3": 215151,
	"./monkey.mp3": 465558,
	"./monogram.mp3": 263113,
	"./monologue.mp3": 368836,
	"./monorail.mp3": 476380,
	"./monosyllable.mp3": 806692,
	"./monotonous.mp3": 922310,
	"./montain-2.mp3": 832216,
	"./montain.mp3": 732397,
	"./month.mp3": 848654,
	"./mood.mp3": 183212,
	"./moon.mp3": 486950,
	"./mop.mp3": 641299,
	"./more.mp3": 785378,
	"./morning.mp3": 757531,
	"./mortal.mp3": 141308,
	"./mortality.mp3": 57744,
	"./mortgage.mp3": 877875,
	"./mortician.mp3": 354737,
	"./mosh.mp3": 245348,
	"./mosque.mp3": 128087,
	"./most.mp3": 195760,
	"./mot.mp3": 101559,
	"./moth.mp3": 810925,
	"./mother.mp3": 511840,
	"./motherhood.mp3": 801842,
	"./motion.mp3": 312847,
	"./motive.mp3": 896195,
	"./motorcycle.mp3": 358506,
	"./motorcyclist.mp3": 200283,
	"./motorist.mp3": 121876,
	"./mound.mp3": 693484,
	"./mount.mp3": 201116,
	"./mountain.mp3": 384828,
	"./mountainous.mp3": 26139,
	"./mourning.mp3": 883134,
	"./mouse's.mp3": 667912,
	"./mouse.mp3": 965026,
	"./mouse_s.mp3": 617776,
	"./moustache.mp3": 148982,
	"./mouth.mp3": 657638,
	"./move.mp3": 716358,
	"./movement.mp3": 84038,
	"./moving.mp3": 561619,
	"./moxer.mp3": 927578,
	"./moxor.mp3": 246244,
	"./moz.mp3": 580745,
	"./mr.mp3": 894392,
	"./mrs.mp3": 19415,
	"./much.mp3": 18234,
	"./mud.mp3": 532357,
	"./mude.mp3": 443910,
	"./mug.mp3": 764786,
	"./muil.mp3": 736912,
	"./muintain.mp3": 444842,
	"./muith.mp3": 254536,
	"./muke.mp3": 435147,
	"./mule.mp3": 546334,
	"./mult.mp3": 532115,
	"./multiple.mp3": 134497,
	"./multiply.mp3": 178941,
	"./mum.mp3": 875528,
	"./mumble.mp3": 363599,
	"./mun.mp3": 768255,
	"./muntain.mp3": 935147,
	"./mup.mp3": 235377,
	"./murl.mp3": 457221,
	"./muscle.mp3": 726520,
	"./museum.mp3": 242969,
	"./music.mp3": 512634,
	"./musician.mp3": 434162,
	"./muss.mp3": 909637,
	"./must.mp3": 620110,
	"./mustn't.mp3": 382521,
	"./mut.mp3": 846101,
	"./muth.mp3": 330391,
	"./muww.mp3": 441045,
	"./muxx.mp3": 108691,
	"./muyy.mp3": 226257,
	"./muzz.mp3": 77483,
	"./my.mp3": 76519,
	"./mysterious.mp3": 897263,
	"./mystery.mp3": 98616,
	"./myth.mp3": 706987,
	"./n -2.mp3": 624866,
	"./n -3.mp3": 229799,
	"./n.mp3": 802233,
	"./na.mp3": 381702,
	"./nacc.mp3": 116432,
	"./nach.mp3": 793135,
	"./nack.mp3": 789240,
	"./nad.mp3": 796790,
	"./nade.mp3": 448043,
	"./nag.mp3": 226217,
	"./nagg.mp3": 161288,
	"./nait.mp3": 80465,
	"./nall.mp3": 729558,
	"./nam.mp3": 315379,
	"./name.mp3": 483704,
	"./named.mp3": 901452,
	"./nan.mp3": 234044,
	"./nap.mp3": 367882,
	"./nar.mp3": 200120,
	"./narl.mp3": 462932,
	"./narr.mp3": 658514,
	"./narrator.mp3": 843350,
	"./nas.mp3": 812637,
	"./nash.mp3": 392607,
	"./nast.mp3": 713411,
	"./nastiness.mp3": 432473,
	"./nat.mp3": 81990,
	"./nath.mp3": 52370,
	"./nation.mp3": 893132,
	"./national.mp3": 942111,
	"./nationality.mp3": 934113,
	"./nationally.mp3": 670214,
	"./native.mp3": 277224,
	"./natives.mp3": 798535,
	"./nativity.mp3": 564357,
	"./natural.mp3": 375760,
	"./nature.mp3": 989320,
	"./naught.mp3": 679462,
	"./naughtier.mp3": 495134,
	"./naughty.mp3": 186759,
	"./naw.mp3": 741881,
	"./nawt.mp3": 844319,
	"./naz.mp3": 916816,
	"./ne.mp3": 125066,
	"./near.mp3": 652867,
	"./nearby.mp3": 165028,
	"./necc.mp3": 342132,
	"./necessary.mp3": 850126,
	"./necessity.mp3": 726360,
	"./neck.mp3": 803116,
	"./neckon.mp3": 362067,
	"./ned.mp3": 186922,
	"./nede.mp3": 315631,
	"./need.mp3": 495913,
	"./neen.mp3": 585075,
	"./neet.mp3": 11577,
	"./neg.mp3": 924925,
	"./negate.mp3": 374599,
	"./negative.mp3": 622380,
	"./negg.mp3": 631004,
	"./neglect.mp3": 268857,
	"./negligence.mp3": 348882,
	"./negotiations.mp3": 43871,
	"./neighbour.mp3": 453762,
	"./neighbourhood.mp3": 405852,
	"./neighbouring.mp3": 733590,
	"./neighbourly.mp3": 525731,
	"./neither.mp3": 607526,
	"./nell.mp3": 861786,
	"./nelnet.mp3": 925623,
	"./nem.mp3": 802439,
	"./neme.mp3": 666892,
	"./nen.mp3": 988720,
	"./nep.mp3": 857494,
	"./nephew.mp3": 644318,
	"./nerr.mp3": 951286,
	"./nervous.mp3": 670893,
	"./nescar.mp3": 154825,
	"./nescay.mp3": 564110,
	"./nescear.mp3": 568348,
	"./nescow.mp3": 427886,
	"./nescue.mp3": 499998,
	"./nest.mp3": 811951,
	"./net.mp3": 25178,
	"./never.mp3": 122465,
	"./new.mp3": 97197,
	"./newspaper.mp3": 331318,
	"./newt.mp3": 552019,
	"./next.mp3": 640529,
	"./ng -2.mp3": 858257,
	"./ng -3.mp3": 800396,
	"./ng .mp3": 169232,
	"./ng.mp3": 346808,
	"./ni.mp3": 908350,
	"./nib.mp3": 378896,
	"./nic.mp3": 65525,
	"./nice.mp3": 292694,
	"./nicer.mp3": 762120,
	"./nicest.mp3": 601171,
	"./nick.mp3": 415200,
	"./nid.mp3": 766270,
	"./nide.mp3": 713539,
	"./niece.mp3": 110443,
	"./niff.mp3": 92290,
	"./nig.mp3": 938705,
	"./night.mp3": 517861,
	"./nim.mp3": 152555,
	"./nime.mp3": 857952,
	"./nin.mp3": 148116,
	"./nine.mp3": 533101,
	"./nineteen.mp3": 245581,
	"./nip.mp3": 343698,
	"./nis.mp3": 134245,
	"./nisit.mp3": 465410,
	"./nit.mp3": 250606,
	"./nk.mp3": 565452,
	"./no.mp3": 674000,
	"./noa.mp3": 950013,
	"./noal.mp3": 789179,
	"./noan.mp3": 467849,
	"./nobly.mp3": 474603,
	"./nock.mp3": 849810,
	"./nod.mp3": 72436,
	"./node.mp3": 21645,
	"./noise.mp3": 622545,
	"./noisily.mp3": 780068,
	"./noisy.mp3": 3981,
	"./nol.mp3": 17068,
	"./nom.mp3": 379377,
	"./nome.mp3": 869138,
	"./non-essential.mp3": 404525,
	"./non-profit.mp3": 314761,
	"./nondescript.mp3": 725870,
	"./nonfiction.mp3": 482466,
	"./nonsense.mp3": 527336,
	"./noo.mp3": 221859,
	"./noon.mp3": 997623,
	"./noot.mp3": 687357,
	"./nop.mp3": 19528,
	"./nor.mp3": 719642,
	"./norl.mp3": 364338,
	"./normal.mp3": 747420,
	"./norn.mp3": 156192,
	"./nose.mp3": 757396,
	"./nost.mp3": 297577,
	"./nostril.mp3": 291430,
	"./not.mp3": 547044,
	"./notation.mp3": 226391,
	"./notch.mp3": 190665,
	"./note.mp3": 893661,
	"./noted.mp3": 175539,
	"./nothing.mp3": 730948,
	"./notice.mp3": 552773,
	"./noticeable.mp3": 101609,
	"./notified.mp3": 154497,
	"./notifies.mp3": 590498,
	"./notify.mp3": 210450,
	"./notifying.mp3": 433478,
	"./notion.mp3": 268982,
	"./nought.mp3": 84556,
	"./nourish.mp3": 39111,
	"./novel.mp3": 561805,
	"./novelty.mp3": 289276,
	"./november.mp3": 406999,
	"./novice.mp3": 474391,
	"./now.mp3": 603323,
	"./nowhere.mp3": 600477,
	"./nowl.mp3": 182685,
	"./nowt.mp3": 42213,
	"./nuch.mp3": 575507,
	"./nucket.mp3": 897179,
	"./nuclear.mp3": 649153,
	"./nud.mp3": 547962,
	"./nude.mp3": 880351,
	"./nudged.mp3": 261758,
	"./nuf.mp3": 107880,
	"./nug.mp3": 797837,
	"./nuhe.mp3": 585171,
	"./nuisance.mp3": 67003,
	"./num.mp3": 809559,
	"./numb.mp3": 81175,
	"./nume.mp3": 82108,
	"./numerical.mp3": 858781,
	"./numerically.mp3": 787236,
	"./numerous.mp3": 186105,
	"./nun.mp3": 45312,
	"./nup.mp3": 505414,
	"./nure.mp3": 85549,
	"./nurkair.mp3": 657761,
	"./nurkar.mp3": 187142,
	"./nurkay.mp3": 886225,
	"./nurkey.mp3": 218477,
	"./nurkoy.mp3": 188043,
	"./nurse.mp3": 671680,
	"./nus.mp3": 165305,
	"./nush.mp3": 256323,
	"./nuss.mp3": 926596,
	"./nut.mp3": 791306,
	"./nutritious.mp3": 512927,
	"./nutritiously.mp3": 596934,
	"./o -2.mp3": 27325,
	"./o -3.mp3": 304600,
	"./o -4.mp3": 154443,
	"./o -5.mp3": 398118,
	"./o -6.mp3": 109593,
	"./o.mp3": 230036,
	"./o2.mp3": 358438,
	"./oa.mp3": 135049,
	"./oak.mp3": 532284,
	"./oal.mp3": 684375,
	"./ob.mp3": 888662,
	"./obedience.mp3": 143171,
	"./obedient.mp3": 976101,
	"./obey.mp3": 965908,
	"./object.mp3": 296536,
	"./obligatory.mp3": 293187,
	"./observance.mp3": 790443,
	"./observant.mp3": 394205,
	"./observation.mp3": 915141,
	"./obsession.mp3": 23698,
	"./obstruct.mp3": 579017,
	"./obstruction.mp3": 658917,
	"./obtuse.mp3": 558227,
	"./obvious.mp3": 863596,
	"./occasion.mp3": 244480,
	"./occasional.mp3": 612523,
	"./occasionally.mp3": 635354,
	"./occupancy.mp3": 657100,
	"./occupant.mp3": 783552,
	"./occupier.mp3": 74523,
	"./occupy.mp3": 493086,
	"./occur.mp3": 847515,
	"./octagon.mp3": 132738,
	"./octet.mp3": 117414,
	"./october.mp3": 882475,
	"./octopus.mp3": 749784,
	"./odorous.mp3": 17938,
	"./of.mp3": 56346,
	"./off.mp3": 144712,
	"./official.mp3": 258194,
	"./often.mp3": 812947,
	"./oh.mp3": 165852,
	"./ohh.mp3": 903460,
	"./oil.mp3": 353839,
	"./oit.mp3": 662807,
	"./ok.mp3": 195603,
	"./ol.mp3": 400672,
	"./old.mp3": 909220,
	"./om.mp3": 529413,
	"./ome.mp3": 374470,
	"./omnidirectional.mp3": 5302,
	"./omnipotent.mp3": 96622,
	"./omnipresent.mp3": 38619,
	"./omniscient.mp3": 9280,
	"./omnivore.mp3": 598556,
	"./omnivorous.mp3": 646190,
	"./on.mp3": 761842,
	"./once.mp3": 42706,
	"./one.mp3": 626695,
	"./only.mp3": 393203,
	"./onslome.mp3": 200048,
	"./onsode.mp3": 609685,
	"./oo -2.mp3": 318848,
	"./oo -3.mp3": 369125,
	"./oo -4.mp3": 485486,
	"./oo -5.mp3": 12339,
	"./oo -6.mp3": 931004,
	"./oo .mp3": 838533,
	"./oo.mp3": 139511,
	"./oon.mp3": 738171,
	"./oot.mp3": 209777,
	"./op.mp3": 925492,
	"./opacity.mp3": 975400,
	"./opaque.mp3": 647168,
	"./operable.mp3": 861641,
	"./operation.mp3": 483048,
	"./opp.mp3": 849876,
	"./opportune.mp3": 450673,
	"./opportunist.mp3": 545540,
	"./opportunistic.mp3": 353532,
	"./opportunity.mp3": 573100,
	"./opposing.mp3": 540758,
	"./opposite.mp3": 938086,
	"./opposition.mp3": 937433,
	"./optician.mp3": 723856,
	"./option.mp3": 513346,
	"./or -2.mp3": 963847,
	"./or -3.mp3": 381890,
	"./or .mp3": 932378,
	"./or.mp3": 173862,
	"./orchestra.mp3": 648898,
	"./orchid.mp3": 432260,
	"./order.mp3": 645443,
	"./ordered.mp3": 712924,
	"./ordinary.mp3": 303231,
	"./ore.mp3": 305083,
	"./orhan.mp3": 262647,
	"./original.mp3": 747344,
	"./orl.mp3": 88590,
	"./orn.mp3": 226460,
	"./orpan.mp3": 604671,
	"./orphan.mp3": 710475,
	"./orran.mp3": 598977,
	"./ort.mp3": 234470,
	"./ortor.mp3": 541633,
	"./os.mp3": 930187,
	"./ose.mp3": 455808,
	"./oss.mp3": 138110,
	"./ostentatious.mp3": 214027,
	"./ot.mp3": 596696,
	"./other.mp3": 525201,
	"./ou.mp3": 803069,
	"./ouch.mp3": 945184,
	"./ought.mp3": 771048,
	"./our.mp3": 361941,
	"./out.mp3": 77347,
	"./outgoings.mp3": 12246,
	"./outrage.mp3": 527996,
	"./outrageous.mp3": 565083,
	"./outside.mp3": 274466,
	"./oval.mp3": 206893,
	"./over.mp3": 248399,
	"./overambitious.mp3": 994822,
	"./overbalance.mp3": 48081,
	"./overcoat.mp3": 739002,
	"./overcook.mp3": 807915,
	"./overfamiliar.mp3": 694622,
	"./overfamiliarity.mp3": 542209,
	"./overlook.mp3": 396278,
	"./overpaid.mp3": 699525,
	"./overpopulated.mp3": 983407,
	"./overreact.mp3": 816856,
	"./overslept.mp3": 847787,
	"./overthrow.mp3": 126141,
	"./overtired.mp3": 825215,
	"./overturn.mp3": 863602,
	"./ow -2.mp3": 363448,
	"./ow .mp3": 39565,
	"./ow.mp3": 239119,
	"./ow2.mp3": 258671,
	"./owl.mp3": 911169,
	"./own.mp3": 165107,
	"./ownership.mp3": 643236,
	"./oxygen.mp3": 31101,
	"./oy -2.mp3": 392986,
	"./oy -3.mp3": 101951,
	"./oy .mp3": 999859,
	"./oy.mp3": 232433,
	"./oyster.mp3": 692601,
	"./p -2.mp3": 555872,
	"./p -3.mp3": 531589,
	"./p.mp3": 446487,
	"./pa.mp3": 206720,
	"./pab.mp3": 680122,
	"./pace.mp3": 94324,
	"./pach.mp3": 234370,
	"./pacific.mp3": 789010,
	"./pack.mp3": 267458,
	"./pact.mp3": 303881,
	"./pad.mp3": 793988,
	"./paddle.mp3": 626765,
	"./pag.mp3": 314779,
	"./page.mp3": 29936,
	"./pai.mp3": 227749,
	"./paid.mp3": 954955,
	"./paik.mp3": 587184,
	"./paim.mp3": 777118,
	"./pain.mp3": 952753,
	"./painful.mp3": 14750,
	"./paint.mp3": 888935,
	"./pair.mp3": 695661,
	"./paison.mp3": 858447,
	"./pait.mp3": 481147,
	"./pak.mp3": 484247,
	"./pake.mp3": 275260,
	"./palace.mp3": 984245,
	"./pale.mp3": 723045,
	"./palm.mp3": 425293,
	"./palp.mp3": 469644,
	"./palt.mp3": 967696,
	"./pam.mp3": 312577,
	"./pamphlet.mp3": 855224,
	"./pan.mp3": 344110,
	"./pank.mp3": 253613,
	"./pantob.mp3": 907801,
	"./pap.mp3": 298232,
	"./paper.mp3": 79729,
	"./par.mp3": 76490,
	"./parachute.mp3": 276298,
	"./parade.mp3": 711718,
	"./paradoxically.mp3": 550422,
	"./paragraph.mp3": 202673,
	"./parallel.mp3": 325724,
	"./paranormal.mp3": 111174,
	"./parasite.mp3": 701930,
	"./pard.mp3": 795050,
	"./parents'.mp3": 588507,
	"./parents.mp3": 943616,
	"./park.mp3": 962417,
	"./parliament.mp3": 861768,
	"./parsley.mp3": 165369,
	"./partial.mp3": 306944,
	"./participate.mp3": 419855,
	"./particular.mp3": 162572,
	"./particularly.mp3": 169965,
	"./parties.mp3": 631927,
	"./partnership.mp3": 427035,
	"./partridge.mp3": 266115,
	"./party.mp3": 152611,
	"./pas.mp3": 302127,
	"./pash.mp3": 111429,
	"./pass.mp3": 342634,
	"./passed.mp3": 625673,
	"./passenger.mp3": 287183,
	"./passes.mp3": 555690,
	"./passive.mp3": 198052,
	"./passport.mp3": 843111,
	"./past.mp3": 467353,
	"./pat-2.mp3": 43853,
	"./pat.mp3": 725268,
	"./patch.mp3": 314681,
	"./patches.mp3": 392310,
	"./path.mp3": 453084,
	"./patient.mp3": 814636,
	"./patiently.mp3": 923021,
	"./patted.mp3": 316055,
	"./patting.mp3": 978024,
	"./pause.mp3": 64125,
	"./paw.mp3": 788587,
	"./payment.mp3": 173921,
	"./payrsay.mp3": 492234,
	"./payrtay.mp3": 667905,
	"./paz.mp3": 875426,
	"./pe.mp3": 514428,
	"./peace.mp3": 274549,
	"./pear.mp3": 129633,
	"./pearl.mp3": 687343,
	"./peb.mp3": 507502,
	"./peckon.mp3": 746741,
	"./peculiar.mp3": 434576,
	"./peculiarities.mp3": 603152,
	"./peculiarity.mp3": 298676,
	"./peculiarly.mp3": 123369,
	"./ped.mp3": 340864,
	"./pedal.mp3": 831019,
	"./peege.mp3": 711181,
	"./peem.mp3": 459742,
	"./peen.mp3": 609201,
	"./peer.mp3": 894637,
	"./peers.mp3": 814496,
	"./peet.mp3": 833147,
	"./peg.mp3": 105111,
	"./peke.mp3": 381936,
	"./pelt.mp3": 237228,
	"./pen.mp3": 843514,
	"./penalises.mp3": 745769,
	"./pence.mp3": 714330,
	"./pencil.mp3": 810678,
	"./penniless.mp3": 473586,
	"./pension.mp3": 128757,
	"./pentagon.mp3": 495849,
	"./pentagram.mp3": 365482,
	"./people's.mp3": 548622,
	"./people.mp3": 210304,
	"./pep.mp3": 137740,
	"./perceive.mp3": 186232,
	"./percent.mp3": 358848,
	"./percentage.mp3": 658069,
	"./perennial.mp3": 311863,
	"./perfect.mp3": 179308,
	"./perfectly.mp3": 575693,
	"./perfeeme.mp3": 95912,
	"./perfime.mp3": 493303,
	"./perfome.mp3": 780645,
	"./perfume.mp3": 484739,
	"./perhaps.mp3": 690220,
	"./peril.mp3": 899297,
	"./period.mp3": 902446,
	"./perishable.mp3": 923594,
	"./permanent.mp3": 207901,
	"./permission.mp3": 475060,
	"./permitted.mp3": 945979,
	"./perpetual.mp3": 623269,
	"./persist.mp3": 365351,
	"./persistent.mp3": 49818,
	"./person.mp3": 936970,
	"./perspective.mp3": 580281,
	"./persuade.mp3": 113882,
	"./perusal.mp3": 856417,
	"./pet.mp3": 635792,
	"./pete.mp3": 127705,
	"./petition.mp3": 324619,
	"./pew.mp3": 490727,
	"./phantob.mp3": 365823,
	"./pharmacy.mp3": 600198,
	"./phene.mp3": 660589,
	"./phine.mp3": 485817,
	"./phone.mp3": 254599,
	"./phonics.mp3": 322965,
	"./phopics.mp3": 84851,
	"./phot.mp3": 950936,
	"./photo.mp3": 529291,
	"./photograph.mp3": 196209,
	"./phream.mp3": 282444,
	"./phune.mp3": 144349,
	"./physical.mp3": 783858,
	"./physicality.mp3": 459714,
	"./physically.mp3": 537331,
	"./physician.mp3": 248823,
	"./physicist.mp3": 42519,
	"./physics.mp3": 585112,
	"./pic.mp3": 492087,
	"./pick.mp3": 382106,
	"./pict.mp3": 558193,
	"./picture.mp3": 451477,
	"./pid.mp3": 544604,
	"./pie.mp3": 137377,
	"./piece.mp3": 929429,
	"./pieces.mp3": 461816,
	"./pig.mp3": 421331,
	"./pige.mp3": 247320,
	"./pight.mp3": 232935,
	"./pike.mp3": 89940,
	"./pim.mp3": 513801,
	"./pin.mp3": 114390,
	"./pineapple.mp3": 822017,
	"./pinf.mp3": 693300,
	"./pink.mp3": 457941,
	"./pip.mp3": 245616,
	"./pipe.mp3": 401401,
	"./pit.mp3": 553324,
	"./pity.mp3": 896105,
	"./pla.mp3": 282838,
	"./placate.mp3": 780871,
	"./place.mp3": 319118,
	"./plag.mp3": 717785,
	"./plai.mp3": 513031,
	"./plain.mp3": 468587,
	"./plainness.mp3": 475134,
	"./plair.mp3": 164247,
	"./plairon.mp3": 397452,
	"./plam.mp3": 907363,
	"./plane.mp3": 391221,
	"./plank.mp3": 478251,
	"./plant.mp3": 867136,
	"./plants.mp3": 52271,
	"./plaon.mp3": 320269,
	"./plaque.mp3": 789565,
	"./play.mp3": 971959,
	"./playful.mp3": 892932,
	"./playground.mp3": 379094,
	"./playon.mp3": 45036,
	"./plays.mp3": 999746,
	"./pleasant.mp3": 570789,
	"./please.mp3": 964691,
	"./pleasure.mp3": 249728,
	"./plee.mp3": 460543,
	"./pleeon.mp3": 276116,
	"./plentiful.mp3": 481774,
	"./plinth.mp3": 666152,
	"./ploe.mp3": 8393,
	"./plonk.mp3": 29197,
	"./plot.mp3": 315188,
	"./plough.mp3": 90264,
	"./ploy.mp3": 232853,
	"./pluck.mp3": 79948,
	"./plug.mp3": 299805,
	"./plum.mp3": 928295,
	"./plumb.mp3": 20871,
	"./plumber's.mp3": 757212,
	"./plumber.mp3": 976078,
	"./plume.mp3": 998508,
	"./plump.mp3": 657797,
	"./plush.mp3": 522323,
	"./poa.mp3": 744879,
	"./poad.mp3": 685065,
	"./poak.mp3": 616306,
	"./poam.mp3": 715868,
	"./poan.mp3": 592595,
	"./poason.mp3": 504033,
	"./poat.mp3": 739801,
	"./pocket.mp3": 234775,
	"./pod.mp3": 775878,
	"./podet.mp3": 81285,
	"./poff.mp3": 463002,
	"./pog.mp3": 893241,
	"./poge.mp3": 700874,
	"./pohh.mp3": 129078,
	"./poi.mp3": 923111,
	"./point.mp3": 233269,
	"./poison.mp3": 243401,
	"./poisonous.mp3": 334724,
	"./poke.mp3": 463766,
	"./polar.mp3": 264183,
	"./pole.mp3": 731587,
	"./politician.mp3": 288279,
	"./pollution.mp3": 771113,
	"./pom.mp3": 82819,
	"./pomp.mp3": 632121,
	"./pon.mp3": 959628,
	"./pond.mp3": 888624,
	"./ponies.mp3": 655785,
	"./ponk.mp3": 256395,
	"./pool.mp3": 181631,
	"./poom.mp3": 472666,
	"./poor.mp3": 801777,
	"./poot.mp3": 249927,
	"./pop.mp3": 122874,
	"./popcorn.mp3": 734224,
	"./popet.mp3": 767753,
	"./popics.mp3": 218013,
	"./popp.mp3": 385990,
	"./popular.mp3": 374976,
	"./popularity.mp3": 642052,
	"./populate.mp3": 167571,
	"./populating.mp3": 90426,
	"./population.mp3": 104340,
	"./por.mp3": 378344,
	"./pore.mp3": 741729,
	"./porridge.mp3": 737885,
	"./portable.mp3": 515748,
	"./porter.mp3": 807165,
	"./portion.mp3": 759518,
	"./posing.mp3": 847403,
	"./position.mp3": 850632,
	"./positive.mp3": 876628,
	"./poss.mp3": 378304,
	"./possess.mp3": 209131,
	"./possessed.mp3": 746660,
	"./possesses.mp3": 373775,
	"./possessing.mp3": 992037,
	"./possession.mp3": 870987,
	"./possessions.mp3": 199294,
	"./possessive.mp3": 512735,
	"./possible.mp3": 118032,
	"./possibly.mp3": 286596,
	"./postal.mp3": 53344,
	"./postdate.mp3": 758311,
	"./postmortem.mp3": 95715,
	"./postpone.mp3": 204979,
	"./postscript.mp3": 810814,
	"./pot.mp3": 948150,
	"./potatoes.mp3": 962628,
	"./potential.mp3": 441001,
	"./potet.mp3": 382165,
	"./potter.mp3": 510563,
	"./poultry.mp3": 435348,
	"./pound.mp3": 563497,
	"./pour.mp3": 478099,
	"./pow.mp3": 920105,
	"./powson.mp3": 25243,
	"./practice.mp3": 89462,
	"./practise.mp3": 808454,
	"./praise.mp3": 665969,
	"./pram.mp3": 568785,
	"./prance.mp3": 75350,
	"./pray.mp3": 764325,
	"./pre-empt.mp3": 806519,
	"./pre-existing.mp3": 462850,
	"./pream.mp3": 411482,
	"./prearrange.mp3": 900228,
	"./precautionary.mp3": 610727,
	"./precede.mp3": 727877,
	"./precept.mp3": 91588,
	"./precious.mp3": 774875,
	"./prediction.mp3": 483038,
	"./preene.mp3": 808354,
	"./prefab.mp3": 341867,
	"./prefer.mp3": 412775,
	"./preference.mp3": 976106,
	"./preferential.mp3": 553664,
	"./preferred.mp3": 820640,
	"./preferring.mp3": 270457,
	"./prehistoric.mp3": 787019,
	"./prehistorically.mp3": 782977,
	"./prehistory.mp3": 211796,
	"./prejudice.mp3": 620098,
	"./prem.mp3": 68189,
	"./preoccupied.mp3": 359216,
	"./preoccupy.mp3": 769783,
	"./preparation.mp3": 34132,
	"./prepare.mp3": 201890,
	"./prepared.mp3": 212050,
	"./preparing.mp3": 600919,
	"./prescribe.mp3": 53094,
	"./prescribed.mp3": 59734,
	"./prescribes.mp3": 974141,
	"./prescription.mp3": 73789,
	"./present.mp3": 907654,
	"./preserve.mp3": 204009,
	"./press.mp3": 374134,
	"./pressed.mp3": 589381,
	"./presses.mp3": 295966,
	"./pressure.mp3": 969432,
	"./pressuring.mp3": 279421,
	"./pretend.mp3": 349035,
	"./pretentious.mp3": 416384,
	"./pretty.mp3": 411825,
	"./prevent.mp3": 77045,
	"./previous.mp3": 755978,
	"./previously.mp3": 805131,
	"./prey.mp3": 481769,
	"./price.mp3": 480780,
	"./prick.mp3": 429898,
	"./primary.mp3": 197613,
	"./prince.mp3": 937694,
	"./principal.mp3": 399393,
	"./principle.mp3": 806211,
	"./prine.mp3": 750843,
	"./print.mp3": 468326,
	"./privilege.mp3": 21910,
	"./prize.mp3": 483199,
	"./probable.mp3": 821008,
	"./probably.mp3": 600068,
	"./problem.mp3": 666262,
	"./proceed.mp3": 531821,
	"./processes.mp3": 801724,
	"./procession.mp3": 462802,
	"./procrastinate.mp3": 859954,
	"./produce.mp3": 592131,
	"./produces.mp3": 906054,
	"./production.mp3": 618260,
	"./profession.mp3": 796919,
	"./professional.mp3": 690716,
	"./profile.mp3": 587988,
	"./profit.mp3": 204359,
	"./prognosis.mp3": 662611,
	"./program.mp3": 215411,
	"./programme.mp3": 917209,
	"./programmed.mp3": 59407,
	"./programmer.mp3": 955337,
	"./programs.mp3": 332214,
	"./progress.mp3": 3284,
	"./progressed.mp3": 552739,
	"./progression.mp3": 965830,
	"./progressive.mp3": 249254,
	"./prohet.mp3": 685249,
	"./project.mp3": 919368,
	"./prologue.mp3": 630130,
	"./promise.mp3": 444472,
	"./promised.mp3": 51212,
	"./promises.mp3": 18583,
	"./promising.mp3": 503453,
	"./promote.mp3": 292471,
	"./prone.mp3": 485253,
	"./pronounce.mp3": 899362,
	"./pronouncing.mp3": 926551,
	"./pronunciation.mp3": 508172,
	"./prooduce.mp3": 259672,
	"./propel.mp3": 330401,
	"./propet.mp3": 761561,
	"./prophecy.mp3": 706967,
	"./prophesy.mp3": 827943,
	"./prophet.mp3": 233181,
	"./proposal.mp3": 801971,
	"./propose.mp3": 127217,
	"./proposed.mp3": 197591,
	"./proposition.mp3": 133571,
	"./proret.mp3": 651303,
	"./proscribe.mp3": 808112,
	"./prospered.mp3": 386589,
	"./prospering.mp3": 520346,
	"./prosperity.mp3": 665534,
	"./prosperous.mp3": 319017,
	"./prospers.mp3": 551349,
	"./protein.mp3": 634162,
	"./proud.mp3": 654117,
	"./prove.mp3": 839309,
	"./proverb.mp3": 731453,
	"./provide.mp3": 595404,
	"./prune.mp3": 447,
	"./pry.mp3": 584776,
	"./publicity.mp3": 587970,
	"./publicly.mp3": 147955,
	"./pucket.mp3": 773517,
	"./pud.mp3": 284272,
	"./pudding.mp3": 459196,
	"./puff.mp3": 192608,
	"./pug.mp3": 97991,
	"./puge.mp3": 526540,
	"./puhe.mp3": 513421,
	"./puhh.mp3": 373052,
	"./puison.mp3": 272907,
	"./puke.mp3": 49920,
	"./pull.mp3": 160180,
	"./pulled.mp3": 751235,
	"./pulp.mp3": 635360,
	"./pump.mp3": 5383,
	"./pun.mp3": 482474,
	"./punctuation.mp3": 822871,
	"./puncture.mp3": 949419,
	"./punk.mp3": 574737,
	"./puny.mp3": 897139,
	"./pup.mp3": 583260,
	"./pupil.mp3": 53271,
	"./pupp.mp3": 653100,
	"./puppies.mp3": 343497,
	"./pure.mp3": 429299,
	"./purpose.mp3": 526697,
	"./pursar.mp3": 958708,
	"./purse.mp3": 301398,
	"./pursear.mp3": 165679,
	"./pursow.mp3": 275655,
	"./pursue.mp3": 913147,
	"./purtar.mp3": 535543,
	"./purtear.mp3": 892182,
	"./purtow.mp3": 411432,
	"./purtue.mp3": 891960,
	"./pus.mp3": 459987,
	"./push.mp3": 999985,
	"./pushes.mp3": 863233,
	"./puss.mp3": 986838,
	"./put.mp3": 53171,
	"./pyramid.mp3": 206731,
	"./q.mp3": 941970,
	"./qu.mp3": 449559,
	"./quach.mp3": 890773,
	"./quack.mp3": 146242,
	"./quadbike.mp3": 742527,
	"./quadrilateral.mp3": 785344,
	"./quag.mp3": 19483,
	"./quaip.mp3": 533567,
	"./quair.mp3": 286125,
	"./quait.mp3": 224635,
	"./qualities.mp3": 377588,
	"./quality.mp3": 354768,
	"./qualm.mp3": 457101,
	"./quam.mp3": 991105,
	"./quan.mp3": 565166,
	"./quang.mp3": 68705,
	"./quantity.mp3": 637998,
	"./quap.mp3": 976760,
	"./quarter.mp3": 357535,
	"./quat.mp3": 946324,
	"./quate.mp3": 853037,
	"./quear.mp3": 877025,
	"./queck.mp3": 31806,
	"./queen.mp3": 340465,
	"./queep.mp3": 720319,
	"./quench.mp3": 279507,
	"./quep.mp3": 520268,
	"./query.mp3": 526047,
	"./quest.mp3": 334493,
	"./question.mp3": 823537,
	"./questionable.mp3": 708613,
	"./questioned.mp3": 664738,
	"./questioning.mp3": 136327,
	"./questionnaire.mp3": 211800,
	"./quests.mp3": 807184,
	"./quet.mp3": 145168,
	"./quete.mp3": 544473,
	"./queue.mp3": 579030,
	"./queuing.mp3": 771427,
	"./quib.mp3": 666098,
	"./quick.mp3": 803418,
	"./quicker.mp3": 610271,
	"./quickest.mp3": 736842,
	"./quickly.mp3": 991739,
	"./quiet.mp3": 69207,
	"./quietly.mp3": 937758,
	"./quig.mp3": 583507,
	"./quiss.mp3": 904274,
	"./quit.mp3": 774380,
	"./quite.mp3": 694645,
	"./quiver.mp3": 950027,
	"./quix.mp3": 984600,
	"./quiz.mp3": 452970,
	"./quor.mp3": 903848,
	"./quot.mp3": 499830,
	"./quote.mp3": 36651,
	"./quow.mp3": 929257,
	"./r -2.mp3": 296958,
	"./r -3.mp3": 77251,
	"./r.mp3": 732517,
	"./ra.mp3": 498154,
	"./rabbit.mp3": 99713,
	"./race.mp3": 906954,
	"./rach.mp3": 411651,
	"./racial.mp3": 137945,
	"./rack.mp3": 957836,
	"./racket.mp3": 32619,
	"./rad.mp3": 54410,
	"./raddit.mp3": 593373,
	"./raff.mp3": 132286,
	"./raft.mp3": 757692,
	"./rag.mp3": 346141,
	"./rahh.mp3": 916618,
	"./rai.mp3": 101635,
	"./raid.mp3": 954381,
	"./raif.mp3": 164447,
	"./rain.mp3": 482455,
	"./rainbow.mp3": 306409,
	"./raise.mp3": 791579,
	"./rait.mp3": 908957,
	"./rak.mp3": 10129,
	"./rake.mp3": 841714,
	"./ram.mp3": 458279,
	"./ramp.mp3": 52037,
	"./ran.mp3": 603344,
	"./rang.mp3": 163787,
	"./range.mp3": 785920,
	"./rannit.mp3": 685177,
	"./ranoa.mp3": 800484,
	"./ranor.mp3": 118667,
	"./ranow.mp3": 465450,
	"./rantob.mp3": 646727,
	"./ranuhe.mp3": 844088,
	"./ranure.mp3": 20810,
	"./rap.mp3": 483318,
	"./rapid.mp3": 624753,
	"./rapp.mp3": 416954,
	"./rappit.mp3": 260685,
	"./raptop.mp3": 536227,
	"./rar.mp3": 771908,
	"./rare.mp3": 460093,
	"./ras.mp3": 938921,
	"./rass.mp3": 130100,
	"./rat.mp3": 141690,
	"./rather.mp3": 513275,
	"./rattit.mp3": 320701,
	"./ravi's.mp3": 393779,
	"./raw.mp3": 544589,
	"./rax.mp3": 322030,
	"./rayal.mp3": 659936,
	"./re-educate.mp3": 839456,
	"./re-elect.mp3": 471012,
	"./re-enter.mp3": 620083,
	"./re-entering.mp3": 387741,
	"./re-evaluate.mp3": 247734,
	"./re-examine.mp3": 917176,
	"./re-examining.mp3": 689821,
	"./re.mp3": 606950,
	"./reac.mp3": 374794,
	"./reach.mp3": 987614,
	"./react.mp3": 834138,
	"./reaction.mp3": 206152,
	"./reactive.mp3": 232148,
	"./read.mp3": 748793,
	"./reah.mp3": 483509,
	"./reak.mp3": 173730,
	"./realise.mp3": 198686,
	"./really.mp3": 38528,
	"./reappear.mp3": 101537,
	"./rear.mp3": 75039,
	"./rearrange.mp3": 267866,
	"./reason.mp3": 68593,
	"./reasonable.mp3": 569349,
	"./reat.mp3": 259305,
	"./reb.mp3": 131848,
	"./rebound.mp3": 791662,
	"./rebra.mp3": 124339,
	"./rebuild.mp3": 444638,
	"./receipt.mp3": 728579,
	"./receive.mp3": 876896,
	"./received.mp3": 886436,
	"./recent.mp3": 520952,
	"./recently.mp3": 637489,
	"./recite.mp3": 761375,
	"./reck.mp3": 782488,
	"./recognisable.mp3": 19475,
	"./recognise.mp3": 541960,
	"./recognised.mp3": 936316,
	"./recognises.mp3": 474023,
	"./recognising.mp3": 631021,
	"./recommend.mp3": 525281,
	"./recommended.mp3": 534738,
	"./record.mp3": 794166,
	"./recorded.mp3": 441733,
	"./recorder.mp3": 140259,
	"./recycle.mp3": 426300,
	"./recycling.mp3": 652569,
	"./red.mp3": 690454,
	"./redecorate.mp3": 744603,
	"./redevelop.mp3": 560689,
	"./redeveloped.mp3": 562850,
	"./redo.mp3": 476401,
	"./reduce.mp3": 44803,
	"./reebe.mp3": 685928,
	"./reed.mp3": 620725,
	"./reede.mp3": 905622,
	"./reef.mp3": 272679,
	"./reele.mp3": 238510,
	"./reet.mp3": 689445,
	"./referee.mp3": 780811,
	"./reference.mp3": 651240,
	"./referral.mp3": 109610,
	"./referred.mp3": 711214,
	"./referring.mp3": 206139,
	"./reff.mp3": 384458,
	"./reflect.mp3": 474808,
	"./reform.mp3": 926756,
	"./refresh.mp3": 293866,
	"./refusal.mp3": 462891,
	"./refuse.mp3": 491497,
	"./reg.mp3": 606217,
	"./regal.mp3": 562814,
	"./regardless.mp3": 467363,
	"./region.mp3": 445413,
	"./regionality.mp3": 54034,
	"./regionally.mp3": 499203,
	"./regions.mp3": 324104,
	"./registration.mp3": 682706,
	"./regret.mp3": 37210,
	"./regular.mp3": 194619,
	"./regularity.mp3": 565933,
	"./regularly.mp3": 330122,
	"./regulate.mp3": 726302,
	"./regulation.mp3": 104033,
	"./rehearse.mp3": 23274,
	"./reign.mp3": 190980,
	"./rein.mp3": 715771,
	"./reins.mp3": 15406,
	"./reject.mp3": 730824,
	"./relation.mp3": 142925,
	"./release.mp3": 400576,
	"./relevant.mp3": 185638,
	"./reliable.mp3": 79167,
	"./relief.mp3": 606010,
	"./relieved.mp3": 731817,
	"./relocate.mp3": 557300,
	"./relret.mp3": 723455,
	"./rem.mp3": 997395,
	"./remainder.mp3": 257074,
	"./remember.mp3": 801540,
	"./remove.mp3": 277049,
	"./ren.mp3": 637020,
	"./renat.mp3": 195543,
	"./rene.mp3": 798469,
	"./reneat.mp3": 898202,
	"./renege.mp3": 43821,
	"./renet.mp3": 888859,
	"./renoat.mp3": 476732,
	"./renovate.mp3": 275497,
	"./reorganise.mp3": 495574,
	"./rep.mp3": 536234,
	"./repair.mp3": 218934,
	"./replace.mp3": 500763,
	"./replay.mp3": 886908,
	"./replied.mp3": 190676,
	"./replies.mp3": 572767,
	"./reply.mp3": 739563,
	"./replying.mp3": 640229,
	"./report.mp3": 476387,
	"./reporter.mp3": 463330,
	"./reposition.mp3": 446851,
	"./request.mp3": 109620,
	"./requested.mp3": 178307,
	"./requesting.mp3": 888796,
	"./requests.mp3": 29419,
	"./rescar.mp3": 999173,
	"./rescay.mp3": 526106,
	"./rescear.mp3": 550760,
	"./rescow.mp3": 924570,
	"./rescue.mp3": 111402,
	"./rese.mp3": 838862,
	"./resign.mp3": 602265,
	"./resistant.mp3": 905542,
	"./resolute.mp3": 364324,
	"./resolutions.mp3": 730386,
	"./resolve.mp3": 124299,
	"./respect.mp3": 165821,
	"./respected.mp3": 252654,
	"./respectful.mp3": 190666,
	"./respecting.mp3": 179003,
	"./respective.mp3": 417137,
	"./ress.mp3": 161392,
	"./restaurant.mp3": 44004,
	"./restoration.mp3": 997359,
	"./restore.mp3": 133829,
	"./restored.mp3": 375019,
	"./restoring.mp3": 714164,
	"./ret.mp3": 645030,
	"./return.mp3": 59223,
	"./reveal.mp3": 224698,
	"./reverberate.mp3": 829000,
	"./revere.mp3": 603878,
	"./reverse.mp3": 945409,
	"./revert.mp3": 674491,
	"./review.mp3": 679189,
	"./revision.mp3": 899182,
	"./revisit.mp3": 113199,
	"./reward.mp3": 518188,
	"./rewind.mp3": 902440,
	"./rewrite.mp3": 746595,
	"./rhubarb.mp3": 50407,
	"./rhyme.mp3": 897978,
	"./rhythm.mp3": 501893,
	"./rib.mp3": 104860,
	"./ribe.mp3": 769413,
	"./ric.mp3": 723809,
	"./rice.mp3": 875682,
	"./rich.mp3": 399339,
	"./ricked.mp3": 198563,
	"./ricochet.mp3": 483198,
	"./rid.mp3": 700850,
	"./riddle.mp3": 467007,
	"./ride.mp3": 58887,
	"./riff.mp3": 829974,
	"./rift.mp3": 866804,
	"./rig.mp3": 468421,
	"./right.mp3": 528161,
	"./rigorous.mp3": 638121,
	"./rih.mp3": 827670,
	"./rik.mp3": 557705,
	"./rile.mp3": 528511,
	"./rill.mp3": 982514,
	"./rim.mp3": 704319,
	"./rin.mp3": 811592,
	"./rine.mp3": 292801,
	"./ring.mp3": 546739,
	"./rip.mp3": 21982,
	"./rir.mp3": 809132,
	"./ris.mp3": 171441,
	"./rise.mp3": 3666,
	"./rish.mp3": 881243,
	"./risit.mp3": 244918,
	"./risky.mp3": 444513,
	"./rit.mp3": 37634,
	"./rith.mp3": 849302,
	"./river.mp3": 572585,
	"./rix.mp3": 112870,
	"./riz.mp3": 864500,
	"./ro.mp3": 303212,
	"./roa.mp3": 29457,
	"./road.mp3": 612535,
	"./roaf.mp3": 333061,
	"./roal.mp3": 595135,
	"./roat.mp3": 179783,
	"./rob.mp3": 857022,
	"./robe.mp3": 145091,
	"./robin.mp3": 581395,
	"./rockair.mp3": 524066,
	"./rockar.mp3": 722311,
	"./rockare.mp3": 678156,
	"./rocker.mp3": 796795,
	"./rockerer.mp3": 855578,
	"./rocket.mp3": 527661,
	"./rockor.mp3": 604729,
	"./rocks.mp3": 867285,
	"./rod.mp3": 622672,
	"./rode.mp3": 842713,
	"./rof.mp3": 872674,
	"./rogue.mp3": 178501,
	"./roi.mp3": 447737,
	"./roial.mp3": 957486,
	"./roind.mp3": 319867,
	"./role.mp3": 28497,
	"./rom.mp3": 365469,
	"./romantically.mp3": 813134,
	"./romp.mp3": 24231,
	"./ron.mp3": 73738,
	"./rond.mp3": 997354,
	"./rone.mp3": 959503,
	"./ronkair.mp3": 87967,
	"./ronkar.mp3": 4848,
	"./ronkay.mp3": 681551,
	"./ronkey.mp3": 959515,
	"./ronkoy.mp3": 905917,
	"./roo.mp3": 299375,
	"./roof.mp3": 724347,
	"./room.mp3": 645724,
	"./root.mp3": 669657,
	"./rop.mp3": 966076,
	"./rope.mp3": 925349,
	"./ropics.mp3": 78107,
	"./ror.mp3": 341358,
	"./rose.mp3": 768504,
	"./ross.mp3": 492022,
	"./rot.mp3": 658368,
	"./rotation.mp3": 907443,
	"./roual.mp3": 407266,
	"./rough.mp3": 31740,
	"./round.mp3": 193495,
	"./row.mp3": 965143,
	"./royal.mp3": 643422,
	"./rream.mp3": 544340,
	"./rthym.mp3": 940091,
	"./rubble.mp3": 351423,
	"./rube.mp3": 184497,
	"./ruby.mp3": 469933,
	"./ruc.mp3": 165501,
	"./ruch.mp3": 264959,
	"./rude.mp3": 802299,
	"./rue.mp3": 292619,
	"./ruf.mp3": 287924,
	"./ruff.mp3": 785594,
	"./rug.mp3": 247769,
	"./ruh.mp3": 461058,
	"./ruind.mp3": 131333,
	"./ruk.mp3": 205589,
	"./rule.mp3": 552291,
	"./rum.mp3": 437347,
	"./rump.mp3": 240921,
	"./run.mp3": 232556,
	"./rund.mp3": 709328,
	"./rune.mp3": 269109,
	"./rung.mp3": 564263,
	"./runner.mp3": 202479,
	"./running.mp3": 609998,
	"./runny.mp3": 974611,
	"./rup.mp3": 418778,
	"./rus.mp3": 880301,
	"./ruse.mp3": 974110,
	"./rush.mp3": 460879,
	"./russ.mp3": 291808,
	"./rut.mp3": 251094,
	"./ruww.mp3": 511928,
	"./ruxx.mp3": 662614,
	"./ruyy.mp3": 918232,
	"./ruzz.mp3": 104962,
	"./s -2.mp3": 106809,
	"./s -3.mp3": 381588,
	"./s.mp3": 682240,
	"./sa.mp3": 153869,
	"./sach.mp3": 430512,
	"./sack.mp3": 548679,
	"./sacrifice.mp3": 906676,
	"./sact.mp3": 268196,
	"./sad.mp3": 589507,
	"./sadder.mp3": 480640,
	"./saddest.mp3": 911355,
	"./sadly.mp3": 562354,
	"./sadness.mp3": 270086,
	"./safe.mp3": 476210,
	"./sag.mp3": 466316,
	"./sai.mp3": 25930,
	"./said.mp3": 908074,
	"./saif.mp3": 770328,
	"./sail.mp3": 246082,
	"./saim.mp3": 523591,
	"./saip.mp3": 62294,
	"./sair.mp3": 243108,
	"./sait.mp3": 746330,
	"./sak.mp3": 247672,
	"./sal.mp3": 221675,
	"./salary.mp3": 53247,
	"./salt.mp3": 701589,
	"./salute.mp3": 97597,
	"./sam-2.mp3": 630811,
	"./sam.mp3": 282566,
	"./same.mp3": 480347,
	"./san.mp3": 399929,
	"./sand.mp3": 767087,
	"./sang.mp3": 373688,
	"./sanset.mp3": 238243,
	"./saof.mp3": 303578,
	"./sap.mp3": 917335,
	"./sar.mp3": 177189,
	"./sard.mp3": 551627,
	"./sas.mp3": 610560,
	"./sash.mp3": 622400,
	"./sat.mp3": 999603,
	"./satchel.mp3": 620505,
	"./sath.mp3": 929553,
	"./saturday.mp3": 479020,
	"./sauce.mp3": 951238,
	"./save.mp3": 399810,
	"./saw.mp3": 434620,
	"./say.mp3": 113210,
	"./says.mp3": 886457,
	"./saz.mp3": 32461,
	"./scab.mp3": 573314,
	"./scaib.mp3": 646213,
	"./scalp.mp3": 828948,
	"./scare.mp3": 393863,
	"./scared.mp3": 527697,
	"./scaring.mp3": 992166,
	"./scary.mp3": 169659,
	"./scaub.mp3": 351313,
	"./scene.mp3": 844583,
	"./scenery.mp3": 811288,
	"./scent.mp3": 801426,
	"./scheme.mp3": 735208,
	"./school.mp3": 744625,
	"./schools.mp3": 763532,
	"./scieb.mp3": 737529,
	"./science.mp3": 264385,
	"./scientific.mp3": 170358,
	"./scientist.mp3": 307045,
	"./scientists.mp3": 580040,
	"./scissors.mp3": 970816,
	"./sclue.mp3": 445719,
	"./score.mp3": 321737,
	"./scrap.mp3": 593344,
	"./scratch.mp3": 823249,
	"./scraw.mp3": 982387,
	"./scream.mp3": 524434,
	"./screw.mp3": 452687,
	"./scribble.mp3": 27721,
	"./scribbled.mp3": 617247,
	"./scribbles.mp3": 565780,
	"./scribbling.mp3": 269664,
	"./script.mp3": 245132,
	"./scronkair.mp3": 325793,
	"./scronkar.mp3": 23238,
	"./scronkay.mp3": 238673,
	"./scronkey.mp3": 570925,
	"./scronkoy.mp3": 540491,
	"./scroo.mp3": 433977,
	"./scrow.mp3": 422913,
	"./scruff.mp3": 594488,
	"./scrumptious.mp3": 784921,
	"./scub.mp3": 548038,
	"./scuff.mp3": 657432,
	"./se.mp3": 522025,
	"./sea.mp3": 661974,
	"./sead.mp3": 52326,
	"./seal.mp3": 418910,
	"./sear.mp3": 539144,
	"./search.mp3": 668301,
	"./seat.mp3": 97750,
	"./sebra.mp3": 524998,
	"./secc.mp3": 214699,
	"./secoa.mp3": 123312,
	"./second.mp3": 713765,
	"./secondary.mp3": 96865,
	"./secor.mp3": 886135,
	"./secow.mp3": 317134,
	"./secret.mp3": 820117,
	"./secretarial.mp3": 971334,
	"./secretaries.mp3": 202577,
	"./secretary.mp3": 595953,
	"./secretive.mp3": 881769,
	"./secretively.mp3": 402840,
	"./secretly.mp3": 978428,
	"./sect.mp3": 878056,
	"./section.mp3": 321234,
	"./secuhe.mp3": 703780,
	"./secure.mp3": 920294,
	"./sed.mp3": 538623,
	"./see.mp3": 346010,
	"./seef.mp3": 756808,
	"./seem.mp3": 23735,
	"./seen.mp3": 284896,
	"./seep.mp3": 58086,
	"./seer.mp3": 809716,
	"./seet.mp3": 949290,
	"./seff.mp3": 569073,
	"./seg.mp3": 103368,
	"./segg.mp3": 998387,
	"./seize.mp3": 586897,
	"./sel.mp3": 556023,
	"./self.mp3": 89491,
	"./sell.mp3": 28937,
	"./sem.mp3": 508978,
	"./seme.mp3": 26887,
	"./sen.mp3": 276549,
	"./send.mp3": 899499,
	"./sensation.mp3": 454747,
	"./senset.mp3": 826711,
	"./sensible.mp3": 155128,
	"./sensibly.mp3": 342076,
	"./sensitive.mp3": 689319,
	"./sentence.mp3": 784918,
	"./sentenced.mp3": 606182,
	"./sentences.mp3": 950189,
	"./sentencing.mp3": 505443,
	"./sep.mp3": 160971,
	"./separate.mp3": 275618,
	"./separated.mp3": 57042,
	"./separately.mp3": 238595,
	"./separating.mp3": 288727,
	"./september.mp3": 778266,
	"./sequence.mp3": 954694,
	"./serial.mp3": 239801,
	"./serious.mp3": 881625,
	"./serr.mp3": 48265,
	"./serve.mp3": 841950,
	"./sess.mp3": 466411,
	"./session.mp3": 853643,
	"./set.mp3": 469903,
	"./seven.mp3": 75716,
	"./seventeen.mp3": 777672,
	"./severe.mp3": 957977,
	"./sh -2.mp3": 974137,
	"./sh -3.mp3": 248916,
	"./sh .mp3": 642280,
	"./sh.mp3": 917696,
	"./sha.mp3": 631309,
	"./shack.mp3": 416007,
	"./shade.mp3": 282600,
	"./shadow.mp3": 630757,
	"./shaft.mp3": 957831,
	"./shai.mp3": 198410,
	"./shail.mp3": 113410,
	"./shal.mp3": 394155,
	"./shall.mp3": 243629,
	"./shaon.mp3": 333874,
	"./shape.mp3": 255612,
	"./shar.mp3": 833317,
	"./share.mp3": 874534,
	"./sharp.mp3": 312959,
	"./shart.mp3": 461499,
	"./shass.mp3": 614383,
	"./shat.mp3": 172083,
	"./shave.mp3": 783490,
	"./shawl.mp3": 715688,
	"./she'll.mp3": 681968,
	"./she.mp3": 483113,
	"./sheat.mp3": 965078,
	"./shed.mp3": 711103,
	"./sheel.mp3": 513394,
	"./sheen.mp3": 152224,
	"./sheer.mp3": 677044,
	"./sheff.mp3": 436401,
	"./sheg.mp3": 275848,
	"./shel.mp3": 212151,
	"./shelf.mp3": 956819,
	"./shell.mp3": 896265,
	"./shem.mp3": 165106,
	"./shen.mp3": 932677,
	"./shess.mp3": 333739,
	"./shich.mp3": 501912,
	"./shick.mp3": 660687,
	"./shid.mp3": 496843,
	"./shield.mp3": 630574,
	"./shiff.mp3": 766461,
	"./shift.mp3": 59327,
	"./shig.mp3": 492148,
	"./shill.mp3": 838149,
	"./shim.mp3": 165982,
	"./shin.mp3": 799089,
	"./shine.mp3": 505490,
	"./shing.mp3": 245760,
	"./shining.mp3": 902983,
	"./shink.mp3": 378628,
	"./shiny.mp3": 401414,
	"./ship.mp3": 848319,
	"./shirk.mp3": 314136,
	"./shirt.mp3": 913043,
	"./shis.mp3": 955592,
	"./shoa.mp3": 567828,
	"./shoal.mp3": 52256,
	"./shock.mp3": 959141,
	"./shoil.mp3": 194008,
	"./shol.mp3": 1589,
	"./shook.mp3": 676585,
	"./shool.mp3": 91258,
	"./shoon.mp3": 651176,
	"./shop.mp3": 108009,
	"./shore.mp3": 89840,
	"./shorn.mp3": 766543,
	"./short.mp3": 56837,
	"./should've.mp3": 159844,
	"./should.mp3": 786187,
	"./shoulder.mp3": 855025,
	"./shouldered.mp3": 148386,
	"./shouldering.mp3": 602247,
	"./shouldn't.mp3": 791311,
	"./shout.mp3": 945132,
	"./shouted.mp3": 948731,
	"./show.mp3": 6330,
	"./showl.mp3": 592018,
	"./shrew.mp3": 243974,
	"./shriek.mp3": 348191,
	"./shrill.mp3": 678659,
	"./shud.mp3": 623,
	"./shug.mp3": 480376,
	"./shump.mp3": 642686,
	"./shup.mp3": 496923,
	"./shurn.mp3": 687173,
	"./shy.mp3": 376693,
	"./shyly.mp3": 372636,
	"./sich.mp3": 634584,
	"./sick.mp3": 277007,
	"./sid.mp3": 840715,
	"./side.mp3": 522496,
	"./siege.mp3": 886650,
	"./siff.mp3": 382781,
	"./sift.mp3": 191999,
	"./sig.mp3": 836020,
	"./sigh.mp3": 676476,
	"./sight.mp3": 41104,
	"./sign.mp3": 628498,
	"./signal.mp3": 16869,
	"./signalling.mp3": 705133,
	"./signature.mp3": 776681,
	"./significance.mp3": 626054,
	"./signify.mp3": 629656,
	"./signing.mp3": 404998,
	"./sik.mp3": 472944,
	"./sil.mp3": 985443,
	"./silence.mp3": 494446,
	"./silently.mp3": 846559,
	"./silk.mp3": 681294,
	"./silliness.mp3": 16451,
	"./silly.mp3": 185362,
	"./silt.mp3": 940029,
	"./sim.mp3": 993502,
	"./sime.mp3": 121763,
	"./similar.mp3": 943392,
	"./simplicity.mp3": 971766,
	"./simply.mp3": 807731,
	"./sin.mp3": 142961,
	"./since.mp3": 658341,
	"./sincere.mp3": 518110,
	"./sincerely.mp3": 167175,
	"./sing.mp3": 378432,
	"./singe.mp3": 744553,
	"./sinset.mp3": 617515,
	"./sip.mp3": 675839,
	"./sir.mp3": 428397,
	"./sird.mp3": 51875,
	"./sis.mp3": 783112,
	"./sister.mp3": 384285,
	"./sit.mp3": 366907,
	"./site.mp3": 208912,
	"./six.mp3": 50039,
	"./sixteen.mp3": 472779,
	"./sizeable.mp3": 283138,
	"./skart.mp3": 500634,
	"./skate.mp3": 646253,
	"./skeat.mp3": 351671,
	"./skep.mp3": 310220,
	"./sketch.mp3": 14885,
	"./ski.mp3": 442280,
	"./skilful.mp3": 223889,
	"./skill.mp3": 867088,
	"./skin.mp3": 770518,
	"./skip.mp3": 901744,
	"./skirt.mp3": 157314,
	"./skit.mp3": 725804,
	"./skort .mp3": 678924,
	"./skort.mp3": 25004,
	"./skunk.mp3": 442065,
	"./sky.mp3": 288568,
	"./slack.mp3": 35115,
	"./slade.mp3": 753740,
	"./slane.mp3": 392334,
	"./slang.mp3": 860828,
	"./slant.mp3": 769891,
	"./slave.mp3": 550662,
	"./slede.mp3": 280000,
	"./sledge.mp3": 988583,
	"./sleep.mp3": 119018,
	"./sleepily.mp3": 391410,
	"./sleigh.mp3": 725287,
	"./slene.mp3": 260370,
	"./slept.mp3": 3305,
	"./slice.mp3": 259613,
	"./slide.mp3": 606996,
	"./slime.mp3": 806663,
	"./sline.mp3": 554438,
	"./sling.mp3": 240551,
	"./slippery.mp3": 986905,
	"./slit.mp3": 667663,
	"./slode.mp3": 30506,
	"./slone.mp3": 183368,
	"./sloth.mp3": 66035,
	"./slow.mp3": 759958,
	"./slowly.mp3": 735999,
	"./slu.mp3": 701557,
	"./slung.mp3": 308432,
	"./slurp.mp3": 314311,
	"./slush.mp3": 682840,
	"./sly.mp3": 966841,
	"./small.mp3": 630286,
	"./smart.mp3": 459956,
	"./smarter.mp3": 76389,
	"./smash.mp3": 579751,
	"./smell.mp3": 604722,
	"./smelly.mp3": 616507,
	"./smile.mp3": 168755,
	"./smith's.mp3": 36984,
	"./smoothly.mp3": 35838,
	"./smoulder.mp3": 812948,
	"./smudged.mp3": 316150,
	"./snack.mp3": 692889,
	"./snail.mp3": 899012,
	"./snare.mp3": 650892,
	"./sneeze.mp3": 66879,
	"./snick.mp3": 565745,
	"./sniff.mp3": 488247,
	"./snort.mp3": 459551,
	"./snow.mp3": 133816,
	"./snuff.mp3": 956139,
	"./so.mp3": 94835,
	"./soa.mp3": 395348,
	"./soaf.mp3": 840602,
	"./soal.mp3": 668576,
	"./soap.mp3": 193396,
	"./soat.mp3": 864600,
	"./soch.mp3": 301266,
	"./social.mp3": 694780,
	"./socialise.mp3": 936781,
	"./sock.mp3": 91813,
	"./sod.mp3": 38301,
	"./sof.mp3": 819183,
	"./soft.mp3": 659929,
	"./sog.mp3": 593546,
	"./soi.mp3": 644428,
	"./soil.mp3": 326680,
	"./soind.mp3": 562570,
	"./sol.mp3": 829109,
	"./solar.mp3": 11060,
	"./solder.mp3": 144026,
	"./soldier.mp3": 777029,
	"./solemn.mp3": 450423,
	"./solution.mp3": 829996,
	"./solve.mp3": 179626,
	"./solvent.mp3": 998756,
	"./solver.mp3": 857924,
	"./som.mp3": 142480,
	"./some.mp3": 451929,
	"./something.mp3": 104867,
	"./sometimes.mp3": 253889,
	"./somewhere.mp3": 518338,
	"./somp.mp3": 439176,
	"./son.mp3": 997415,
	"./sond.mp3": 175134,
	"./song.mp3": 319646,
	"./sonset.mp3": 835393,
	"./soof.mp3": 721280,
	"./soon.mp3": 783848,
	"./soot.mp3": 749858,
	"./sop.mp3": 451881,
	"./sor.mp3": 984859,
	"./sord.mp3": 503253,
	"./sore.mp3": 222512,
	"./sorf.mp3": 824327,
	"./sort.mp3": 189509,
	"./sot.mp3": 83725,
	"./sought.mp3": 159719,
	"./sound.mp3": 596902,
	"./soup.mp3": 770096,
	"./south.mp3": 783124,
	"./sow.mp3": 350202,
	"./sowl.mp3": 724690,
	"./spa.mp3": 838773,
	"./space.mp3": 563585,
	"./spacious.mp3": 135984,
	"./spaciously.mp3": 259401,
	"./spack.mp3": 900895,
	"./spam.mp3": 215950,
	"./spare.mp3": 623118,
	"./spark.mp3": 255816,
	"./speak.mp3": 898765,
	"./special.mp3": 341950,
	"./specialise.mp3": 717423,
	"./specialises.mp3": 711978,
	"./specified.mp3": 934697,
	"./specify.mp3": 316026,
	"./specifying.mp3": 822046,
	"./speck.mp3": 964283,
	"./spectate.mp3": 556392,
	"./speke.mp3": 296093,
	"./spell.mp3": 950417,
	"./spend.mp3": 685283,
	"./spends.mp3": 185190,
	"./spew.mp3": 701872,
	"./sphere.mp3": 999442,
	"./spicy.mp3": 593141,
	"./spied.mp3": 213134,
	"./spies.mp3": 816405,
	"./spike.mp3": 418465,
	"./spiky.mp3": 920381,
	"./spill.mp3": 372797,
	"./spim.mp3": 232054,
	"./spin.mp3": 661481,
	"./spine.mp3": 562458,
	"./splach.mp3": 216620,
	"./splaf.mp3": 27213,
	"./splag.mp3": 853608,
	"./splas.mp3": 338836,
	"./splash.mp3": 790236,
	"./spoke.mp3": 18955,
	"./spontaneous.mp3": 837176,
	"./spoon.mp3": 190752,
	"./sport.mp3": 179389,
	"./spotless.mp3": 866146,
	"./spra.mp3": 251523,
	"./sprai.mp3": 8828,
	"./sprair.mp3": 426046,
	"./spraw.mp3": 142666,
	"./spray.mp3": 709900,
	"./spread.mp3": 256084,
	"./spree.mp3": 71212,
	"./sprene.mp3": 698624,
	"./sprew.mp3": 440974,
	"./sprine.mp3": 25620,
	"./spring.mp3": 421574,
	"./sproi.mp3": 178682,
	"./sproiy.mp3": 276611,
	"./sprone.mp3": 154906,
	"./sproo.mp3": 808900,
	"./sprouy.mp3": 994463,
	"./sprow.mp3": 15436,
	"./sproy.mp3": 91402,
	"./spruiy.mp3": 302525,
	"./sprune.mp3": 514288,
	"./spruy.mp3": 914680,
	"./spuke.mp3": 328653,
	"./spy.mp3": 93389,
	"./squad.mp3": 697713,
	"./squander.mp3": 993240,
	"./square.mp3": 288220,
	"./squash.mp3": 748646,
	"./squawk.mp3": 294861,
	"./squirrel.mp3": 530384,
	"./ss.mp3": 889327,
	"./sta.mp3": 612489,
	"./stable.mp3": 919964,
	"./stack.mp3": 846563,
	"./staff.mp3": 400721,
	"./stage.mp3": 621089,
	"./stair.mp3": 221936,
	"./staird.mp3": 966420,
	"./stake.mp3": 163173,
	"./stale.mp3": 410940,
	"./stalk.mp3": 89530,
	"./stam.mp3": 352338,
	"./stame.mp3": 858535,
	"./stamp.mp3": 722286,
	"./stan.mp3": 142885,
	"./stand.mp3": 259787,
	"./stang.mp3": 255092,
	"./stank.mp3": 892016,
	"./stapar.mp3": 570526,
	"./stapay.mp3": 372889,
	"./stapear.mp3": 673413,
	"./stapow.mp3": 271293,
	"./stapue.mp3": 553529,
	"./star.mp3": 212601,
	"./stard.mp3": 247215,
	"./stare.mp3": 21578,
	"./starfish.mp3": 970499,
	"./start.mp3": 721823,
	"./started.mp3": 967784,
	"./stash.mp3": 62364,
	"./statar.mp3": 77922,
	"./statay.mp3": 570717,
	"./state.mp3": 286948,
	"./statear.mp3": 147817,
	"./station.mp3": 790343,
	"./stationary.mp3": 88547,
	"./stationery.mp3": 287151,
	"./statow.mp3": 471697,
	"./statue.mp3": 862093,
	"./stature.mp3": 496859,
	"./staw.mp3": 670840,
	"./stay.mp3": 291262,
	"./steak.mp3": 971017,
	"./steal.mp3": 739290,
	"./steam.mp3": 448255,
	"./sted.mp3": 124963,
	"./stee.mp3": 649374,
	"./steel.mp3": 477670,
	"./steer.mp3": 704480,
	"./steering.mp3": 934560,
	"./stem.mp3": 766438,
	"./steme.mp3": 298107,
	"./stene.mp3": 359210,
	"./stew.mp3": 274780,
	"./stick.mp3": 285003,
	"./stied.mp3": 89490,
	"./stiff.mp3": 569609,
	"./still.mp3": 184225,
	"./stilt.mp3": 768409,
	"./stime.mp3": 574607,
	"./stine.mp3": 986734,
	"./sting.mp3": 432252,
	"./stink.mp3": 882664,
	"./stir.mp3": 663617,
	"./stitch.mp3": 591174,
	"./stoad.mp3": 944292,
	"./stoam.mp3": 302817,
	"./stock.mp3": 340121,
	"./stole.mp3": 278650,
	"./stolhin.mp3": 471466,
	"./stolphin.mp3": 520228,
	"./stolpin.mp3": 44578,
	"./stolrin.mp3": 595476,
	"./stomach.mp3": 376860,
	"./stome.mp3": 419165,
	"./stomp.mp3": 844932,
	"./stone.mp3": 677072,
	"./stoo.mp3": 885462,
	"./stool.mp3": 527390,
	"./stop.mp3": 297429,
	"./stopped.mp3": 165560,
	"./storage.mp3": 25728,
	"./store.mp3": 755596,
	"./stored.mp3": 499376,
	"./stores.mp3": 132563,
	"./stories.mp3": 279148,
	"./storm.mp3": 22868,
	"./stove.mp3": 451528,
	"./stow.mp3": 206622,
	"./strai.mp3": 256144,
	"./straight.mp3": 259471,
	"./strait.mp3": 216484,
	"./strand.mp3": 537165,
	"./strange.mp3": 93023,
	"./strangely.mp3": 981446,
	"./straw.mp3": 136118,
	"./stray.mp3": 808192,
	"./streak.mp3": 880907,
	"./stream.mp3": 753789,
	"./stree.mp3": 266512,
	"./street.mp3": 882980,
	"./streke.mp3": 399579,
	"./strength.mp3": 205698,
	"./stretch.mp3": 797208,
	"./stretched.mp3": 374807,
	"./strike.mp3": 594943,
	"./stripes.mp3": 408653,
	"./strobe.mp3": 631922,
	"./stroe.mp3": 525474,
	"./stroke.mp3": 47661,
	"./strop.mp3": 216563,
	"./stroy.mp3": 155446,
	"./structures.mp3": 231999,
	"./struke.mp3": 559531,
	"./stuck.mp3": 67703,
	"./student.mp3": 700582,
	"./students'.mp3": 896988,
	"./studious.mp3": 982059,
	"./stuff.mp3": 299189,
	"./stume.mp3": 784779,
	"./stump.mp3": 427290,
	"./stun.mp3": 309961,
	"./stune.mp3": 358202,
	"./stung.mp3": 918120,
	"./stunk.mp3": 951356,
	"./stunt.mp3": 310831,
	"./sty.mp3": 709873,
	"./style.mp3": 494708,
	"./subconscious.mp3": 877909,
	"./subdivide.mp3": 912162,
	"./subdivided.mp3": 699474,
	"./subheading.mp3": 541349,
	"./submarine.mp3": 771687,
	"./submerge.mp3": 863523,
	"./subscribe.mp3": 685331,
	"./subscript.mp3": 361440,
	"./substance.mp3": 40549,
	"./substantial.mp3": 554675,
	"./substitute.mp3": 455093,
	"./subtitle.mp3": 599865,
	"./subtract.mp3": 681121,
	"./subtraction.mp3": 665085,
	"./subvert.mp3": 770708,
	"./subway.mp3": 93202,
	"./success.mp3": 154554,
	"./successful.mp3": 544863,
	"./sucessfully.mp3": 929437,
	"./suddenly.mp3": 38969,
	"./sufficient.mp3": 841197,
	"./sug.mp3": 307896,
	"./sugar.mp3": 833405,
	"./suggest.mp3": 316161,
	"./suggested.mp3": 174322,
	"./suggestible.mp3": 260861,
	"./suggestion.mp3": 249117,
	"./suggestive.mp3": 562765,
	"./suhe.mp3": 866600,
	"./suil.mp3": 200198,
	"./suind.mp3": 271496,
	"./sulk.mp3": 369066,
	"./sult.mp3": 62625,
	"./sum.mp3": 401442,
	"./sume.mp3": 883479,
	"./summair.mp3": 255829,
	"./summar.mp3": 328946,
	"./summare.mp3": 520583,
	"./summer.mp3": 537286,
	"./summerer.mp3": 976979,
	"./summor.mp3": 976736,
	"./sump.mp3": 775358,
	"./sun.mp3": 711221,
	"./sund.mp3": 323387,
	"./sunday.mp3": 817289,
	"./sunk.mp3": 267680,
	"./sunny.mp3": 620470,
	"./sunset.mp3": 363111,
	"./sup.mp3": 324443,
	"./supercilious.mp3": 978814,
	"./superficial.mp3": 474866,
	"./superhero.mp3": 941578,
	"./superhuman.mp3": 289817,
	"./superior.mp3": 975052,
	"./superman.mp3": 457134,
	"./supermarket.mp3": 375826,
	"./supernatural.mp3": 601301,
	"./superscript.mp3": 369451,
	"./supersonic.mp3": 683514,
	"./superstar.mp3": 52914,
	"./superstitious.mp3": 655500,
	"./supervise.mp3": 313305,
	"./suppair.mp3": 231055,
	"./suppar.mp3": 148224,
	"./suppare.mp3": 523625,
	"./supper.mp3": 324236,
	"./supperer.mp3": 793821,
	"./suppor.mp3": 170962,
	"./support.mp3": 705618,
	"./supporters.mp3": 170434,
	"./suppose.mp3": 605628,
	"./supposedly.mp3": 305721,
	"./supposing.mp3": 700057,
	"./sure.mp3": 346778,
	"./surf.mp3": 808301,
	"./surface.mp3": 655266,
	"./surprise.mp3": 145064,
	"./surprised.mp3": 133404,
	"./surprising.mp3": 513229,
	"./surrender.mp3": 319717,
	"./surround.mp3": 369131,
	"./survey.mp3": 134767,
	"./survive.mp3": 161585,
	"./suspicious.mp3": 37124,
	"./swade.mp3": 495113,
	"./swaird.mp3": 377583,
	"./swallow.mp3": 91822,
	"./swam.mp3": 145197,
	"./swan.mp3": 683674,
	"./swang.mp3": 310317,
	"./swap.mp3": 497452,
	"./swapt.mp3": 615104,
	"./sward.mp3": 914078,
	"./swarm.mp3": 91915,
	"./swast.mp3": 724285,
	"./swat.mp3": 189744,
	"./sway.mp3": 512665,
	"./swear.mp3": 650309,
	"./sweast.mp3": 427444,
	"./sweat.mp3": 800147,
	"./sweater.mp3": 704946,
	"./swed.mp3": 559588,
	"./swede.mp3": 578589,
	"./sweeo.mp3": 935424,
	"./sweep.mp3": 546539,
	"./swell.mp3": 44040,
	"./swept.mp3": 847900,
	"./swerve.mp3": 508065,
	"./swest.mp3": 776057,
	"./swide.mp3": 723473,
	"./swied.mp3": 289011,
	"./swift.mp3": 14234,
	"./swim.mp3": 851445,
	"./swimming.mp3": 573530,
	"./swing.mp3": 959909,
	"./swipe.mp3": 878845,
	"./swirly.mp3": 840543,
	"./swoad.mp3": 829173,
	"./swoast.mp3": 822814,
	"./swode.mp3": 707135,
	"./swong.mp3": 92667,
	"./sword.mp3": 187368,
	"./swung.mp3": 895441,
	"./symbol.mp3": 245365,
	"./symbolic.mp3": 695793,
	"./symmetric.mp3": 278370,
	"./symmetrical.mp3": 669365,
	"./symmetry.mp3": 540855,
	"./sympathetic.mp3": 338352,
	"./sympathy.mp3": 79344,
	"./system.mp3": 127550,
	"./systematic.mp3": 130125,
	"./systems.mp3": 72485,
	"./t -2.mp3": 908620,
	"./t -3.mp3": 966481,
	"./t.mp3": 859379,
	"./ta.mp3": 917908,
	"./table.mp3": 565155,
	"./tables.mp3": 722022,
	"./tacher.mp3": 763428,
	"./tack.mp3": 388742,
	"./tacket.mp3": 191493,
	"./tact.mp3": 283365,
	"./tactician.mp3": 625379,
	"./tad.mp3": 484360,
	"./tag.mp3": 377087,
	"./tai.mp3": 912929,
	"./taid.mp3": 103591,
	"./taik.mp3": 501524,
	"./tail.mp3": 925359,
	"./tailm.mp3": 729372,
	"./tain.mp3": 144477,
	"./taint.mp3": 267587,
	"./tair.mp3": 546305,
	"./tait.mp3": 717975,
	"./tak.mp3": 807379,
	"./take.mp3": 613400,
	"./taki.mp3": 886828,
	"./talented.mp3": 548276,
	"./talk.mp3": 703799,
	"./tall.mp3": 730140,
	"./tallest.mp3": 57452,
	"./tally.mp3": 930777,
	"./talm.mp3": 865441,
	"./talt.mp3": 489780,
	"./tam.mp3": 141189,
	"./tame.mp3": 945990,
	"./tamp.mp3": 389599,
	"./tan.mp3": 373618,
	"./tangible.mp3": 633649,
	"./tank.mp3": 191065,
	"./tant.mp3": 67570,
	"./tao.mp3": 751287,
	"./taon.mp3": 793339,
	"./tap.mp3": 537268,
	"./tar.mp3": 785638,
	"./tarel.mp3": 842781,
	"./tari.mp3": 229111,
	"./tarl.mp3": 143758,
	"./tarn.mp3": 281628,
	"./tas.mp3": 541963,
	"./tase.mp3": 510976,
	"./tasi.mp3": 584964,
	"./tass.mp3": 193278,
	"./tat.mp3": 208472,
	"./taught.mp3": 697064,
	"./taunt.mp3": 507631,
	"./taut.mp3": 648867,
	"./tax.mp3": 481900,
	"./taxi.mp3": 92345,
	"./tay.mp3": 844209,
	"./te.mp3": 948344,
	"./tea.mp3": 973109,
	"./teach.mp3": 714024,
	"./teacher's.mp3": 407071,
	"./teacher.mp3": 86273,
	"./teachers'.mp3": 572663,
	"./teachers.mp3": 850844,
	"./teal.mp3": 596883,
	"./team.mp3": 614990,
	"./tear.mp3": 873725,
	"./teb.mp3": 536482,
	"./tecc.mp3": 79874,
	"./techer.mp3": 142800,
	"./technical.mp3": 368706,
	"./technician.mp3": 728103,
	"./technique.mp3": 301413,
	"./technology.mp3": 162055,
	"./teck.mp3": 46314,
	"./teckon.mp3": 397409,
	"./ted.mp3": 788428,
	"./tee.mp3": 846289,
	"./teebe.mp3": 340386,
	"./teed.mp3": 194359,
	"./teek.mp3": 938596,
	"./teen.mp3": 56365,
	"./teene.mp3": 890142,
	"./teese.mp3": 185141,
	"./teet.mp3": 219079,
	"./teether.mp3": 873200,
	"./teg.mp3": 242243,
	"./tegg.mp3": 814778,
	"./teke.mp3": 919268,
	"./telegram.mp3": 479076,
	"./telephone.mp3": 249895,
	"./teleport.mp3": 190092,
	"./telescope.mp3": 904231,
	"./television.mp3": 661873,
	"./tell.mp3": 929504,
	"./telm.mp3": 58245,
	"./telt.mp3": 125528,
	"./tem.mp3": 111545,
	"./teme.mp3": 653898,
	"./temperament.mp3": 523379,
	"./temperate.mp3": 361734,
	"./temperature.mp3": 482081,
	"./tempered.mp3": 51545,
	"./tempering.mp3": 451422,
	"./tempermental.mp3": 878989,
	"./temporary.mp3": 135358,
	"./ten.mp3": 451654,
	"./tenacious.mp3": 104930,
	"./tend.mp3": 630390,
	"./tennis.mp3": 724276,
	"./tension.mp3": 279025,
	"./tent.mp3": 458118,
	"./tep.mp3": 991552,
	"./term.mp3": 312623,
	"./terminal.mp3": 861289,
	"./terminate.mp3": 647154,
	"./termination.mp3": 961869,
	"./terminology.mp3": 686414,
	"./terr.mp3": 495676,
	"./terraform.mp3": 595819,
	"./terrain.mp3": 390044,
	"./terrapin.mp3": 457034,
	"./terrible.mp3": 139644,
	"./terribly.mp3": 622072,
	"./territorial.mp3": 514034,
	"./territory.mp3": 774949,
	"./terrorise.mp3": 814100,
	"./test.mp3": 590289,
	"./tet.mp3": 603708,
	"./th -2.mp3": 448314,
	"./th -3.mp3": 61279,
	"./th -4.mp3": 562180,
	"./th .mp3": 332243,
	"./th-2.mp3": 244660,
	"./th.mp3": 224849,
	"./th2.mp3": 38449,
	"./thail.mp3": 511345,
	"./thair.mp3": 374847,
	"./thal.mp3": 21750,
	"./thall.mp3": 913662,
	"./thame.mp3": 309168,
	"./than.mp3": 437188,
	"./thank.mp3": 820963,
	"./thanks.mp3": 903846,
	"./thar.mp3": 658128,
	"./thard.mp3": 248116,
	"./tharst.mp3": 121001,
	"./tharteen.mp3": 784996,
	"./thase.mp3": 632022,
	"./thass.mp3": 340056,
	"./that's.mp3": 916012,
	"./that.mp3": 45502,
	"./thatch.mp3": 509943,
	"./thaw.mp3": 217937,
	"./thawl.mp3": 645887,
	"./thay.mp3": 818479,
	"./the.mp3": 383282,
	"./thead.mp3": 343661,
	"./thear.mp3": 755979,
	"./theard.mp3": 739237,
	"./theast.mp3": 245241,
	"./theateen.mp3": 156967,
	"./thed.mp3": 266242,
	"./theff.mp3": 207494,
	"./their.mp3": 504771,
	"./theirs.mp3": 462918,
	"./them.mp3": 890383,
	"./theme.mp3": 333828,
	"./then.mp3": 790488,
	"./there's.mp3": 72971,
	"./there.mp3": 788293,
	"./therefore.mp3": 942591,
	"./these.mp3": 182882,
	"./they're.mp3": 948245,
	"./they.mp3": 107643,
	"./thick.mp3": 333512,
	"./thid.mp3": 42790,
	"./thief.mp3": 162199,
	"./thime.mp3": 673096,
	"./thimnair.mp3": 121805,
	"./thimnar.mp3": 106282,
	"./thimnay.mp3": 884373,
	"./thimney.mp3": 225241,
	"./thimnoy.mp3": 139831,
	"./thin.mp3": 739052,
	"./thing.mp3": 9191,
	"./things.mp3": 701362,
	"./think.mp3": 801067,
	"./thip.mp3": 925274,
	"./third.mp3": 975356,
	"./thirst.mp3": 462497,
	"./thirsty.mp3": 420342,
	"./thirteen.mp3": 496716,
	"./this.mp3": 386797,
	"./thise.mp3": 419038,
	"./thist.mp3": 404819,
	"./thistle.mp3": 587126,
	"./thiteen.mp3": 317486,
	"./thoa.mp3": 692837,
	"./thoad.mp3": 154635,
	"./thoil.mp3": 374123,
	"./thome.mp3": 498458,
	"./thor.mp3": 340514,
	"./thord.mp3": 988114,
	"./thorn.mp3": 486504,
	"./thorough.mp3": 785003,
	"./thoroughly.mp3": 976218,
	"./thorst.mp3": 910727,
	"./thorteen.mp3": 429754,
	"./those.mp3": 113900,
	"./though.mp3": 248416,
	"./thought.mp3": 634676,
	"./thoughtful.mp3": 552737,
	"./thoughtfully.mp3": 274032,
	"./thoughts.mp3": 661547,
	"./thow.mp3": 588803,
	"./thowl.mp3": 489637,
	"./thraw.mp3": 481073,
	"./thread.mp3": 927309,
	"./three.mp3": 778279,
	"./threw.mp3": 678693,
	"./thrill.mp3": 446982,
	"./throo.mp3": 984379,
	"./through.mp3": 39040,
	"./throw.mp3": 755939,
	"./thud.mp3": 207346,
	"./thue.mp3": 585015,
	"./thug.mp3": 974917,
	"./thumb.mp3": 727983,
	"./thump.mp3": 508877,
	"./thunder.mp3": 607277,
	"./thundered.mp3": 617054,
	"./thunk.mp3": 718239,
	"./thursday.mp3": 94939,
	"./thuse.mp3": 448594,
	"./ti.mp3": 166988,
	"./tibe.mp3": 106467,
	"./tick.mp3": 149646,
	"./ticken.mp3": 860839,
	"./ticket.mp3": 463501,
	"./tict.mp3": 924733,
	"./tid.mp3": 636272,
	"./tidiness.mp3": 457580,
	"./tie.mp3": 917013,
	"./tient.mp3": 883703,
	"./tiet.mp3": 133035,
	"./tiff.mp3": 980512,
	"./tig.mp3": 754439,
	"./tight.mp3": 649667,
	"./tik.mp3": 4043,
	"./tike.mp3": 507200,
	"./til.mp3": 670552,
	"./till.mp3": 948084,
	"./tilm.mp3": 907929,
	"./tilt.mp3": 188444,
	"./tim.mp3": 876925,
	"./time.mp3": 267534,
	"./timid.mp3": 801626,
	"./timney.mp3": 62403,
	"./timorous.mp3": 683377,
	"./timp.mp3": 250759,
	"./tin.mp3": 138922,
	"./tine.mp3": 920879,
	"./tinsel.mp3": 668594,
	"./tint.mp3": 782522,
	"./tiny.mp3": 668915,
	"./tip.mp3": 239708,
	"./tipet.mp3": 450139,
	"./tiptoe.mp3": 157096,
	"./tir.mp3": 771214,
	"./tirl.mp3": 156086,
	"./tirp.mp3": 42466,
	"./tis.mp3": 269459,
	"./tit.mp3": 474528,
	"./titet.mp3": 960495,
	"./tix.mp3": 473956,
	"./to.mp3": 915042,
	"./toa.mp3": 725939,
	"./toacher.mp3": 932407,
	"./toad.mp3": 817245,
	"./toael.mp3": 123732,
	"./toak.mp3": 308798,
	"./toal.mp3": 608053,
	"./toam.mp3": 921424,
	"./toan.mp3": 776359,
	"./toast.mp3": 215158,
	"./tob.mp3": 160956,
	"./tobe.mp3": 523045,
	"./tock.mp3": 66676,
	"./tocket.mp3": 665523,
	"./tocknair.mp3": 571646,
	"./tocknar.mp3": 406187,
	"./tocknay.mp3": 134476,
	"./tockney.mp3": 792219,
	"./tocknoy.mp3": 515978,
	"./tod.mp3": 808530,
	"./today.mp3": 423372,
	"./toe.mp3": 313047,
	"./toel.mp3": 762985,
	"./toffee.mp3": 29088,
	"./toft.mp3": 721876,
	"./tog.mp3": 599077,
	"./together.mp3": 209495,
	"./toi.mp3": 686107,
	"./toil.mp3": 935293,
	"./toin.mp3": 371343,
	"./tok.mp3": 153129,
	"./toke.mp3": 124954,
	"./told.mp3": 956090,
	"./tolerable.mp3": 848287,
	"./tolerably.mp3": 711619,
	"./tolerance.mp3": 412798,
	"./tolerant.mp3": 631238,
	"./toleration.mp3": 792270,
	"./tolm.mp3": 243863,
	"./tom.mp3": 995039,
	"./tome.mp3": 47348,
	"./tomorrow.mp3": 988020,
	"./ton.mp3": 611368,
	"./tonait.mp3": 675234,
	"./tone.mp3": 980961,
	"./toneet.mp3": 874210,
	"./tonet.mp3": 795863,
	"./tongue.mp3": 51649,
	"./tonight.mp3": 657944,
	"./too.mp3": 784973,
	"./took.mp3": 26616,
	"./toon.mp3": 178873,
	"./toose.mp3": 334185,
	"./top.mp3": 231102,
	"./tor.mp3": 345676,
	"./torch.mp3": 893153,
	"./torel.mp3": 770803,
	"./torl.mp3": 315160,
	"./torn.mp3": 783530,
	"./tot.mp3": 93730,
	"./total.mp3": 137269,
	"./tou.mp3": 698663,
	"./touch.mp3": 619478,
	"./tough.mp3": 790122,
	"./tourist.mp3": 364449,
	"./toward.mp3": 617064,
	"./towards.mp3": 533895,
	"./towel.mp3": 282142,
	"./towl.mp3": 324435,
	"./town.mp3": 556833,
	"./toy.mp3": 617387,
	"./tra.mp3": 357740,
	"./trace.mp3": 19304,
	"./track.mp3": 123374,
	"./tradition.mp3": 341259,
	"./train.mp3": 381045,
	"./trair.mp3": 3817,
	"./trairs.mp3": 511092,
	"./trane.mp3": 474255,
	"./tranquil.mp3": 434211,
	"./transcendent.mp3": 803538,
	"./transcribe.mp3": 224236,
	"./transect.mp3": 155343,
	"./transfer.mp3": 16576,
	"./transference.mp3": 431185,
	"./transferred.mp3": 337129,
	"./transferring.mp3": 482126,
	"./transformed.mp3": 133612,
	"./translate.mp3": 713325,
	"./transmission.mp3": 783481,
	"./transmit.mp3": 774933,
	"./transparent.mp3": 410417,
	"./transplant.mp3": 553548,
	"./transport.mp3": 900856,
	"./transportation.mp3": 382123,
	"./transported.mp3": 465655,
	"./trap.mp3": 810044,
	"./trar.mp3": 668974,
	"./trars.mp3": 295957,
	"./trash.mp3": 533585,
	"./travel.mp3": 911193,
	"./tray.mp3": 802217,
	"./tread.mp3": 769011,
	"./trear.mp3": 573429,
	"./treasure.mp3": 406666,
	"./treat.mp3": 842563,
	"./tree.mp3": 323641,
	"./trees.mp3": 507076,
	"./tremendous.mp3": 237931,
	"./trend.mp3": 582526,
	"./trene.mp3": 846467,
	"./tres.mp3": 649887,
	"./trial.mp3": 102775,
	"./triangle.mp3": 498377,
	"./triathlon.mp3": 614936,
	"./trick.mp3": 57766,
	"./tricycle.mp3": 943582,
	"./trident.mp3": 685379,
	"./tried.mp3": 593731,
	"./trier.mp3": 876965,
	"./tries.mp3": 826688,
	"./trine.mp3": 986215,
	"./trist.mp3": 309397,
	"./troas.mp3": 821662,
	"./trock.mp3": 472588,
	"./troe.mp3": 607663,
	"./trolley.mp3": 762528,
	"./trone.mp3": 633689,
	"./trop.mp3": 810934,
	"./trouble.mp3": 94594,
	"./trough.mp3": 773106,
	"./trousers.mp3": 899482,
	"./trow.mp3": 388557,
	"./truck.mp3": 163682,
	"./trudged.mp3": 377080,
	"./true.mp3": 382345,
	"./truly.mp3": 432665,
	"./trunk.mp3": 421837,
	"./truth.mp3": 832956,
	"./try.mp3": 887716,
	"./trying.mp3": 657132,
	"./tube.mp3": 230535,
	"./tubeless.mp3": 864340,
	"./tuck.mp3": 858,
	"./tucket.mp3": 259945,
	"./tud.mp3": 201052,
	"./tuesday.mp3": 129978,
	"./tuft.mp3": 732286,
	"./tug.mp3": 230803,
	"./tuil.mp3": 774923,
	"./tuin.mp3": 730073,
	"./tuke.mp3": 547220,
	"./tull.mp3": 787664,
	"./tum.mp3": 170249,
	"./tun.mp3": 923862,
	"./tune.mp3": 485899,
	"./tunnel.mp3": 649171,
	"./tunt.mp3": 444374,
	"./tup.mp3": 597616,
	"./tur.mp3": 133826,
	"./turbulent.mp3": 665414,
	"./turkair.mp3": 845879,
	"./turkar.mp3": 832872,
	"./turkay.mp3": 534551,
	"./turkey.mp3": 553155,
	"./turkoy.mp3": 309109,
	"./turn.mp3": 4872,
	"./tus.mp3": 715783,
	"./tuss.mp3": 101714,
	"./tut.mp3": 905324,
	"./tuww.mp3": 739178,
	"./tuxx.mp3": 447624,
	"./tuyy.mp3": 187690,
	"./tuzz.mp3": 656380,
	"./twas.mp3": 568782,
	"./twelfth.mp3": 24953,
	"./twelve.mp3": 780886,
	"./twenty.mp3": 743082,
	"./twice.mp3": 133723,
	"./twill.mp3": 264659,
	"./twirl.mp3": 732541,
	"./twist.mp3": 46454,
	"./two.mp3": 859109,
	"./type.mp3": 482069,
	"./typical.mp3": 987383,
	"./u -2.mp3": 973999,
	"./u -3.mp3": 748362,
	"./u .mp3": 552178,
	"./u-2.mp3": 195955,
	"./u-3.mp3": 669102,
	"./u.mp3": 848878,
	"./u2.mp3": 352752,
	"./uil.mp3": 654417,
	"./uit.mp3": 99561,
	"./unbelievable.mp3": 715483,
	"./unbelieveable.mp3": 108360,
	"./uncertain.mp3": 296018,
	"./unclear.mp3": 126295,
	"./uncoiled.mp3": 886406,
	"./unconscious.mp3": 435698,
	"./unconsciously.mp3": 505907,
	"./under.mp3": 907889,
	"./underneath.mp3": 503211,
	"./understandable.mp3": 490159,
	"./undeveloped.mp3": 438740,
	"./undo.mp3": 664107,
	"./unfair.mp3": 915542,
	"./unfamiliar.mp3": 262793,
	"./unfavourable.mp3": 239603,
	"./unfavourably.mp3": 491567,
	"./unfortunately.mp3": 331419,
	"./unhappy.mp3": 417390,
	"./unhealthy.mp3": 637223,
	"./unicorn.mp3": 508771,
	"./unicycle.mp3": 236713,
	"./unidentifiable.mp3": 709576,
	"./unidentified.mp3": 655087,
	"./uniform.mp3": 934619,
	"./unimaginable.mp3": 793583,
	"./unimaginative.mp3": 692542,
	"./unimportant.mp3": 936126,
	"./union.mp3": 607222,
	"./unique.mp3": 959704,
	"./unison.mp3": 304979,
	"./unit.mp3": 59015,
	"./universe.mp3": 244492,
	"./unkind.mp3": 984698,
	"./unknowing.mp3": 900623,
	"./unknowingly.mp3": 302102,
	"./unknown.mp3": 228101,
	"./unload.mp3": 594232,
	"./unlock.mp3": 379605,
	"./unlucky.mp3": 307500,
	"./unmoving.mp3": 303446,
	"./unnatural.mp3": 942555,
	"./unnaturally.mp3": 249450,
	"./unnecessarily.mp3": 18476,
	"./unnecessary.mp3": 959541,
	"./unpopular.mp3": 926999,
	"./unpopularity.mp3": 553705,
	"./unprepared.mp3": 797327,
	"./unpretentious.mp3": 841288,
	"./unprofessional.mp3": 382365,
	"./unprofessionally.mp3": 368100,
	"./unsocial.mp3": 745945,
	"./until.mp3": 81035,
	"./untrar.mp3": 654523,
	"./untrear.mp3": 166890,
	"./untrow.mp3": 508060,
	"./untrue.mp3": 652684,
	"./unusual.mp3": 80750,
	"./unwell.mp3": 336444,
	"./unzip.mp3": 240205,
	"./up.mp3": 377986,
	"./upstairs.mp3": 934000,
	"./ur -2.mp3": 527209,
	"./ur -3.mp3": 360196,
	"./ur .mp3": 475128,
	"./ur.mp3": 325424,
	"./ure -2.mp3": 217506,
	"./ure -3.mp3": 822439,
	"./ure .mp3": 799083,
	"./ure.mp3": 658937,
	"./urn.mp3": 68222,
	"./urt.mp3": 2436,
	"./us.mp3": 122517,
	"./use.mp3": 261430,
	"./used.mp3": 506310,
	"./using.mp3": 243395,
	"./usual.mp3": 192113,
	"./usually.mp3": 74208,
	"./ut.mp3": 515358,
	"./uthor.mp3": 347389,
	"./v -2.mp3": 673770,
	"./v -3.mp3": 635919,
	"./v.mp3": 274817,
	"./va.mp3": 967774,
	"./vacate.mp3": 512783,
	"./vacation.mp3": 331096,
	"./vacuum.mp3": 308552,
	"./vad.mp3": 829598,
	"./vag.mp3": 979057,
	"./vague.mp3": 347031,
	"./vai.mp3": 985743,
	"./vaid.mp3": 750313,
	"./vail.mp3": 585537,
	"./vain.mp3": 839475,
	"./vair.mp3": 575087,
	"./vait.mp3": 723449,
	"./val.mp3": 920486,
	"./valar.mp3": 34975,
	"./valay.mp3": 919360,
	"./valear.mp3": 667598,
	"./vallair.mp3": 89666,
	"./vallar.mp3": 966887,
	"./vallay.mp3": 395256,
	"./valley.mp3": 423420,
	"./vallow.mp3": 476696,
	"./valloy.mp3": 962974,
	"./valow.mp3": 938688,
	"./valt.mp3": 392486,
	"./valuable.mp3": 411915,
	"./value.mp3": 495936,
	"./van.mp3": 672116,
	"./vandalise.mp3": 47528,
	"./vard.mp3": 67236,
	"./variable.mp3": 43689,
	"./variation.mp3": 499976,
	"./varied.mp3": 417974,
	"./varies.mp3": 950173,
	"./varieties.mp3": 578499,
	"./variety.mp3": 272871,
	"./various.mp3": 298024,
	"./varying.mp3": 399171,
	"./vast.mp3": 30491,
	"./vat.mp3": 443982,
	"./vaul.mp3": 479061,
	"./vault.mp3": 884331,
	"./vaw.mp3": 47777,
	"./vax.mp3": 802970,
	"./vay.mp3": 511935,
	"./ve.mp3": 830402,
	"./vea.mp3": 805011,
	"./vear.mp3": 223931,
	"./veb.mp3": 444636,
	"./veck.mp3": 768724,
	"./vee.mp3": 392119,
	"./veeb.mp3": 124727,
	"./veed.mp3": 286369,
	"./veel.mp3": 603913,
	"./veen.mp3": 441595,
	"./veese.mp3": 401847,
	"./veet.mp3": 217649,
	"./veff.mp3": 746326,
	"./veg.mp3": 112645,
	"./vegetable.mp3": 791234,
	"./vehicle.mp3": 889740,
	"./veil.mp3": 555741,
	"./vein.mp3": 336623,
	"./velt.mp3": 40618,
	"./velvet.mp3": 256999,
	"./vem.mp3": 374719,
	"./ven.mp3": 455816,
	"./vent.mp3": 709452,
	"./vep.mp3": 819230,
	"./veracity.mp3": 706224,
	"./verb.mp3": 633534,
	"./verbal.mp3": 387993,
	"./verbose.mp3": 382013,
	"./verdict.mp3": 207404,
	"./verify.mp3": 531082,
	"./version.mp3": 792371,
	"./very.mp3": 39209,
	"./vess.mp3": 295692,
	"./vestle.mp3": 518186,
	"./vet.mp3": 681858,
	"./vexatious.mp3": 273385,
	"./vib.mp3": 157128,
	"./vibrant.mp3": 158049,
	"./vibration.mp3": 853505,
	"./vic.mp3": 802413,
	"./vich.mp3": 641807,
	"./vicious.mp3": 823677,
	"./vicked.mp3": 809239,
	"./victorious.mp3": 159764,
	"./vid.mp3": 173206,
	"./video.mp3": 584506,
	"./viel.mp3": 530461,
	"./viff.mp3": 796682,
	"./vig.mp3": 419593,
	"./vight.mp3": 815565,
	"./vigorous.mp3": 95069,
	"./vill.mp3": 782838,
	"./village.mp3": 111243,
	"./vim.mp3": 480147,
	"./vin.mp3": 450396,
	"./violinist.mp3": 735274,
	"./vip.mp3": 349610,
	"./viscount.mp3": 763318,
	"./vise.mp3": 894286,
	"./visible.mp3": 703321,
	"./visibly.mp3": 347397,
	"./vision.mp3": 770705,
	"./visit.mp3": 764586,
	"./visitors.mp3": 51760,
	"./viskers.mp3": 284604,
	"./vismer.mp3": 374595,
	"./visper.mp3": 804942,
	"./visualise.mp3": 249401,
	"./vit.mp3": 458406,
	"./voa.mp3": 869141,
	"./voad.mp3": 228827,
	"./voan.mp3": 742977,
	"./vob.mp3": 124610,
	"./voi.mp3": 524605,
	"./voice.mp3": 896009,
	"./volt.mp3": 339832,
	"./volume.mp3": 361707,
	"./voluntary.mp3": 347723,
	"./von.mp3": 895398,
	"./vood.mp3": 100901,
	"./voon.mp3": 872268,
	"./vor.mp3": 787826,
	"./vord.mp3": 808706,
	"./vose.mp3": 423516,
	"./voss.mp3": 356290,
	"./vow.mp3": 247763,
	"./vul.mp3": 235114,
	"./vun.mp3": 766744,
	"./vuse.mp3": 150178,
	"./vuss.mp3": 217404,
	"./w -2.mp3": 961445,
	"./w -3.mp3": 911168,
	"./w.mp3": 294396,
	"./wa.mp3": 351489,
	"./wack.mp3": 167787,
	"./wag.mp3": 280560,
	"./wai.mp3": 892006,
	"./waid.mp3": 588758,
	"./waik.mp3": 686981,
	"./wail.mp3": 397454,
	"./waip.mp3": 918186,
	"./wair.mp3": 296792,
	"./wait.mp3": 543334,
	"./wak.mp3": 643636,
	"./walk.mp3": 344658,
	"./walking.mp3": 75270,
	"./wall.mp3": 220033,
	"./wallet.mp3": 676226,
	"./walrus.mp3": 660075,
	"./wamp.mp3": 865270,
	"./wand.mp3": 506899,
	"./wander.mp3": 264498,
	"./want.mp3": 386211,
	"./wanted.mp3": 833148,
	"./wap.mp3": 913747,
	"./war.mp3": 19297,
	"./ward.mp3": 840935,
	"./warder.mp3": 259630,
	"./wardrobe.mp3": 116529,
	"./ware.mp3": 236002,
	"./warfare.mp3": 433293,
	"./warm.mp3": 437066,
	"./warplane.mp3": 465782,
	"./warship.mp3": 154115,
	"./wary.mp3": 865974,
	"./was.mp3": 883996,
	"./wash.mp3": 212324,
	"./washing.mp3": 719212,
	"./wasn't.mp3": 375187,
	"./wasn’t.mp3": 980189,
	"./wasp.mp3": 470444,
	"./wat.mp3": 374007,
	"./watch.mp3": 226598,
	"./water.mp3": 176606,
	"./wave.mp3": 683334,
	"./wax.mp3": 174523,
	"./way.mp3": 606806,
	"./we're.mp3": 236123,
	"./we.mp3": 266661,
	"./weak.mp3": 421137,
	"./wealth.mp3": 997686,
	"./wear.mp3": 640388,
	"./wearily.mp3": 69427,
	"./weary.mp3": 427361,
	"./weather.mp3": 444795,
	"./web.mp3": 53373,
	"./webra.mp3": 559098,
	"./weck.mp3": 650831,
	"./wedge.mp3": 434663,
	"./wednesday.mp3": 969235,
	"./wee.mp3": 424166,
	"./weeb.mp3": 59208,
	"./weed.mp3": 75286,
	"./week.mp3": 716037,
	"./weekend.mp3": 784832,
	"./weel.mp3": 883982,
	"./ween.mp3": 352476,
	"./weep.mp3": 251690,
	"./weff.mp3": 442109,
	"./weg.mp3": 633268,
	"./weigh.mp3": 171367,
	"./weight.mp3": 705889,
	"./weightless.mp3": 555150,
	"./weird.mp3": 345424,
	"./wek.mp3": 117168,
	"./weke.mp3": 695353,
	"./well.mp3": 725701,
	"./welt.mp3": 999357,
	"./wem.mp3": 307102,
	"./wen.mp3": 482737,
	"./went.mp3": 283175,
	"./wep.mp3": 862591,
	"./were.mp3": 145438,
	"./wes.mp3": 427336,
	"./wess.mp3": 696935,
	"./westle.mp3": 20273,
	"./wet.mp3": 11131,
	"./wh -2.mp3": 866669,
	"./wh -3.mp3": 221384,
	"./wh .mp3": 276020,
	"./wh.mp3": 832900,
	"./whack.mp3": 573107,
	"./whaft.mp3": 459555,
	"./whale.mp3": 645260,
	"./what.mp3": 55935,
	"./whate.mp3": 656212,
	"./whaw.mp3": 620680,
	"./wheat.mp3": 81010,
	"./wheb.mp3": 495173,
	"./wheck.mp3": 233591,
	"./wheeb.mp3": 514752,
	"./wheel.mp3": 689654,
	"./wheelchair.mp3": 555477,
	"./whelp.mp3": 381633,
	"./whem.mp3": 854422,
	"./when.mp3": 584457,
	"./where.mp3": 256566,
	"./whestle.mp3": 280505,
	"./whete.mp3": 315912,
	"./whether.mp3": 589132,
	"./whew.mp3": 835884,
	"./whey.mp3": 514474,
	"./which.mp3": 313028,
	"./whiff.mp3": 960025,
	"./while.mp3": 144244,
	"./whip.mp3": 704963,
	"./whirl.mp3": 959103,
	"./whisk.mp3": 33867,
	"./whiskers.mp3": 613513,
	"./whismer.mp3": 607888,
	"./whisper.mp3": 328269,
	"./whistle.mp3": 53829,
	"./white.mp3": 964140,
	"./whizz.mp3": 841281,
	"./who's.mp3": 93157,
	"./who.mp3": 389063,
	"./whole.mp3": 750794,
	"./wholly.mp3": 640520,
	"./whom.mp3": 749268,
	"./whoo.mp3": 840774,
	"./whose.mp3": 587751,
	"./whote.mp3": 125506,
	"./whow.mp3": 851758,
	"./why.mp3": 9633,
	"./wib.mp3": 391113,
	"./wich.mp3": 998412,
	"./wick.mp3": 452227,
	"./wicked.mp3": 100764,
	"./wid.mp3": 21375,
	"./wide.mp3": 739668,
	"./widening.mp3": 865446,
	"./width.mp3": 427283,
	"./wield.mp3": 458370,
	"./wife.mp3": 789534,
	"./wiff.mp3": 965169,
	"./wig.mp3": 128648,
	"./wiggle.mp3": 375318,
	"./wike.mp3": 133509,
	"./wild.mp3": 564961,
	"./will.mp3": 425033,
	"./willingness.mp3": 33666,
	"./wilt.mp3": 522417,
	"./wim.mp3": 17906,
	"./wimp.mp3": 286734,
	"./win.mp3": 785477,
	"./wind.mp3": 142571,
	"./windmill.mp3": 888621,
	"./window.mp3": 856829,
	"./wing.mp3": 595604,
	"./winter.mp3": 730746,
	"./wip.mp3": 186251,
	"./wipe.mp3": 252096,
	"./wire.mp3": 374378,
	"./wish.mp3": 406076,
	"./wishes.mp3": 679816,
	"./wiskers.mp3": 659649,
	"./wismer.mp3": 781720,
	"./wisper.mp3": 696069,
	"./wiss.mp3": 709483,
	"./wit.mp3": 495183,
	"./witch's.mp3": 578108,
	"./witch.mp3": 263534,
	"./with.mp3": 138981,
	"./wix.mp3": 330979,
	"./wiz.mp3": 488497,
	"./woad.mp3": 426412,
	"./woal.mp3": 481780,
	"./woan.mp3": 730150,
	"./woap.mp3": 440608,
	"./wob.mp3": 937935,
	"./wocket.mp3": 953970,
	"./wod.mp3": 584153,
	"./woe.mp3": 624308,
	"./woke.mp3": 253047,
	"./wol.mp3": 931249,
	"./wolt.mp3": 199719,
	"./woman's.mp3": 7731,
	"./woman.mp3": 540781,
	"./women's.mp3": 813247,
	"./women.mp3": 356001,
	"./women_s.mp3": 873511,
	"./won't.mp3": 450538,
	"./won.mp3": 773731,
	"./wonder.mp3": 476704,
	"./wonderful.mp3": 418461,
	"./wood.mp3": 648222,
	"./wool.mp3": 281638,
	"./woon.mp3": 490740,
	"./wop.mp3": 216685,
	"./word.mp3": 67961,
	"./wordy.mp3": 779118,
	"./wore.mp3": 12116,
	"./work.mp3": 492898,
	"./worker.mp3": 86887,
	"./workmanship.mp3": 899720,
	"./works.mp3": 694545,
	"./world.mp3": 51959,
	"./worm.mp3": 261196,
	"./worn.mp3": 715011,
	"./worries.mp3": 684292,
	"./worry.mp3": 168928,
	"./worse.mp3": 699103,
	"./worship.mp3": 769549,
	"./worst.mp3": 998858,
	"./worth.mp3": 394259,
	"./worthwhile.mp3": 202386,
	"./worthy.mp3": 257564,
	"./woss.mp3": 742553,
	"./wot.mp3": 833865,
	"./would.mp3": 141876,
	"./wound.mp3": 445074,
	"./woy.mp3": 99488,
	"./wrap.mp3": 81349,
	"./wreath.mp3": 441192,
	"./wreck.mp3": 46261,
	"./wren.mp3": 673239,
	"./wrench.mp3": 322886,
	"./wrestle.mp3": 236115,
	"./wrestling.mp3": 332858,
	"./wriggle.mp3": 597260,
	"./wrinkle.mp3": 644923,
	"./wrist.mp3": 319866,
	"./write.mp3": 166826,
	"./writer.mp3": 492932,
	"./written.mp3": 887602,
	"./wrong.mp3": 545252,
	"./wrote.mp3": 936820,
	"./wry.mp3": 668319,
	"./wub.mp3": 350509,
	"./wuck.mp3": 572383,
	"./wuke.mp3": 891785,
	"./wum.mp3": 529998,
	"./wump.mp3": 238690,
	"./wunt.mp3": 910423,
	"./x.mp3": 128479,
	"./xak.mp3": 541327,
	"./xap.mp3": 855904,
	"./xeb.mp3": 672694,
	"./xeck.mp3": 64934,
	"./xeff.mp3": 970408,
	"./xeg.mp3": 944031,
	"./xell.mp3": 545084,
	"./xem.mp3": 548069,
	"./xes.mp3": 566379,
	"./xet.mp3": 76024,
	"./xick.mp3": 411634,
	"./xiff.mp3": 888132,
	"./xim.mp3": 651217,
	"./xip.mp3": 554600,
	"./xub.mp3": 375558,
	"./xuck.mp3": 250518,
	"./xum.mp3": 743989,
	"./y -2.mp3": 476715,
	"./y -3.mp3": 21254,
	"./y.mp3": 184890,
	"./yacht.mp3": 1082,
	"./yad.mp3": 116885,
	"./yaid.mp3": 594536,
	"./yait.mp3": 110200,
	"./yak.mp3": 659494,
	"./yap.mp3": 727905,
	"./yar.mp3": 11859,
	"./yard.mp3": 825341,
	"./yart.mp3": 997613,
	"./yat.mp3": 803141,
	"./yawn.mp3": 77144,
	"./ye.mp3": 796319,
	"./year.mp3": 454002,
	"./yearly.mp3": 910451,
	"./yeb.mp3": 214159,
	"./yebra.mp3": 878024,
	"./yeck.mp3": 320529,
	"./yeeb.mp3": 350966,
	"./yeel.mp3": 506688,
	"./yeff.mp3": 941015,
	"./yeg.mp3": 148902,
	"./yell.mp3": 631967,
	"./yellow.mp3": 365409,
	"./yelp.mp3": 495299,
	"./yem.mp3": 845164,
	"./yen.mp3": 49955,
	"./yep.mp3": 492909,
	"./yes.mp3": 547738,
	"./yesterday.mp3": 893623,
	"./yestle.mp3": 140183,
	"./yet.mp3": 110089,
	"./yich.mp3": 192018,
	"./yick.mp3": 982565,
	"./yield.mp3": 403848,
	"./yiff.mp3": 740667,
	"./yim.mp3": 215952,
	"./yip.mp3": 67881,
	"./yiskers.mp3": 145639,
	"./yismer.mp3": 910357,
	"./yisper.mp3": 317759,
	"./yo.mp3": 247333,
	"./yoa.mp3": 591594,
	"./yoad.mp3": 448266,
	"./yoat.mp3": 204922,
	"./yoch.mp3": 686808,
	"./yog.mp3": 909492,
	"./yoga.mp3": 863849,
	"./yolp.mp3": 217497,
	"./yom.mp3": 583326,
	"./yon.mp3": 758961,
	"./yong.mp3": 269184,
	"./yor.mp3": 501869,
	"./you'll.mp3": 680377,
	"./you're.mp3": 363962,
	"./you've.mp3": 129758,
	"./you.mp3": 262166,
	"./young.mp3": 278375,
	"./youngster.mp3": 843415,
	"./your.mp3": 917192,
	"./youre.mp3": 198785,
	"./yourself.mp3": 945086,
	"./youth.mp3": 550146,
	"./youthful.mp3": 767303,
	"./yow.mp3": 926628,
	"./yub.mp3": 696063,
	"./yuck.mp3": 774625,
	"./yum.mp3": 765980,
	"./z -2.mp3": 807174,
	"./z .mp3": 310311,
	"./z.mp3": 918413,
	"./za.mp3": 347426,
	"./zach.mp3": 809099,
	"./zad-2.mp3": 668687,
	"./zad.mp3": 728978,
	"./zaddair.mp3": 340430,
	"./zaddar.mp3": 487323,
	"./zadder.mp3": 489511,
	"./zaddor.mp3": 679653,
	"./zag.mp3": 519525,
	"./zai.mp3": 606555,
	"./zaich.mp3": 159402,
	"./zaid.mp3": 1429,
	"./zaik.mp3": 27686,
	"./zail.mp3": 656893,
	"./zair.mp3": 380051,
	"./zait.mp3": 687685,
	"./zak.mp3": 769129,
	"./zake.mp3": 473178,
	"./zall.mp3": 603922,
	"./zane.mp3": 160033,
	"./zanoa.mp3": 107660,
	"./zanor.mp3": 4275,
	"./zanow.mp3": 570514,
	"./zanuhe.mp3": 71920,
	"./zanure.mp3": 405170,
	"./zar.mp3": 808652,
	"./zard.mp3": 790576,
	"./zark.mp3": 158347,
	"./zass.mp3": 645868,
	"./zat.mp3": 167202,
	"./zaw.mp3": 993333,
	"./ze.mp3": 331774,
	"./zear.mp3": 226359,
	"./zebra.mp3": 414203,
	"./zech.mp3": 773239,
	"./zee.mp3": 399683,
	"./zeech.mp3": 429922,
	"./zeed.mp3": 806925,
	"./zeel.mp3": 951653,
	"./zeen.mp3": 208151,
	"./zeet.mp3": 92125,
	"./zeff.mp3": 195138,
	"./zeg.mp3": 3729,
	"./zeke.mp3": 728430,
	"./zem.mp3": 701227,
	"./zen.mp3": 696788,
	"./zene.mp3": 635949,
	"./zero.mp3": 729267,
	"./zet.mp3": 799278,
	"./zick.mp3": 905964,
	"./zid.mp3": 735594,
	"./zie.mp3": 214095,
	"./zight.mp3": 380713,
	"./zike.mp3": 273490,
	"./zin.mp3": 537392,
	"./zine.mp3": 92153,
	"./zink.mp3": 122023,
	"./zip.mp3": 406166,
	"./zis.mp3": 805577,
	"./zit.mp3": 573850,
	"./zo.mp3": 197268,
	"./zoa.mp3": 362825,
	"./zoad.mp3": 116959,
	"./zoak.mp3": 309052,
	"./zoal.mp3": 308119,
	"./zoan.mp3": 51621,
	"./zoat.mp3": 642351,
	"./zoi.mp3": 986401,
	"./zoil.mp3": 104431,
	"./zoke.mp3": 665624,
	"./zol.mp3": 85920,
	"./zone.mp3": 877063,
	"./zoo.mp3": 341111,
	"./zood.mp3": 528865,
	"./zool.mp3": 362761,
	"./zoon.mp3": 200443,
	"./zoot.mp3": 460145,
	"./zor.mp3": 401638,
	"./zord.mp3": 199638,
	"./zorn.mp3": 476828,
	"./zort.mp3": 484838,
	"./zot.mp3": 155096,
	"./zow.mp3": 771343,
	"./zowl.mp3": 830913,
	"./zrill.mp3": 46450,
	"./zud.mp3": 889998,
	"./zug.mp3": 977441,
	"./zuil.mp3": 443409,
	"./zuke.mp3": 186334,
	"./zum.mp3": 132667,
	"./zump.mp3": 506113,
	"./zz.mp3": 555021
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 895807;